import React from "react";

export const lang = [
  {
    user_key: "profile_fname",
    kurdish: "ناوی یەکەم",
    arabic: "الاسم الأول",
    english: "First Name",
  },
  {
    user_key: "All properties",
    kurdish: "هەموو موڵکەکان",
    arabic: "جميع العقارات",
    english: "All properties",
  },
  {
    user_key: "s_login",
    kurdish: "چوونەژوورەوە",
    arabic: "تسجيل الدخول",
    english: "Login",
  },
  {
    user_key: "The gas station",
    kurdish: "بەنزینخانە",
    arabic: "محطة الوقود.",
    english: "The gas station.",
  },
  {
    user_key: "Strecture",
    kurdish: "هەیکەل",
    arabic: "هیکل",
    english: "Strecture",
  },
  {
    user_key: "Factory",
    kurdish: "کارگە",
    arabic: "مصنع",
    english: "Factory.",
  },
  {
    user_key: "GYM",
    kurdish: "هۆڵی لەشجوانی",
    arabic: "قاعة كمال الاجسام",
    english: "GYM.",
  },
  {
    user_key: "store",
    kurdish: "کۆگا",
    arabic: "مخزن",
    english: "store.",
  },
  {
    user_key: "Car wash",
    kurdish: "شووشتنگەی ئۆتۆمبێل",
    arabic: "غسيل السيارات",
    english: "Car wash",
  },
  {
    user_key: "Restaurant",
    kurdish: "چێشتخانە",
    arabic: "مطعم",
    english: "Restaurant.",
  },
  {
    user_key: "subject",
    kurdish: "بابەت",
    arabic: "موضوع",
    english: "subject",
  },
  //
  {
    user_key: "Building",
    kurdish: "باڵەخانە",
    arabic: "بناء",
    english: "Building",
  },
  {
    user_key: "Agitator",
    kurdish: "ئارایشتگە",
    arabic: "صالۆن",
    english: "Agitator",
  },
  {
    user_key: "residential community",
    kurdish: "کۆمەلگەی نیشتەجێبوون",
    arabic: "مجتمع سكني",
    english: "residential community",
  },
  {
    user_key: "agricultural land of the register",
    kurdish: "زەوی کشتوکاڵی تاپۆ",
    arabic: "الأراضي الزراعية للسجل",
    english: "agricultural land of the register",
  },
  {
    user_key: "unregistered agricultural land",
    kurdish: "زەوی کشتوکاڵی  بێ تاپۆ",
    arabic: "الأراضي الزراعية غير المسجلة",
    english: "unregistered agricultural land",
  },
  {
    user_key: "Government agricultural land",
    kurdish: "زەوی کشتوکاڵی حکومەت",
    arabic: "الأراضي الزراعية الحكومية",
    english: "Government agricultural land",
  },
  {
    user_key: "Land of Istamar",
    kurdish: "زەوی استسمار",
    arabic: "ارض استسمار",
    english: "Land of Istamar",
  },
  {
    user_key: "Erth Musataha",
    kurdish: "زەوی مساتەحە",
    arabic: "ارض مساتەحە",
    english: "Erth Musataha",
  },
  {
    user_key: "school",
    kurdish: "قوتابخانە",
    arabic: "مدرسة",
    english: "school",
  },
  {
    user_key: "Building of Istamar",
    kurdish: "بالەخانە استسمار",
    arabic: "بناء استسمار",
    english: "Building of Istamar",
  },
  {
    user_key: "Building of Musataha",
    kurdish: "بالەخانەی مساتحە",
    arabic: "بناء مساتحە",
    english: "Building of Musataha",
  },
  {
    user_key: "Profit Report",
    kurdish: "ڕاپۆرتی قازانج",
    arabic: "تقرير الربح",
    english: "Profit Report",
  },
  {
    user_key: "Project Bill List",
    kurdish: "لیستی پسوولەی پڕۆژە",
    arabic: "قائمة فاتورة مشروع",
    english: "Project Bill List",
  },
  {
    user_key: "To write",
    kurdish: "نووسراو",
    arabic: "الكتابة",
    english: "writing",
  },
  {
    user_key: "List of Scripts",
    kurdish: "لیستی نووسراوەکان",
    arabic: "قائمة البرامج النصية",
    english: "List of Scripts",
  },
  {
    user_key: "Commission",
    kurdish: "عمولە",
    arabic: "عمولة",
    english: "Commission",
  },
  {
    user_key: "phone_number",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "profile_lname",
    kurdish: "ناوی دووەم",
    arabic: "الاسم الثاني",
    english: "Last Name",
  },
  {
    user_key: "addproperty",
    kurdish: "زیادکردنی موڵك",
    arabic: "طلب عقار",
    english: "Add Property",
  },
  {
    user_key: "add_Required_property",
    kurdish: "زیادکردنی داواکاری موڵك",
    arabic: "إضافة العقارات المطلوبة",
    english: "Add Required Property",
  },
  {
    user_key: "add_Required",
    kurdish: "داواکاری موڵك",
    arabic: "طلب عقار",
    english: "Add Required",
  },
  {
    user_key: "Required",
    kurdish: "طلبیة",
    arabic: "طلب عقار",
    english: "Required",
  },
  {
    user_key: "update_property_sell",
    kurdish: "دەستکاری کردنی موڵکی فرۆشتن",
    arabic: "تعديل",
    english: "Update Sell Property ",
  },
  {
    user_key: "update_property_rent",
    kurdish: "دەستکاری کردنی موڵکی کرێ",
    arabic: "تعديل عقارات الإيجار",
    english: "Update Rent Property",
  },
  {
    user_key: "profile_gender",
    kurdish: "ڕەگەز",
    arabic: "الجنس",
    english: "Gender",
  },
  {
    user_key: "profile_mob",
    kurdish: "مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "invoice_mob",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "Contract Organizer",
    kurdish: "ڕێکخەری گرێبەست",
    arabic: "منظم العقد",
    english: "Contract Organizer",
  },
  {
    user_key: "List of Tenants",
    kurdish: "لیستی کرێچیەکان",
    arabic: "قائمة المستأجرين",
    english: "List of Tenants",
  },
  {
    user_key: "information",
    kurdish: "زانیاری",
    arabic: "معلومات",
    english: "Information",
  },
  {
    user_key: "profile_location",
    kurdish: "شوێن",
    arabic: "الموقع",
    english: "Location",
  },
  {
    user_key: "Account Details",
    kurdish: "زانیاری کەسی",
    arabic: "معلومات شخصية",
    english: "Personal information",
  },
  {
    user_key: "active",
    kurdish: "چاڵاك",
    arabic: "متاح",
    english: "Active",
  },
  {
    user_key: "deactive",
    kurdish: "ناچاڵاك",
    arabic: "غير متاح",
    english: "DeActive",
  },
  {
    user_key: "rented",
    kurdish: "بەکرێدراو",
    arabic: "مؤجر",
    english: "rented",
  },
  {
    user_key: "sold",
    kurdish: "فرۆشراو",
    arabic: "مباع",
    english: "sold",
  },
  {
    user_key: "suspend",
    kurdish: "ڕاگیراو",
    arabic: "معلق",
    english: "Suspend",
  },
  {
    user_key: "Housing",
    kurdish: "نیشتەجێبوون",
    arabic: "سکنیة",
    english: "Housing",
  },
  {
    user_key: "office",
    kurdish: "ئۆفیس",
    arabic: "مكتب",
    english: "office",
  },
  {
    user_key: "profile_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "Logged_in_Yet",
    kurdish: "ئایە داخل بووە",
    arabic: "تم تسجيل الدخول من قبل",
    english: "Logged in Yet",
  },
  {
    user_key: "Agents",
    kurdish: "وەکیل",
    arabic: "الوكيل",
    english: "Agents",
  },
  {
    user_key: "hold",
    kurdish: "گرتراوە",
    arabic: "حجز",
    english: "Hold",
  },
  {
    user_key: "Agent_",
    kurdish: "کارمەند",
    arabic: "موظف",
    english: "Agent",
  },
  {
    user_key: "agent",
    kurdish: "کارمەند",
    arabic: "موظف",
    english: "agent",
  },
  {
    user_key: "Manager_",
    kurdish: "بەڕێوبەر",
    arabic: "مدير",
    english: "Manager",
  },
  {
    user_key: "manager",
    kurdish: "بەڕێوبەر",
    arabic: "مدير",
    english: "manager",
  },
  {
    user_key: "Agent_name",
    kurdish: "ناوی وەکیل",
    arabic: "اسم الوكيل",
    english: "Agent Name",
  },
  {
    user_key: "Agents_List",
    kurdish: "لیستی وەکیلەکان",
    arabic: "قائمة الوكلاء",
    english: "Agents List",
  },
  {
    user_key: "Update Profile",
    kurdish: "دەستکاری لاپەڕەی کەسی",
    arabic: "تعديل الملف الشخصي",
    english: "Update Profile",
  },
  {
    user_key: "Update Image",
    kurdish: "گۆڕینی وێنە",
    arabic: " تحديث الصورة",
    english: "Update Image",
  },
  {
    user_key: "Create Agent",
    kurdish: "دروستکردنی وەکیل",
    arabic: "إضافة وكيل",
    english: "Create Agent",
  },
  {
    user_key: "Create",
    kurdish: "دروستکردن",
    arabic: "إضافة",
    english: "Create",
  },
  {
    user_key: "Branches",
    kurdish: "لقەکان",
    arabic: " الفروع",
    english: "Branches",
  },
  {
    user_key: "Account",
    kurdish: "زانیاری کەسی",
    arabic: "معلومات شخصية",
    english: "Account Information",
  },
  {
    user_key: "Name of Branch",
    kurdish: "ناوی لق",
    arabic: " اسم الفرع",
    english: "Name of Branch",
  },
  {
    user_key: "Create Branch",
    kurdish: "دروستکردنی لق",
    arabic: " إضافة فرع",
    english: "Create Branch",
  },
  {
    user_key: "Branch",
    kurdish: "لق",
    arabic: "فرع",
    english: "Branch",
  },
  {
    user_key: "List Branches",
    kurdish: "لیستی لقەکان",
    arabic: "قائمة الفروع",
    english: "List Branches",
  },
  {
    user_key: "save",
    kurdish: "خەزن کردن",
    arabic: "حفظ",
    english: "Save",
  },
  {
    user_key: "password_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "password",
    kurdish: "وشەی نهێنی ",
    arabic: "كلمة المرور ",
    english: "Password",
  },
  {
    user_key: "password_change",
    kurdish: "نویکردنەوەی پاسوورد",
    arabic: "تغيير كلمة المرور",
    english: "Change Password",
  },
  {
    user_key: "id",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "ID",
  },
  {
    user_key: "id_branch",
    kurdish: "ژمارەی لق",
    arabic: "معرف الفرع",
    english: "Branch ID",
  },
  {
    user_key: "id_branch_agent",
    kurdish: "وەکیل ID",
    arabic: "معرف الوكيل",
    english: "Agent ID",
  },
  {
    user_key: "Search",
    kurdish: "گەڕان",
    arabic: "بحث",
    english: "Search",
  },
  {
    user_key: "Old_Password",
    kurdish: "وشەی نهێنی کۆن",
    arabic: "كلمة المرور القديمة",
    english: "Old Password",
  },
  {
    user_key: "New_Password",
    kurdish: "وشەی نهێنی نوێ",
    arabic: "كلمة المرور الجديدة",
    english: "New Password",
  },
  {
    user_key: "new_page",
    kurdish: "پەڕەی نوێ",
    arabic: "صفحة جديدة",
    english: "New Page",
  },
  // Dashboard
  {
    user_key: "d_earnings",
    kurdish: "قازانج",
    arabic: "فوائد",
    english: "Benefits",
  },
  {
    user_key: "d_products",
    kurdish: "کالایەکان",
    arabic: "منتجات",
    english: "Products",
  },
  {
    user_key: "d_totalorders",
    kurdish: "داواکاریەکان",
    arabic: "إجمالي الطلبات",
    english: "Total orders",
  },
  {
    user_key: "d_lorders",
    kurdish: "نوێترین داواکاریەکان",
    arabic: "أحدث الطلبات",
    english: "Latest Orders",
  },
  {
    user_key: "d_orderid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Order Id",
  },
  {
    user_key: "d_payment",
    kurdish: "جۆری پارەدان",
    arabic: "طريقة الدفع",
    english: "Payment Method",
  },
  {
    user_key: "d_status",
    kurdish: "بار",
    arabic: "الحالة",
    english: "Status",
  },
  {
    user_key: "d_total",
    kurdish: "کۆی گشتی",
    arabic: "المجموع",
    english: "Total",
  },
  {
    user_key: "Buy",
    kurdish: "کڕین",
    arabic: "بيع",
    english: "Buy",
  },
  {
    user_key: "d_viewall",
    kurdish: "بینینی هەمووی",
    arabic: "عرض الجميع",
    english: "View All",
  },
  {
    user_key: "All Permision",
    kurdish: "هەموو دەسەڵاتەکان",
    arabic: "الجميع دورات",
    english: "All Permision",
  },
  {
    user_key: "d_view",
    kurdish: "بینین",
    arabic: "عرض",
    english: "View",
  },
  {
    user_key: "d_totalsales",
    kurdish: "کۆی فرۆشتنەکان",
    arabic: "إجمالي المبيعات",
    english: "Total Sales",
  },
  {
    user_key: "d_totalqazanj",
    kurdish: "کۆی گشتیی قازانج",
    arabic: "إجمالي الفوائد",
    english: "Total Benefits",
  },
  {
    user_key: "d_saleslm",
    kurdish: "فرۆشتنەکانی مانگی پێشوو",
    arabic: "مبيعات الشهر الماضي",
    english: "Last Month Sales",
  },
  {
    user_key: "d_purchasem",
    kurdish: "قازانجی مانگی پێشوو",
    arabic: "مشتريات الشهر الماضي",
    english: "Last Month Purchases",
  },
  {
    user_key: "d_productrate",
    kurdish: "هەلسەنگادنی کالاکان",
    arabic: "تقييم المنتج",
    english: "Product Rate",
  },
  {
    user_key: "d_productratelevel",
    kurdish: "ئاست",
    arabic: "مستوى",
    english: "Level",
  },
  {
    user_key: "d_productname",
    kurdish: "ناو",
    arabic: "اسم",
    english: "Name",
  },
  {
    user_key: "d_productid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Product id",
  },
  {
    user_key: "Number",
    kurdish: "ژمارە",
    arabic: "الرقم",
    english: "Number",
  },
  // product list
  {
    user_key: "pr_productid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "ID",
  },
  {
    user_key: "pr_image",
    kurdish: "وێنە",
    arabic: "صورة",
    english: "Image",
  },
  {
    user_key: "pr_name",
    kurdish: "ناو",
    arabic: "اسم",
    english: "Name",
  },
  {
    user_key: "pr_size",
    kurdish: "قەبارە",
    arabic: "قیاس",
    english: "Size",
  },
  {
    user_key: "pr_quantity",
    kurdish: "دانە",
    arabic: "عدد",
    english: "Quantity",
  },
  {
    user_key: "s_kryar",
    kurdish: "ناوی کڕیار",
    arabic: "مشتري",
    english: "name",
  },
  {
    user_key: "Project Type",
    kurdish: "جۆری پڕۆژە",
    arabic: "نوع المشروع",
    english: "Project Type",
  },
  {
    user_key: "pr_price",
    kurdish: "نرخ",
    arabic: "سعر",
    english: "Price",
  },
  {
    user_key: "pr_color",
    kurdish: "ڕەنگ",
    arabic: "اللون",
    english: "Color",
  },
  {
    user_key: "pr_productlist",
    kurdish: "لیستی کاڵاکان",
    arabic: "قائمة المنتجات",
    english: "Product List",
  },
  {
    user_key: "next",
    kurdish: "دواتر",
    arabic: "التالي",
    english: "Next",
  },
  {
    user_key: "previous",
    kurdish: "پێشتر",
    arabic: "السابق",
    english: "Previous",
  },
  {
    user_key: "date",
    kurdish: "بەروار",
    arabic: "تاريخ",
    english: "Date",
  },
  {
    user_key: "manageorder",
    kurdish: "ڕێکخستنی داواکاریەکان",
    arabic: "إدارة الطلبات",
    english: "Manage Orders",
  },
  {
    user_key: "pr_action",
    kurdish: "دەستکاری",
    arabic: "تعديل",
    english: "Edit",
  },
  {
    user_key: "tr_amount",
    kurdish: "بڕی پارە",
    arabic: "المبلغ",
    english: "Amount",
  },
  {
    user_key: "transactionid",
    kurdish: "ژمارەی پارەدان",
    arabic: "رقم المعاملة",
    english: "Transaction_ID",
  },
  {
    user_key: "transaction",
    kurdish: "پارەدانەکان",
    arabic: "المعاملات المالية",
    english: "Transaction details",
  },
  {
    user_key: "in_no",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "No",
  },
  {
    user_key: "in_invoice",
    kurdish: "ژمارەی پسولە",
    arabic: "رقم وصل",
    english: "Invoice No",
  },
  {
    user_key: "in_shipping",
    kurdish: "نرخی گواستنەوە",
    arabic: "سعر توصيل",
    english: "Shipping",
  },
  {
    user_key: "s_dashboard",
    kurdish: "داشبۆرد",
    arabic: "الصفحة الرئيسية",
    english: "Dashboard",
  },
  {
    user_key: "accept_orders",
    kurdish: "پەسەندکردنی داواکاریەکان",
    arabic: "قبول الطلبات",
    english: "Accept Orders",
  },
  {
    user_key: "s_products",
    kurdish: "کاڵایەکان",
    arabic: "منتجات",
    english: "Products",
  },
  {
    user_key: "transfer_orders",
    kurdish: "گواستنەوەی داواکاریەکان",
    arabic: "أوامر التحويل",
    english: "Transfer_Orders",
  },
  {
    user_key: "sending_orders",
    kurdish: "ناردنی داواکاریەکان",
    arabic: "إرسال الطلبات",
    english: "Sending Orders",
  },
  {
    user_key: "Sent",
    kurdish: "ناردنی ئەرك",
    arabic: "ارسال",
    english: "Sent",
  },
  {
    user_key: "order_from",
    kurdish: "داواکاری لە",
    arabic: "طلب من",
    english: "Order From",
  },
  {
    user_key: "from",
    kurdish: "لە",
    arabic: "من",
    english: "From",
  },
  {
    user_key: "Repayment bills",
    kurdish: "پسوولەی پارەوەرگرتن",
    arabic: "فواتير الاستلام",
    english: "Repayment bills",
  },
  {
    user_key: "Monthly fee receipts",
    kurdish: "کرێی مانگانە",
    arabic: "الرسوم الشهرية",
    english: "Monthly fee receipts",
  },
  {
    user_key: "Insurance Bill",
    kurdish: "دڵنیایی",
    arabic: "التأمين",
    english: "Insurance Bill",
  },
  {
    user_key: "to",
    kurdish: "بۆ",
    arabic: "الی",
    english: "To",
  },
  {
    user_key: "order_to",
    kurdish: "داواکاری بۆ",
    arabic: "طلب الی",
    english: "Order To",
  },
  {
    user_key: "s_transactions",
    kurdish: "پارەدانەکان",
    arabic: "المعاملات",
    english: "Transactions",
  },
  {
    user_key: "action",
    kurdish: "چاڵاکی",
    arabic: "فعل",
    english: "Action",
  },
  {
    user_key: "s_reports",
    kurdish: "راپۆرتەکان",
    arabic: "التقارير",
    english: "Reports",
  },
  {
    user_key: "s_pending",
    kurdish: "داواکاریە نوێیەکان",
    arabic: "أوامر معلقة",
    english: "Pending orders",
  },
  {
    user_key: "s_settings",
    kurdish: "رێکخستنەکان",
    arabic: "إعدادات",
    english: "Settings",
  },
  {
    user_key: "s_profile",
    kurdish: "لاپەرەی کەسی",
    arabic: "الملف الشخصي ",
    english: "Profile",
  },
  {
    user_key: "s_invoice",
    kurdish: "پسولە",
    arabic: "وصلات",
    english: "Invoice",
  },
  {
    user_key: "s_logout",
    kurdish: "چونەدەرەوە",
    arabic: "تسجيل خروج",
    english: "Logout",
  },
  {
    user_key: "inprogress",
    kurdish: "لە جێبەجێکردندایە",
    arabic: "في تقدم",
    english: "Inprogress",
  },
  {
    user_key: "phisical",
    kurdish: "کالای ناو دوکان",
    arabic: "منتج مادي",
    english: "Phisical",
  },
  {
    user_key: "incompany",
    kurdish: "لە کۆمپانیا",
    arabic: "فى الشركه",
    english: "In_company",
  },
  {
    user_key: "Print",
    kurdish: "چاپکردن",
    arabic: "طبع",
    english: "Print",
  },
  {
    user_key: "Second Party (Buyer)",
    kurdish: "لایەنی دووەم (کڕیار)",
    arabic: "الطرف الثاني (المشتري) ",
    english: "Second Party (Buyer)",
  },
  {
    user_key: "Buyer",
    kurdish: "کڕیار",
    arabic: "المشتري",
    english: "Buyer",
  },
  {
    user_key: "this",
    kurdish: "ئەم",
    arabic: "هذا",
    english: "this",
  },
  {
    user_key: "to",
    kurdish: "تا",
    arabic: "ل",
    english: "to",
  },
  {
    user_key: "Money-out name",
    kurdish: "ناوی پارە دەر",
    arabic: "اسم المال",
    english: "Money-out name",
  },
  {
    user_key: "First side (property owner)",
    kurdish: "لایەنی یەکەم (خاوەنی موڵك)",
    arabic: "الجانب الأول (مالك العقار)",
    english: "First side (property owner)",
  },
  {
    user_key: "property owner",
    kurdish: "خاوەنی موڵك",
    arabic: "مالك العقار",
    english: "property owner",
  },
  {
    user_key: "Second Side",
    kurdish: "لایەنی دووەم",
    arabic: "الطرف الثاني",
    english: "Second Party",
  },
  {
    user_key: "Second side (tenant)",
    kurdish: "لایەنی دووەم (کرێچی)",
    arabic: "الجانب الثاني (المستأجر)",
    english: "Second side (tenant)",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "دفعات شهرية",
    english: "payment term",
  },
  {
    user_key: "start date",
    kurdish: "بەرواری دەستپێکردن",
    arabic: "تاريخ البدء",
    english: "start date",
  },
  {
    user_key: "end date",
    kurdish: "بەرواری کۆتایی",
    arabic: "تاريخ الانتهاء",
    english: "end date",
  },
  {
    user_key: "and by the amount",
    kurdish: "وە بە بڕی",
    arabic: " و أستلم مبلغ",
    english: "and by the amount",
  },
  //
  {
    user_key: "as an introduction",
    kurdish: "وەکو پێشەکی",
    arabic: "كمقدمة",
    english: "as an introduction",
  },
  {
    user_key: "I'm the second side of this",
    kurdish: "من لایەنی دووەم ئەم",
    arabic: "أني الطرف الثاني إستأجرت ھذا",
    english: "Iam second party I rent this",
  },
  {
    user_key: "I've hired him on the first side for a while",
    kurdish: "م بەکرێ گرتووە لە لایەنی یەکەم بۆ ماوەی",
    arabic: "من الطرف الاول لمدة ",
    english: "I've hired him on the first side for a while",
  },
  {
    user_key: "and I'm doing it for purposes",
    kurdish: "وە بەکاری دێنم بۆ مەبەستی",
    arabic: "وأنا أفعل ذلك لأغراض",
    english: "and I use it for",
  },
  {
    user_key: "Rent_agreement",
    kurdish: "من لایەنی دووەم پابەندم بە پێدانی کرێیەکە",
    arabic: " أني الطرف الثاني ألتزم بتسديد الايجار الشھري كل",
    english: "Iam second party I obliged to pay the rent",
  },
  {
    user_key: "once a preludant",
    kurdish: "مانگ جارێک پێشەکی",
    arabic: "كمقدمة",
    english: "once a preludant",
  },
  {
    user_key: "For every day",
    kurdish: "بۆ هەر ڕۆژێک دواکەوتن",
    arabic: "الى الطرف الاول لكل يوم تأخير",
    english: "for everyday delaying.",
  },
  {
    user_key: "Balance of Assurance",
    kurdish: "باڵانسی دڵنیایی",
    arabic: "ميزان الضمان",
    english: "Balance of Assurance",
  },
  {
    user_key: "Witness",
    kurdish: "شاهێد",
    arabic: "شاهد",
    english: "Witness",
  },
  {
    user_key: "Brikar",
    kurdish: "ناوی بریکار",
    arabic: "اسم الوكيل",
    english: "Brikar",
  },
  {
    user_key: "month",
    kurdish: "مانگ",
    arabic: " شهر",
    english: "month",
  },
  {
    user_key: "to give it to the first side without any shortcomings",
    kurdish: "ە رادەستی لایەنی یەکەم بکات بەبێ هیچ کەم و کوڕیەک",
    arabic: "الى الطرف الاول دون اي نواقص.",
    english: "surrender without any shortage.",
  },
  {
    user_key: "The second party is committed to paying the amount",
    kurdish: " لایەنی دووەم پابەندە بە پێدانی بڕی",
    arabic: " يلتزم الطرف الثاني بدفع المبلغ",
    english: " The second party is committed to paying the amount",
  },
  {
    user_key: "such as assurances",
    kurdish: "وەکو دڵنیایی(تآمینات)",
    arabic: "مثل الضمانات",
    english: "such as assurances",
  },
  {
    user_key: "money",
    kurdish: "بڕی پارە",
    arabic: "مبلغ من المال",
    english: "money",
  },
  {
    user_key: "Lease date",
    kurdish: "ڕێکەوتی بەکرێدان",
    arabic: "تاريخ التأجير",
    english: "Lease date",
  },
  {
    user_key: "end of the lease",
    kurdish: "ڕێکەوتی کۆتایی کرێ",
    arabic: "تاريخ انتهاء عقد الإيجار",
    english: "end of the lease",
  },
  {
    user_key: "Payer Signature",
    kurdish: "ئیمزای پارەدەر",
    arabic: "توقيع دافع",
    english: "Payer Signature",
  },
  {
    user_key: "Instead of",
    kurdish: "لە بری",
    arabic: "بدلاً من",
    english: "Instead of",
  },
  {
    user_key: "nine_rent",
    kurdish:
      "لایەنی دووەم بۆی نیە بە هیچ شێوەیەک ئەم موڵکە بەکرێ بداتەوە بە لایەنێکی تر.",
    arabic: "لايحق للطرف الثاني بأى شكل من الاشكال بتأجير الملك الى طرف أخر.",
    english:
      "The second party doesn`t have to rent this property to another side in anyway.",
  },
  {
    user_key: "ten_rent",
    kurdish:
      "ناکرێت واز لەم ڕێکەوتننامەیە بهێنرێت (یاخود دەستی لێهەڵبگیرێت) لە بەشێک یان هەموو بەشەکانی ئەم گرێبەستە بۆ کرێدارێکی تر یاخود هەر کەسێکی تر بەبێ ڕەزامەندی خاوەنەکەی.",
    arabic:
      "لا يمكن للجانب الآخر إجراء أي تغييرات داخل وخارج هذه الخاصية دون موافقة مالك العقار",
    english:
      "The other side cannot make any changes inside and outside this property without the consent of the owner of the property",
  },
  {
    user_key: "eleven_rent",
    kurdish:
      "لایەنی دووەم ناتوانێ داوای گەڕانەوەی کرێ بکات دوای واژوو کردنی گرێبەست بەهیچ شێوەیەک ، تا دوبارە بە کرێدانەوەی بە کەسێکی تر ئەو ماوەیەی کە پێویستە بۆ بە کرێدانەوەی دەکەوێتە ئەستۆی لایەنی دووەم",
    arabic:
      " لا يمكن للطرف الثاني طلب إعادة الإيجار بعد توقيع العقد على الإطلاق، حتى يكون الطرف الثاني مسؤولا عن إعادة تأجيره لشخص آخر",
    english:
      " The second party cannot ask for the return of the rent after signing the contract at all, until the second party is responsible for re-renting it to someone else",
  },
  {
    user_key: "by the company",
    kurdish: " بە کۆمپانیای",
    arabic: "من قبل الشركة",
    english: "by the company",
  },
  {
    user_key: "twelve_rent",
    kurdish:
      "لەسەر لایەنی دووەم پێویستە خاوەن موڵک یان عقارات زەنگین ئاگادار بکاتەوە مانگێک پێش دەرچوون یان کۆتایی هاتنی گرێبەستەکە بە پێچەوانەوە دەبێت کرێی یەک مانگ بدات بە لایەتی یەکەم.",
    arabic:
      "على الطرف الثاني تبليغ الطرف الاول او عقارات زەنگین قبل شھر من الاخلاء أو انتھاء مدةالعقد و بعكسه يجب دفع ايجار شھر الى الطرف الاول.",
    english:
      "The second party must warn the property owner or Zangin Real Estate Company a month before leaving.",
  },
  {
    user_key: "agreement",
    kurdish: "هەردوو لایەن رێککەوتن لەسەر ئەم خاڵانەی خوارەوە",
    arabic: "إتفق الطرفان على ما يلي",
    english: "Both parties agreed on these terms",
  },
  {
    user_key: "sale and purchase contract",
    kurdish: "گرێبەستی کڕین و فرۆشتن",
    arabic: " عقد الشراء",
    english: "Buy and Sale Contract",
  },
  {
    user_key: "Payer Signature",
    kurdish: "ئیمزای پارەدەر",
    arabic: "توقيع دافع",
    english: "Payer Signature",
  },
  {
    user_key: "Recipient's signature seal",
    kurdish: "مۆرو ئیمزای وەرگر",
    arabic: "ختم توقيع المستلم",
    english: "Recipient's signature",
  },
  {
    user_key: "dolar",
    kurdish: "دۆلار",
    arabic: "دولار",
    english: "dolar",
  },
  {
    user_key: "dinar",
    kurdish: "دینار",
    arabic: "دینار",
    english: "dinar",
  },
  {
    user_key: "Currency Type",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "Currency Type",
  },
  {
    user_key: "Rental contract",
    kurdish: "گرێبەستی کرێ",
    arabic: "عقد الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "Project Report",
    kurdish: "ڕاپۆرتی پرۆژە",
    arabic: "تقرير المشروع",
    english: "Project Report",
  },
  {
    user_key: "Branch Report",
    kurdish: "ڕاپۆرتی لق",
    arabic: "تقرير الفرع",
    english: "Branch Report",
  },
  {
    user_key: "Agent Report",
    kurdish: "ڕاپۆرتی بریکار",
    arabic: "تقرير الوكيل",
    english: "Agent Report",
  },
  {
    user_key: "Rental contract_",
    kurdish: "گرێبەستی کرێیەکان",
    arabic: "عقد الإيجار",
    english: "Rental Contracts",
  },
  {
    user_key: "Show",
    kurdish: "پیشاندان",
    arabic: "عرض",
    english: "Show",
  },
  {
    user_key: "note",
    kurdish: "تێبینی //",
    arabic: "ملاحظة //",
    english: "Note //",
  },
  {
    user_key: "Added",
    kurdish: "زیادکرا",
    arabic: "مضاف",
    english: "Added",
  },
  {
    user_key: "note_",
    kurdish: "تێبینی",
    arabic: "ملاحظة",
    english: "Note",
  },
  {
    user_key: "invoice_mob",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "Contract Organizer",
    kurdish: "ڕێکخەری گرێبەست",
    arabic: "منظم العقد",
    english: "Contract Organizer",
  },
  {
    user_key: "contract number",
    kurdish: "ژمارەی گرێبەست",
    arabic: "رقم العقد",
    english: "contract number",
  },
  {
    user_key: "Number",
    kurdish: "ژمارە",
    arabic: "الرقم",
    english: "Number",
  },
  {
    user_key: "Warn him",
    kurdish:
      "ئاگادار باکاتەوە بەپێچەوانەوە دەبێت کرێی یەک مانگ بدات بە لایەنی یەکەم",
    arabic: "حذره",
    english: "Warn him",
  },
  {
    user_key: "therteen_rent",
    kurdish: "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ کۆمپانیای ",
    arabic: "يلتزم كل طرف بدفع رسوم نصف شهر للشركة",
    english: "Each party is committed to paying the company a half-month fee",
  },
  {
    user_key: "therteen_rent_two",
    kurdish: "لەبەرامبەر ڕێکخستنی ئەم گرێبەستە",
    arabic: "مقابل ترتيب هذا العقد",
    english: "In return for arranging this contract",
  },
  {
    user_key: "First side (property owner)",
    kurdish: "لایەنی یەکەم (خاوەن)",
    arabic: "الجانب الأول (مالك العقار)",
    english: "First side (owner)",
  },
  {
    user_key: "Second side (tenant)",
    kurdish: "لایەنی دووەم (کرێچی)",
    arabic: "الجانب الثاني (المستأجر)",
    english: "Second side (tenant)",
  },
  {
    user_key: "Rent Contracts",
    kurdish: "لیستی گرێبەستە کرێیەکان",
    arabic: "قائمة عقود الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "Sell Contracts",
    kurdish: "لیستی گرێبەستی فرۆشتوو",
    arabic: "قائمة العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Contract List",
    kurdish: "لیستی گرێبەستەکان",
    arabic: "قائمة العقود",
    english: "Contract List",
  },
  {
    user_key: "Rent Contracts",
    kurdish: "لیستی گرێبەستە کرێیەکان",
    arabic: "قائمة عقود الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "First Party (Seller)",
    kurdish: "لایەنی یەکەم (فرۆشیار)",
    arabic: "الطرف الاول (البائع) ",
    english: "First Party (Seller)",
  },
  {
    user_key: "R_digital",
    kurdish: "راپۆرتی ناو وێبسایت",
    arabic: "مسع",
    english: "Digital",
  },
  {
    user_key: "R_phisical",
    kurdish: "راپۆرتی ناو دوکان",
    arabic: "مسع",
    english: "Phisical",
  },
  {
    user_key: "R_reports",
    kurdish: "هەموو راپۆرتەکان",
    arabic: "مسع",
    english: "All reports",
  },
  {
    user_key: "Men",
    kurdish: "پیاوان",
    arabic: "رجال",
    english: "Men",
  },
  {
    user_key: "Women",
    kurdish: "ئافرەتان",
    arabic: "نساء",
    english: "Women",
  },
  {
    user_key: "Kids",
    kurdish: "منداڵان",
    arabic: "أطفال",
    english: "Kids",
  },
  {
    user_key: "Accessories",
    kurdish: "جوانکاری",
    arabic: "جمالیات",
    english: "Accessories",
  },
  {
    user_key: "T-Shirts",
    kurdish: "تیشێرت",
    arabic: "قمصان",
    english: "T-Shirts",
  },
  {
    user_key: "Shirts",
    kurdish: "شێرت",
    arabic: "قمیص",
    english: "Shirts",
  },
  {
    user_key: "Joggers",
    kurdish: "کابۆ",
    arabic: "کابۆ",
    english: "Joggers",
  },
  {
    user_key: "Shorts",
    kurdish: "شۆرت",
    arabic: "السراويل القصيرة",
    english: "Shorts",
  },
  {
    user_key: "Shoes",
    kurdish: "پێلاو",
    arabic: "أحذية",
    english: "Shoes",
  },
  {
    user_key: "Sunglasses",
    kurdish: "چاویلکە",
    arabic: "نظارة شمسيه",
    english: "Sunglasses",
  },
  {
    user_key: "Sportswear",
    kurdish: "جلی وەرزشی",
    arabic: "ملابس رياضية",
    english: "Sportswear",
  },
  {
    user_key: "Watches",
    kurdish: "کاتژمێری دەستی",
    arabic: "ساعات",
    english: "Watches",
  },
  {
    user_key: "Jeans",
    kurdish: "کابؤ",
    arabic: "جينز",
    english: "Jeans",
  },
  {
    user_key: "Dresses",
    kurdish: "کراس",
    arabic: "فساتين",
    english: "Dresses",
  },
  {
    user_key: "Skirts",
    kurdish: "تەنورۆ",
    arabic: "تنورة",
    english: "Skirts",
  },
  {
    user_key: "Trousers",
    kurdish: "تراکسوت",
    arabic: "تراکسوت",
    english: "Trousers",
  },
  {
    user_key: "Jackets",
    kurdish: "چاکەت",
    arabic: "جاكيتات",
    english: "Jackets",
  },
  {
    user_key: "Rings",
    kurdish: "ئانگوستیلە",
    arabic: "خواتم",
    english: "Rings",
  },
  {
    user_key: "Earrings",
    kurdish: "گوارە",
    arabic: "حلق الاذن",
    english: "Earrings",
  },
  {
    user_key: "Necklaces",
    kurdish: "ملوانکە",
    arabic: "قلادات",
    english: "Necklaces",
  },
  {
    user_key: "Bracelets",
    kurdish: "دەستبەند",
    arabic: "أساور",
    english: "Bracelets",
  },
  {
    user_key: "Jewellry",
    kurdish: "خشل",
    arabic: "مجوهرات",
    english: "Jewellry",
  },
  {
    user_key: "Belts",
    kurdish: "پشتێن",
    arabic: "أحزمة",
    english: "Belts",
  },
  {
    user_key: "ToDo List",
    kurdish: "لیستی ئەرکەکان",
    arabic: "عمل قائمة",
    english: "Todo List",
  },
  {
    user_key: "ToDo",
    kurdish: "ئەرکەکەت",
    arabic: "لكى يفعل",
    english: "ToDo",
  },
  {
    user_key: "Send Todo to Agent",
    kurdish: "ناردنی ئەرك بۆ وەکیلەکان",
    arabic: "إرسال Todo",
    english: "Send Todo",
  },
  {
    user_key: "Agent_name",
    kurdish: "ناوی وەکیل",
    arabic: "اسم العميل",
    english: "Agent Name",
  },
  {
    user_key: "Property List",
    kurdish: "لیستی موڵکەکان",
    arabic: "قائمة عقارات ",
    english: "Property List",
  },
  {
    user_key: "Sell List",
    kurdish: "لیستی فرۆشتنەکان",
    arabic: "قائمة عقارات ",
    english: "Sell List",
  },
  {
    user_key: "Rent List",
    kurdish: "لیستی کرێیەکان",
    arabic: "قائمة عقارات ",
    english: "Rent List",
  },
  {
    user_key: "View_Property",
    kurdish: "بینینی موڵك",
    arabic: "عرض الممتلكات ",
    english: "View Property",
  },
  {
    user_key: "d_view",
    kurdish: "بینین",
    arabic: "مشاهدة",
    english: "View",
  },
  {
    user_key: "Close",
    kurdish: "داخستن",
    arabic: "يغلق",
    english: "Close",
  },
  {
    user_key: "Add",
    kurdish: "زیادکردن",
    arabic: "إضافة",
    english: "Add",
  },
  {
    user_key: "Type of property",
    kurdish: "جۆری موڵك",
    arabic: "نوع العقار",
    english: "Type of property",
  },
  {
    user_key: "Area",
    kurdish: "ڕووبەر",
    arabic: "المساحة",
    english: "Area",
  },
  {
    user_key: "Owner Name",
    kurdish: "ناوی خاوەن موڵك",
    arabic: "اسم المالك",
    english: "Owner Name",
  },
  {
    user_key: "Sell Property List",
    kurdish: "لیستی فرۆشتنی موڵکەکان",
    arabic: " قائمة عقارات لبيع",
    english: "Sell Property List",
  },
  {
    user_key: "Sell",
    kurdish: "فرۆشتن",
    arabic: "بيع",
    english: "Sell",
  },
  {
    user_key: "Sell Contract",
    kurdish: "گرێبەستی فرۆشتن",
    arabic: "العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Rent",
    kurdish: "کرێ",
    arabic: "إيجار",
    english: "Rent",
  },

  {
    user_key: "property_just",
    kurdish: "موڵك",
    arabic: "العقار",
    english: "Property",
  },
  {
    user_key: "add_product",
    kurdish: "زیادکردنی کاڵا",
    arabic: "أضف منتج",
    english: "Add Product",
  },
  {
    user_key: "add_system",
    kurdish: "شوێنی کالا",
    arabic: "مكان المنتج",
    english: "System",
  },
  {
    user_key: "add_category",
    kurdish: "بەش",
    arabic: "الفئة",
    english: "Category",
  },
  {
    user_key: "add_scategory",
    kurdish: "جۆری کاڵا",
    arabic: "نوع المنتج",
    english: "Sub-Category",
  },
  {
    user_key: "add_pname",
    kurdish: "ناوی کاڵا",
    arabic: "اسم المنتج",
    english: "Product Name",
  },
  {
    user_key: "add_pcode",
    kurdish: "کۆدی کاڵا",
    arabic: "كود المنتج",
    english: "Product Code",
  },
  {
    user_key: "add_size",
    kurdish: "قەباری کاڵا",
    arabic: "حجم المنتج",
    english: "Product Size",
  },
  {
    user_key: "add_qu",
    kurdish: "ژمارەی کاڵا",
    arabic: "كمية المنتج",
    english: "Total Products",
  },
  {
    user_key: "add_desc",
    kurdish: "دەربارەی کاڵا",
    arabic: "وصف المنتج",
    english: "Description",
  },
  {
    user_key: "Apartment",
    kurdish: "شوقە",
    arabic: "شقة",
    english: "Apartment",
  },
  {
    user_key: "House",
    kurdish: "خانوو",
    arabic: "منزل",
    english: "House",
  },
  {
    user_key: "Farm",
    kurdish: "باخ",
    arabic: "مزرعة",
    english: "Farm",
  },
  {
    user_key: "Shop",
    kurdish: "دوکان",
    arabic: "متجر",
    english: "Shop",
  },
  {
    user_key: "Vella",
    kurdish: "ڤێلا",
    arabic: "فيلا",
    english: "Vella",
  },
  {
    user_key: "active",
    kurdish: "چاڵاك",
    arabic: "نشيط",
    english: "Active",
  },
  {
    user_key: "deactive",
    kurdish: "ناچاڵاك",
    arabic: "تعطيل",
    english: "DeActive",
  },
  {
    user_key: "Owner Detail",
    kurdish: "زانیاری خاوەن موڵك",
    arabic: "تفاصيل المالك",
    english: "Owner Detail",
  },
  {
    user_key: "Buyer_Detail",
    kurdish: "زانیاری کەسی کڕیار",
    arabic: "تفاصيل المشتري",
    english: "Buyer Detail",
  },
  {
    user_key: "Description",
    kurdish: "دەربارەی موڵك",
    arabic: "الوصف",
    english: "Description",
  },
  {
    user_key: "add_button",
    kurdish: "زیادکردنی کاڵا",
    arabic: "أضف المنتج",
    english: "Add Product",
  },
  {
    user_key: "add_buttoncl",
    kurdish: "رەشکردنەوە",
    arabic: "إعادة تعيين",
    english: "Clear",
  },
  {
    user_key: "add_price",
    kurdish: "نرخی کاڵا",
    arabic: "سعر تعيين",
    english: "Price",
  },
  {
    user_key: "Company Branch",
    kurdish: "لقی کۆمپانیا",
    arabic: "فرع الشركة",
    english: "Branch",
  },
  {
    user_key: "Choose",
    kurdish: "هەلبژێرە",
    arabic: "أختر",
    english: "Choose",
  },
  {
    user_key: "add_physical",
    kurdish: "ناو دوکان",
    arabic: "منتج مادي",
    english: "Physical",
  },
  {
    user_key: "add_digital",
    kurdish: "ناو وێبسایت",
    arabic: "منتج المتجر",
    english: "Digital",
  },
  {
    user_key: "discount",
    kurdish: "داشکان",
    arabic: "خصم",
    english: "Discount",
  },
  {
    user_key: "sell",
    kurdish: "فرۆشتن",
    arabic: "بيع",
    english: "Sell",
  },
  {
    user_key: "cancel",
    kurdish: "پاشگەزبوون",
    arabic: "إلغاء",
    english: "Sell",
  },
  {
    user_key: "back",
    kurdish: "گەڕانەوە",
    arabic: "عودة",
    english: "Back",
  },
  {
    user_key: "accept",
    kurdish: "پەسەندکردن",
    arabic: "قبول",
    english: "Accept",
  },
  // colors
  {
    user_key: "White",
    kurdish: "سپی",
    arabic: "أبيض",
    english: "White",
  },
  {
    user_key: "Black",
    kurdish: "ڕەش",
    arabic: "أسود",
    english: "Black",
  },
  {
    user_key: "Red",
    kurdish: "سوور",
    arabic: "أحمر",
    english: "Red",
  },
  {
    user_key: "Green",
    kurdish: "سەوز",
    arabic: "أخضر",
    english: "Green",
  },
  {
    user_key: "Gray",
    kurdish: "ڕەساسی",
    arabic: "الرمادي",
    english: "Gray",
  },
  {
    user_key: "DarkBlue",
    kurdish: "نیلی",
    arabic: "أزرق غامق",
    english: "DarkBlue",
  },
  {
    user_key: "Brown",
    kurdish: "قاوەیی",
    arabic: "بنى",
    english: "Brown",
  },
  {
    user_key: "Purple",
    kurdish: "مۆر",
    arabic: "أرجواني",
    english: "Purple",
  },
  {
    user_key: "Orange",
    kurdish: "پرتەقالی",
    arabic: "البرتقالي",
    english: "Orange",
  },
  {
    user_key: "Pink",
    kurdish: "پەمەیی",
    arabic: "زهري",
    english: "Pink",
  },
  {
    user_key: "Yellow",
    kurdish: "زەرد",
    arabic: "الأصفر",
    english: "Yellow",
  },
  {
    user_key: "Darkgreen",
    kurdish: "سەوزی تۆخ",
    arabic: "أخضر غامق",
    english: "Darkgreen",
  },
  /**
   * new Sgent
   */
  {
    user_key: "cardNo",
    kurdish: "ژمارەی کارت",
    arabic: "رقم البطاقة",
    english: "CardNo",
  },
  {
    user_key: "Agent Contract",
    kurdish: "گرێبەستی بریکار",
    arabic: "عقد الوكيل",
    english: "Agent Contract",
  },
  {
    user_key: "passportNo",
    kurdish: "ژمارەی پاسپۆرت",
    arabic: "رقم جواز السفر",
    english: "PassportNo",
  },
  {
    user_key: "first_rule_price",
    kurdish:
      "من لایەنی یەکەم خاوەنی موڵک ڕازیم بە فرۆشتنی ئەم موڵکەی لە خوارەوە ئاماژەی پێکراوە بە نرخی",
    arabic:
      "اني الطرف الأول (مالك العقار) اقر بانني قد بعت ھذا العقار المدون أدناه بمبلغ قدره",
    english:
      "As an owner to the estate, I agree to sell the estate as detailed below for on amount of",
  },
  {
    user_key: "first_rule_Property_type",
    kurdish: "جۆری موڵک",
    arabic: "نوع العقار",
    english: "estate type",
  },
  {
    user_key: "type",
    kurdish: "جۆر",
    arabic: "نوع",
    english: "type",
  },
  {
    user_key: "second_rule_price",
    kurdish:
      "من لایەنی دووەم ڕازیم بە کڕینی ئەو موڵکەی لە سەرەوە ئاماژەی پێکراوە بە نرخی",
    arabic:
      "اني الطرف الثاني اقره بانني قد اشتريت ھذا العقار المدون أعلاه بمبلغ قدره",
    english:
      " I am (as a second party) agreed to buy this estate as mentioned above for on amount of",
  },
  {
    user_key: "third_rule_price",
    kurdish: "لایەنی یەکەم بڕی ",
    arabic: "استلم الطرف الاول مبلغ",
    english: "The first party has taken amount of",
  },
  {
    user_key: "third_rule_introduction",
    kurdish: "وەرگرت وەک پێشەکی، وە بڕی پارە ماوە ",
    arabic: "كمقدمة، و المبلغ المتبقي",
    english: "in advance, and the rest of money will be ",
  },
  {
    user_key: "and the rest of money  will be",
    kurdish: " وە بڕی پارە ماوە ",
    arabic: " و المبلغ المتبقي",
    english: "and the rest of money  will be ",
  },
  {
    user_key: "forth_rule_date",
    kurdish:
      "لایەنی یەکەم پێویستە ئەم موڵکە ڕادەستی لایەنی دووەم بکات تا ڕێکەوتی ",
    arabic: "على الطرف الاول التسليم العقار الى الطرف الثاني بتاريخ",
    english:
      "The first party needs to give the estate to the second party until",
  },
  {
    user_key: "fifth_rule_price",
    kurdish:
      "ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاریکراودا ئەم مووڵکە ڕادەستی لایەنی دووەم نەکرد ئەوا دەبێت پابەندبێت بە پێدانی بڕی",
    arabic:
      "اذا تأخر تسليم العقار الى الطرف الثاني، يتحمل الطرف الاول غرامة يومية بمبلغ",
    english:
      "If the first party couldn’t give the estate to the second party at the defined time above, the first party must pay about",
  },
  {
    user_key: "rented",
    kurdish: "بەکرێدراو",
    arabic: "مستأجرة",
    english: "rented",
  },
  {
    user_key: "Unsold",
    kurdish: "نەفرۆشراو",
    arabic: "غير المباعة",
    english: "Unsold",
  },
  {
    user_key: "Booking",
    kurdish: "حجزکردن",
    arabic: "الحجز",
    english: "Booking",
  },
  {
    user_key: "sold",
    kurdish: "فرۆشراو",
    arabic: "مباع",
    english: "sold",
  },
  {
    user_key: "seven_rule",
    kurdish:
      "ڕسوماتیی فرۆشتن و گواستنەوە و جیاکردنەوە و یەکخستن و ڕادەستکردنەوە و باجی خانووبەرە لەسەر لایەنی یەکەمە کە بیدات بە پێی یاسا ئەگەر تاپۆ بوو، وە ئەگەر تاپۆ نەبوو لایەنی یەکەم و دووەم پابەندن بە پێدانی پارەی بەناو کردن. ",
    arabic:
      "يتحمل الطرف الاول تسديد مبالغ رسوم البيع و النقل و التوحيد و التصحيح و ضريبة العقار و كل ما عليه حسب القانون.",
    english:
      "Fees of buying, transportation, differentiation, coordination, amendment, and estate fees should be paid by the first party if the property was officially registered. Whereas, if it is not registered, then the seller and buyer are responsible for registering it.",
  },
  {
    user_key: "eight_rule",
    kurdish:
      "ڕسوماتی کەشف و تۆماری عەقاری دەکەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵکەکە تاپۆ بوو، وە ئەگەر تاپۆ نەبوو ئەوا لایەنی یەکەم و دووەم پابەندن بە پێدانی بڕی پارەی بەناوکردن ",
    arabic:
      "اما دفع رسومات الكشف و التسجيل العقار المذكور في مديرية التسجيل العقاري فيكون من مسؤولية الطرف الثاني بموجب القانون فيها اذا كان العقار مسجلا في مديرية التسجيل العقاري, اما اذا لم يوجد سند عقاري (طابو) فعلى الطرفين ان يتفقا على دفع رسومات التسجيل مشاركة.",
    english:
      "As for paying the fees for detection and registration of the property mentioned in the Real Estate Registration Directorate, it is the responsibility of the second party under the law therein if the real estate is registered in the Real Estate Registration Directorate, but if there is no real estate title (Tabu), the two parties must agree to pay the registration fees jointly.",
  },
  {
    user_key: "ten_rule_two",
    kurdish: " ئەوەش لە بەرامبەر نێوەندگیریی رێکخستنی ئەم گرێبەستە",
    arabic: " و ذلك مقابل التوسط في ایجار الملك",
    english: "in return for mediating in the Rent of the property",
  },

  {
    user_key: "ten_rule_thirs",
    kurdish: " نرخی تێچووی خانووەکەی سەرەوە بداتە کۆمپانیای",
    arabic: "  من سعر كلفة الدار اعلاه الى شركة ",
    english: "of the cost price of the house above to",
  },
  {
    user_key: "ten_rule_four",
    kurdish: "کە دەکاتە",
    arabic: "وهو ما تفعله.",
    english: "which it does",
  },
  {
    user_key: "nine_rule_two",
    kurdish:
      ".بە بریکارنامەی تایبەت بەم موڵکە لە فەرمانگەی دادنووس بە مەبەستی ڕایی کردنی مامەڵەکان و بەناوکردنی لە بەڕێوەبەرایەتی تۆماری خانووبەرە بۆ لایەنی دووەم",
    arabic:
      "وكالة خاصة عند الكاتب العدل بالعقار المذكور الاجراء المعاملات و تسجيله بدائرة التسجيل العقاري للطرف الثاني.",
    english:
      "to complete propertied process to the second party in property registration directorate.",
  },
  {
    user_key: "nine_rule_one",
    kurdish: "لەسەر لایەنی یەکەم پێویستە دەسەڵات بدات بە پارێزەر ",
    arabic: "على الطرف الاول توكيل محامي",
    english: "The first party should authorize a solicitor",
  },
  {
    user_key: "Most contract company",
    kurdish: "ڕێکخەری گرێبەست",
    arabic: "معظم العقد شركة",
    english: "Most contract company",
  },
  {
    user_key: "Contract",
    kurdish: "گرێبەست",
    arabic: "العقد",
    english: "Contract",
  },
  {
    user_key: "one tenant's bill",
    kurdish: "پسوولەی یەک کرێچی",
    arabic: "فاتورة مستأجر واحد",
    english: "One Tenant's Bill",
  },
  {
    user_key: "received from Mr",
    kurdish: "وەرگیرا لە بەڕێز",
    arabic: "وردت من السيد",
    english: "received from Mr",
  },
  {
    user_key: "one tenant's contract",
    kurdish: "گرێبەستی یەک کرێچی",
    arabic: "عقد مستأجر واحد",
    english: "One Tenant's Contract",
  },
  {
    user_key: "taking money",
    kurdish: "پارەوەرگرتن",
    arabic: "أخذ المال.",
    english: "taking money",
  },
  {
    user_key: "list taking money",
    kurdish: "لیستی پارەوەرگرتن",
    arabic: "قائمة أخذ المال",
    english: "List of taking money",
  },
  {
    user_key: "tenants",
    kurdish: "کرێچیەکان",
    arabic: "المستأجرين",
    english: "Tenants",
  },
  {
    user_key: "List of Tenants",
    kurdish: "لیستی کرێچیەکان",
    arabic: "قائمة المستأجرين",
    english: "List of Tenants",
  },
  {
    user_key: "lawyer",
    kurdish: "پارێزەر",
    arabic: "محامي",
    english: "lawyer",
  },
  {
    user_key: "six_rule_one",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێک بە هەر هۆیەک پاشگەزبێتەوە لەم گرێبەستە دەبێت پابەند بێت بە پێدانی ",
    arabic: "اذا تنكل احد الطرفين عن العقد المبرم، على المتنكل دفع الغرامة",
    english: "If any of them regret to commit to the contract, the amount of",
  },
  {
    user_key: "six_rule_two",
    kurdish:
      "وەک پێبژاردن (غرامة) بە لایەنەکەی تر بەبێ ئاگادارکردنەوەی لایەنی فەرمی.",
    arabic: "للطرف الاخر بدون تبليغ رسمي",
    english:
      "must be paid as a penalty by one who will withdraw from the contract to another one without notifying interested party.",
  },
  // raports
  {
    user_key: "start_d",
    kurdish: "بەرواری سەرەتا",
    arabic: "تاريخ البدء ",
    english: "Start Date",
  },
  {
    user_key: "end_d",
    kurdish: "بەرواری کۆتا",
    arabic: "تاريخ الانتهاء ",
    english: "End Date",
  },
  {
    user_key: "search_d",
    kurdish: "گەڕان بە پێی ڕۆژ",
    arabic: "البحث باليوم",
    english: "Search By Date",
  },
  {
    user_key: "weekly_report",
    kurdish: "ڕاپۆرتی هەفتانە",
    arabic: "تقرير أسبوعي",
    english: "Weekly Report",
  },
  {
    user_key: "s_reports",
    kurdish: "راپۆرتەکان",
    arabic: "التقارير",
    english: "Reports",
  },
  {
    user_key: "search_m",
    kurdish: "گەڕان بە پێی مانگ",
    arabic: "البحث بالشهر",
    english: "Search By Month",
  },
  {
    user_key: "search_y",
    kurdish: "گەڕان بە پێی ساڵ",
    arabic: "البحث بالسنة",
    english: "Search By Year",
  },
  {
    user_key: "Rent Property List",
    kurdish: "لیستی بەکرێدانی موڵکەکان",
    arabic: "قائمة عقارات الإيجار",
    english: "Rent Property List",
  },
  {
    user_key: "Completion rental contract",
    kurdish: "تەواوبونی گرێبەستی کرێ",
    arabic: "إتمام عقد الإيجار",
    english: "Completion rental",
  },
  {
    user_key: "Percentage",
    kurdish: "ڕێژەی سەدی",
    arabic: "نسبه",
    english: "Percentage",
  },
  {
    user_key: "View Project",
    kurdish: "پیشاندانی پرۆژە",
    arabic: "عرض المشروع",
    english: "View Project",
  },
  {
    user_key: "Profit_s",
    kurdish: "قازانجی سافی دۆلار",
    arabic: "ربح صافي دولار",
    english: "Profit Dollar",
  },
  {
    user_key: "Salary",
    kurdish: "مووچە",
    arabic: "راتب",
    english: "Salary",
  },
  {
    user_key: "Monthly Salary",
    kurdish: "مووچەی مانگی",
    arabic: "الراتب الشهري",
    english: "Monthly Salary",
  },
  {
    user_key: "Premiums Entry",
    kurdish: "داخیلکردنی قیستەکان",
    arabic: "إدخال الأقساط",
    english: "Premiums Entry",
  },
  {
    user_key: "Accounting",
    kurdish: "ژمێریاری",
    arabic: "الحسابات",
    english: "Accounting",
  },
  {
    user_key: "Accounting Report",
    kurdish: "ڕاپۆرتی ژمێریاری",
    arabic: "الحسابات",
    english: "Accounting Report",
  },
  {
    user_key: "List Salary",
    kurdish: "لیستی مووچە",
    arabic: "قائمة الرواتب",
    english: "List Salary",
  },
  /// masrufat
  {
    user_key: "Expenses",
    kurdish: "خەرجیەکان",
    arabic: "مصروفات",
    english: "Expenses",
  },
  {
    user_key: "Create Cost",
    kurdish: "دروستکردنی خەرجی",
    arabic: "إنشاء النفقات",
    english: "Create Cost",
  },
  {
    user_key: "Cost type",
    kurdish: "جۆری خەرجی",
    arabic: "نوع التكلفة",
    english: "Cost type",
  },
  {
    user_key: "Total money.",
    kurdish: "کۆی پارە",
    arabic: "مجموع المال.",
    english: "Total money.",
  },
  {
    user_key: "Total money $",
    kurdish: "$ کۆی پارە بە",
    arabic: "$ مجموع المال",
    english: "Total money $",
  },
  {
    user_key: "Total money ID",
    kurdish: "ID کۆی پارە بە",
    arabic: "ID مجموع المال",
    english: "Total money ID",
  },
  {
    user_key: "Expenses List",
    kurdish: "لیستی خەرجییەکان",
    arabic: "قائمة المصروفات",
    english: "Expenses List",
  },
  {
    user_key: "Amount of money",
    kurdish: "بڕی پارە",
    arabic: "مبلغ من المال",
    english: "Amount of money",
  },
  {
    user_key: "Profit",
    kurdish: "قازانج",
    arabic: "ربح",
    english: "Profit",
  },
  {
    user_key: "",
    kurdish: "",
    arabic: "",
    english: "",
  },
  {
    user_key: "",
    kurdish: "",
    arabic: "",
    english: "",
  },
  {
    user_key: "",
    kurdish: "",
    arabic: "",
    english: "",
  },
  {
    user_key: "",
    kurdish: "",
    arabic: "",
    english: "",
  },
  {
    user_key: "profile_fname",
    kurdish: "ناوی یەکەم",
    arabic: ".قوائم المستخدمين",
    english: "First Name",
  },
  {
    user_key: "profile_lname",
    kurdish: "ناوی دووەم",
    arabic: "اسم المستخدم الأول",
    english: "Last Name",
  },
  {
    user_key: "pr_productlist",
    kurdish: "لیستی کاڵاکان",
    arabic: "قائمة المنتجات",
    english: "Product List",
  },
  {
    user_key: "profile_email",
    kurdish: "ئیمێل",
    arabic: "اسم المستخدم الأخير",
    english: "Email",
  },
  {
    user_key: "digital",
    kurdish: "کالای ناو وێبسایت",
    arabic: "منتج المتجر",
    english: "Digital",
  },
  {
    user_key: "phisical",
    kurdish: "کالای ناو دوکان",
    arabic: "منتج مادي",
    english: "Phisical",
  },
  {
    user_key: "addproperty",
    kurdish: "زیادکردنی موڵك",
    arabic: "أضف العقار",
    english: "Add Property",
  },

  {
    user_key: "add_Required_property",
    kurdish: "زیادکردنی داواکاری موڵك",
    arabic: "إضافة خاصية مطلوبة",
    english: "Add Required Property",
  },

  {
    user_key: "update_property_sell",
    kurdish: "دەستکاری کردنی موڵکی فرۆشتن",
    arabic: "تحديث بيع الممتلكات",
    english: "Update Sell Property ",
  },
  {
    user_key: "update_property_rent",
    kurdish: "دەستکاری کردنی موڵکی کرێ",
    arabic: "تحديث إيجار عقار",
    english: "Update Rent Property",
  },
  {
    user_key: "update Contracts",
    kurdish: "دەستکاری کردنی گرێبەستەکان",
    arabic: "تحديث عقد",
    english: "Update Contracts ",
  },
  {
    user_key: "update_bills",
    kurdish: "دەستکاری کردنی پسوولەکان",
    arabic: "تحديث وصولات",
    english: "Update Bills",
  },
  {
    user_key: "profile_gender",
    kurdish: "ڕەگەز",
    arabic: "دخول المستخدم",
    english: "Gender",
  },
  {
    user_key: "profile_mob",
    kurdish: "مۆبایل",
    arabic: "أضف المنتج",
    english: "Mobile Number",
  },
  {
    user_key: "invoice_mob",
    kurdish: "ژمارەی مۆبایل",
    arabic: "رقم الهاتف",
    english: "Mobile Number",
  },
  {
    user_key: "Contract Organizer",
    kurdish: "ڕێکخەری گرێبەست",
    arabic: "منظم العقد",
    english: "Contract Organizer",
  },
  {
    user_key: "List of Tenants",
    kurdish: "لیستی کرێچیەکان",
    arabic: "قائمة المستأجرين",
    english: "List of Tenants",
  },
  {
    user_key: "profile_dob",
    kurdish: "بەرواری لەدایکبوون",
    arabic: "تاريخ الولادة",
    english: "DOB",
  },
  {
    user_key: "information",
    kurdish: "زانیاری",
    arabic: "معلومة",
    english: "Information",
  },
  {
    user_key: "profile_location",
    kurdish: "شوێن",
    arabic: "مكان",
    english: "Location",
  },
  {
    user_key: "Account Details",
    kurdish: "زانیاری کەسی",
    arabic: "تفاصيل الحساب",
    english: "Account Details",
  },
  {
    user_key: "active",
    kurdish: "چاڵاك",
    arabic: "نشيط",
    english: "Active",
  },
  {
    user_key: "deactive",
    kurdish: "ناچاڵاك",
    arabic: "تعطيل",
    english: "DeActive",
  },
  {
    user_key: "rented",
    kurdish: "بەکرێدراو",
    arabic: "مستأجرة",
    english: "rented",
  },
  {
    user_key: "sold",
    kurdish: "فرۆشراو",
    arabic: "مباع",
    english: "sold",
  },
  {
    user_key: "suspend",
    kurdish: "ڕاگیراو",
    arabic: "تعليق",
    english: "Suspend",
  },
  {
    user_key: "profile_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "Logged_in_Yet",
    kurdish: "ئایە داخل بووە",
    arabic: "تم تسجيل الدخول بعد",
    english: "Logged in Yet",
  },
  {
    user_key: "weight",
    kurdish: "کێش",
    arabic: "وزن",
    english: "weight",
  },
  {
    user_key: "Agents",
    kurdish: "وەکیل",
    arabic: "الوكيل",
    english: "Agents",
  },
  {
    user_key: "Agent_name",
    kurdish: "ناوی وەکیل",
    arabic: "اسم العميل",
    english: "Agent Name",
  },
  {
    user_key: "Rent Contracts",
    kurdish: "لیستی گرێبەستە کرێیەکان",
    arabic: "قائمة عقود الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "Sell Contracts",
    kurdish: "لیستی گرێبەستی فرۆشتوو",
    arabic: "قائمة العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Agents_List",
    kurdish: "لیستی وەکیلەکان",
    arabic: "قائمة الوكيل",
    english: "Agent List",
  },
  {
    user_key: "Create Agent",
    kurdish: "دروستکردنی وەکیل",
    arabic: "إنشاء وكيل",
    english: "Create Agent",
  },
  {
    user_key: "Branches",
    kurdish: "لقەکان",
    arabic: " الفروع",
    english: "Branches",
  },
  {
    user_key: "Account",
    kurdish: "زانیاری کەسی",
    arabic: "تفاصيل الحساب",
    english: "Account",
  },
  {
    user_key: "Name of Branch",
    kurdish: "ناوی لق",
    arabic: " اسم الفرع",
    english: "Name of Branch",
  },
  {
    user_key: "Create Branch",
    kurdish: "دروستکردنی لق",
    arabic: " إنشاء فرع",
    english: "Create Branch",
  },
  {
    user_key: "List Branches",
    kurdish: "لیستی لقەکان",
    arabic: "قائمة الفروع",
    english: "List Branches",
  },
  {
    user_key: "save",
    kurdish: "خەزن کردن",
    arabic: "حفظ",
    english: "Save",
  },
  {
    user_key: "password_updatebt",
    kurdish: "نویکردنەوە",
    arabic: "تحديث",
    english: "Update",
  },
  {
    user_key: "password",
    kurdish: "وشەی نهێنی ",
    arabic: "كلمة السر ",
    english: "Password",
  },
  {
    user_key: "password_change",
    kurdish: "نویکردنەوەی پاسوورد",
    arabic: "تغيير كلمة المرور",
    english: "Change Password",
  },
  {
    user_key: "id",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "ID",
  },
  {
    user_key: "id_branch",
    kurdish: "ژمارەی لق",
    arabic: "معرف الفرع",
    english: "Branch ID",
  },
  {
    user_key: "id_branch_agent",
    kurdish: "وەکیل ID",
    arabic: "معرف الفرع",
    english: "Agent ID",
  },
  {
    user_key: "Search",
    kurdish: "گەڕان",
    arabic: "بحث",
    english: "Search",
  },
  {
    user_key: "Old_Password",
    kurdish: "وشەی نهێنی کۆن",
    arabic: "كلمة سر قديمة",
    english: "Old Password",
  },
  {
    user_key: "New_Password",
    kurdish: "وشەی نهێنی نوێ",
    arabic: "كلمة السر الجديدة",
    english: "New Password",
  },
  {
    user_key: "new_page",
    kurdish: "پەڕەی نوێ",
    arabic: "جديدة",
    english: "New Page",
  },
  // Dashboard
  {
    user_key: "d_earnings",
    kurdish: "قازانج",
    arabic: "أرباح",
    english: "Earnings",
  },
  {
    user_key: "d_products",
    kurdish: "کالایەکان",
    arabic: "منتجات",
    english: "Products",
  },
  {
    user_key: "d_totalorders",
    kurdish: "داواکاریەکان",
    arabic: "إجمالي الطلبات",
    english: "Total orders",
  },
  {
    user_key: "d_lorders",
    kurdish: "نوێترین داواکاریەکان",
    arabic: "أحدث الطلبات",
    english: "Latest Orders",
  },
  {
    user_key: "d_orderid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Order Id",
  },
  {
    user_key: "d_payment",
    kurdish: "جۆری پارەدان",
    arabic: "طريقة الدفع",
    english: "Payment Method",
  },
  {
    user_key: "d_status",
    kurdish: "بار",
    arabic: "الحالة",
    english: "Status",
  },
  {
    user_key: "d_total",
    kurdish: "کۆی گشتی",
    arabic: "مجموع",
    english: "Total",
  },
  {
    user_key: "Buy",
    kurdish: "کڕین",
    arabic: "يشترى",
    english: "Buy",
  },
  {
    user_key: "d_viewall",
    kurdish: "بینینی هەمووی",
    arabic: "مشاهدة الكل",
    english: "View All",
  },
  {
    user_key: "d_view",
    kurdish: "بینین",
    arabic: "مشاهدة",
    english: "View",
  },
  {
    user_key: "d_totalsales",
    kurdish: "کۆی فرۆشتنەکان",
    arabic: "إجمالي المبيعات",
    english: "Total Sales",
  },
  {
    user_key: "d_totalqazanj",
    kurdish: "کۆی گشتیی قازانج",
    arabic: "إجمالي الشراء",
    english: "Total Purchase",
  },
  {
    user_key: "d_saleslm",
    kurdish: "فرۆشتنەکانی مانگی پێشوو",
    arabic: "مبيعات الشهر الماضي",
    english: "Last Month Sales",
  },
  {
    user_key: "d_purchasem",
    kurdish: "قازانجی مانگی پێشوو",
    arabic: "شراء الشهر الماضي",
    english: "Last Month Purchases",
  },
  {
    user_key: "d_productrate",
    kurdish: "هەلسەنگادنی کالاکان",
    arabic: "تقييم المنتج",
    english: "Product Rate",
  },
  {
    user_key: "d_productratelevel",
    kurdish: "ئاست",
    arabic: "مستوى",
    english: "Level",
  },
  {
    user_key: "d_productname",
    kurdish: "ناو",
    arabic: "اسم",
    english: "Name",
  },
  {
    user_key: "Sent To Do",
    kurdish: "ناردنی ئەرک",
    arabic: " إرسال مهمة",
    english: "Sent Task",
  },
  {
    user_key: "d_productid",
    kurdish: "ژمارە",
    arabic: "رقم",
    english: "Product id",
  },
  {
    user_key: "Number",
    kurdish: "ژمارە",
    arabic: "الرقم",
    english: "Number",
  },

  /// add property
  {
    user_key: "Role",
    kurdish: "ڕۆڵ",
    arabic: "دور",
    english: "Role",
  },
  {
    user_key: "Sell",
    kurdish: "فرۆشتن",
    arabic: "باع",
    english: "Sell",
  },
  {
    user_key: "Type of property",
    kurdish: "جۆری موڵك",
    arabic: "نوع العقار",
    english: "Type of property",
  },
  {
    user_key: "Place (Kurdish)",
    kurdish: "شوێن (کوردی)",
    arabic: "مكان (كردي)",
    english: "Place (Kurdish)",
  },
  {
    user_key: "Place (Arabic)",
    kurdish: "شوێن (عربي)",
    arabic: "مكان (عربي)",
    english: "Place (Arabic)",
  },
  {
    user_key: "Place (English)",
    kurdish: "شوێن (ئینگلیزی)",
    arabic: "مكان (إنجليزي)",
    english: "Place (English)",
  },
  {
    user_key: "Area",
    kurdish: "ڕووبەر",
    arabic: "المساحة",
    english: "Area",
  },
  {
    user_key: "Company Branch",
    kurdish: "لقی کۆمپانیای",
    arabic: "فرع الشركة",
    english: "Company Branch",
  },
  {
    user_key: "Description (Kurdish)",
    kurdish: "دەربارەی موڵك (کوردی)",
    arabic: "الوصف (كردي)",
    english: "Description (Kurdish)",
  },
  {
    user_key: "Description (Arabic)",
    kurdish: "دەربارەی موڵك (عربي)",
    arabic: "الوصف (عربي)",
    english: "Description (Arabic)",
  },
  {
    user_key: "Description (English)",
    kurdish: "دەربارەی موڵك (ئینگلیزی)",
    arabic: "الوصف (إنجليزي)",
    english: "Description (English)",
  },
  {
    user_key: "Description",
    kurdish: "دەربارەی موڵك",
    arabic: "الوصف",
    english: "Description",
  },
  {
    user_key: "Rent",
    kurdish: "کرێ",
    arabic: "إيجار",
    english: "Rent",
  },
  /**
   * property type
   */
  {
    user_key: "Apartment",
    kurdish: "شوقە",
    arabic: "شقة",
    english: "Apartment",
  },
  {
    user_key: "House",
    kurdish: "خانوو",
    arabic: "منزل",
    english: "House",
  },
  {
    user_key: "Farm",
    kurdish: "باخ",
    arabic: "مزرعة",
    english: "Farm",
  },
  {
    user_key: "Shop",
    kurdish: "دوکان",
    arabic: "متجر",
    english: "Shop",
  },
  {
    user_key: "Vella",
    kurdish: "ڤێلا",
    arabic: "فيلا",
    english: "Vella",
  },
  /**
   * end
   */
  {
    user_key: "buyer_name",
    kurdish: "ناوی کڕیار",
    arabic: "اسم المشتري",
    english: "Buyer Name",
  },
  {
    user_key: "ListReuiredProperty",
    kurdish: "لیستی داواکاری کڕین",
    arabic: "قائمة طلبات الشراء",
    english: "List Reuired Property",
  },
  {
    user_key: "buyer_phone",
    kurdish: "مۆبایلی کڕیار",
    arabic: "هاتف المشتري",
    english: "Buyer Phone",
  },
  {
    user_key: "Project Anket",
    kurdish: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    arabic: "ئەنکێتی خزمەتگوزاری پڕۆژە",
    english: "Project Anket",
  },
  {
    user_key: "Owner Name",
    kurdish: "ناوی خاوەن موڵك",
    arabic: "اسم المالك",
    english: "Owner Name",
  },
  {
    user_key: "Owner Phone",
    kurdish: "مۆبایلی خاوەن موڵك",
    arabic: "هاتف المالك",
    english: "Owner Phone",
  },
  {
    user_key: "Phone_adressOne",
    kurdish: "ژمارەی ناونیشانی",
    arabic: "رقم العنوان",
    english: "Address.NO",
  },
  {
    user_key: "adressOne",
    kurdish: "ناونیشان",
    arabic: "العنوان",
    english: "Address",
  },
  {
    user_key: "General",
    kurdish: "گشتی",
    arabic: "عام",
    english: "General",
  },
  {
    user_key: "Add",
    kurdish: "زیادکردن",
    arabic: "إضافة",
    english: "Add",
  },
  {
    user_key: "Owner Detail",
    kurdish: "زانیاری خاوەن موڵك",
    arabic: "تفاصيل المالك",
    english: "Owner Detail",
  },
  {
    user_key: "Buyer_Detail",
    kurdish: "زانیاری کەسی کڕیار",
    arabic: "تفاصيل المشتري",
    english: "Buyer Detail",
  },
  {
    user_key: "Add Description",
    kurdish: "دەربارەی موڵك",
    arabic: "اضف وصفا",
    english: "Add Description",
  },
  {
    user_key: "Image Upload",
    kurdish: "تۆمارکردنی وێنە",
    arabic: "تحميل الصورة",
    english: "Image Upload",
  },
  {
    user_key: "Sell Property List",
    kurdish: "لیستی فرۆشتنی موڵکەکان",
    arabic: " قائمة عقارات لبيع",
    english: "Sell Property List",
  },
  {
    user_key: "Rent Property List",
    kurdish: "لیستی بەکرێدانی موڵکەکان",
    arabic: "قائمة عقارات الإيجار",
    english: "Rent Property List",
  },
  {
    user_key: "Property List",
    kurdish: "لیستی موڵکەکان",
    arabic: "قائمة عقارات ",
    english: "Property List",
  },
  {
    user_key: "View_Property",
    kurdish: "بینینی موڵك",
    arabic: "عرض الممتلكات ",
    english: "View Property",
  },
  {
    user_key: "View_Property_required",
    kurdish: "بینینی داواکاری موڵك",
    arabic: "عرض الخاصية المطلوبة ",
    english: "View Required Property",
  },

  ///

  {
    user_key: "Buy Required Property",
    kurdish: "لیستی کڕینی موڵکی داواکراو",
    arabic: " شراء قائمة العقارات المطلوبة",
    english: "Buy Required",
  },
  {
    user_key: "Rent Required Property",
    kurdish: "لیستی موڵکی کرێی داواکراو",
    arabic: "قائمة العقار المطلوبة للإيجار",
    english: "Rent Required",
  },
  {
    user_key: "Required Property List",
    kurdish: "لیستی موڵکی داواکراو",
    arabic: "قائمة العقارات المطلوبة ",
    english: "Required List",
  },
  /// invoice
  {
    user_key: "Second Party (Buyer)",
    kurdish: "لایەنی دووەم (کڕیار)",
    arabic: "الطرف الثاني (المشتري) ",
    english: "Second Party (Buyer)",
  },

  {
    user_key: "First Party (Seller)",
    kurdish: "لایەنی یەکەم (فرۆشیار)",
    arabic: "الطرف الاول (البائع) ",
    english: "First Party (Seller)",
  },
  {
    user_key: "Seller",
    kurdish: "فرۆشیار",
    arabic: "البائع",
    english: "Seller",
  },
  {
    user_key: "First Party",
    kurdish: "لایەنی یەکەم",
    arabic: "الطرف الاول ",
    english: "First Party",
  },
  {
    user_key: "Rental contract",
    kurdish: "گرێبەستی کرێ",
    arabic: "عقد الإيجار",
    english: "Rent Contract",
  },
  {
    user_key: "contract number",
    kurdish: "ژمارەی گرێبەست",
    arabic: "رقم العقد",
    english: "contract number",
  },
  {
    user_key: "View Recontract",
    kurdish: "دووبارە گرێبەستکردن",
    arabic: "إعادة التعاقد",
    english: "View Recontract",
  },
  {
    user_key: "first_rule_price",
    kurdish:
      "من لایەنی یەکەم خاوەنی موڵک ڕازیم بە فرۆشتنی ئەم موڵکەی لە خوارەوە ئاماژەی پێکراوە بە نرخی",
    arabic:
      "اني الطرف الأول (مالك العقار) اقر بانني قد بعت ھذا العقار المدون أدناه بمبلغ قدره",
    english:
      "As an owner to the estate, I agree to sell the estate as detailed below for on amount of",
  },
  {
    user_key: "Rebaru_seven",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە کۆمپانیای ‌‌‌عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
    arabic:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە کۆمپانیای ‌‌‌عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
    english:
      "لایەنی دووەم پابەندە بە پێدانی ( کرێی یەک مانگ) بە کۆمپانیای ‌‌‌عقارات هۆمیڵی وەکوو دڵنیای (تآمینات) تا کۆتایی هاتنی وادەی ئەم گرێبەستە.",
  },
  {
    user_key: "type",
    kurdish: "جۆر",
    arabic: "نوع",
    english: "Type",
  },
  {
    user_key: "first_rule_place",
    kurdish: "شوێن",
    arabic: "الموقع",
    english: "Location",
  },
  {
    user_key: "third_rule_price",
    kurdish: "لایەنی یەکەم بڕی ",
    arabic: "استلم الطرف الاول مبلغ",
    english: "The first party has taken amount of",
  },
  {
    user_key: "third_rule_introduction",
    kurdish: "وەرگرت وەک پێشەکی، وە بڕی پارە ماوە ",
    arabic: "كمقدمة، و المبلغ المتبقي",
    english: "in advance, and the rest of money  will be ",
  },
  {
    user_key: "forth_rule_date",
    kurdish:
      "لایەنی یەکەم پێویستە ئەم موڵکە ڕادەستی لایەنی دووەم بکات تا ڕێکەوتی ",
    arabic: "على الطرف الاول التسليم العقار الى الطرف الثاني بتاريخ",
    english:
      "The first party needs to give the estate to the second party until",
  },
  {
    user_key: "fifth_rule_price",
    kurdish:
      "ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاریکراودا ئەم مووڵکە ڕادەستی لایەنی دووەم نەکرد ئەوا دەبێت پابەندبێت بە پێدانی بڕی",
    arabic:
      "اذا تأخر تسليم العقار الى الطرف الثاني، يتحمل الطرف الاول غرامة يومية بمبلغ",
    english:
      "If the first party couldn’t give the estate to the second party at the defined time above, the first party must pay about",
  },
  {
    user_key: "seven_rule",
    kurdish:
      "ڕسوماتیی فرۆشتن و گواستنەوە و جیاکردنەوە و یەکخستن و ڕادەستکردنەوە و باجی خانووبەرە لەسەر لایەنی یەکەمە کە بیدات بە پێی یاسا ئەگەر تاپۆ بوو، وە ئەگەر تاپۆ نەبوو لایەنی یەکەم و دووەم پابەندن بە پێدانی پارەی بەناو کردن. ",
    arabic:
      "يتحمل الطرف الاول تسديد مبالغ رسوم البيع و النقل و التوحيد و التصحيح و ضريبة العقار و كل ما عليه حسب القانون.",
    english:
      "Fees of buying, transportation, differentiation, coordination, amendment, and estate fees should be paid by the first party if the property was officially registered. Whereas, if it is not registered, then the seller and buyer are responsible for registering it.",
  },
  {
    user_key: "eight_rule",
    kurdish:
      "ڕسوماتی کەشف و تۆماری عەقاری دەکەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵکەکە تاپۆ بوو، وە ئەگەر تاپۆ نەبوو ئەوا لایەنی یەکەم و دووەم پابەندن بە پێدانی بڕی پارەی بەناوکردن ",
    arabic:
      "على الطرف الثاني تسديد رسوم الكشف و التسجيل العقاري و كل ما عليه حسب القانون.",
    english:
      " Property valuation and registration should be paid by the second party if the property was officially registered. Whereas, if it is not registered, then the seller and buyer are responsible for registering it.",
  },
  {
    user_key: "ten_rule_one",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی ڕێژەی 1% لە نرخی ئەم موڵکەی سەرەوە بە عقارات زەنگین لە بەرامبەر فرۆشتنی ئەم موڵكە.",
    arabic:
      "من الطرفين تسديد مبلغ 1% من قيمة العقار الى عقارات زەنگین كاجرة لشراء العقار. ",
    english:
      "Both parties are committed to pay 1% of the property price to Zangin Real Estate Company agency for selling this property.",
  },
  {
    user_key: "ten_rule_thirs",
    kurdish: " نرخی تێچووی خانووەکەی سەرەوە بداتە کۆمپانیای",
    arabic: "  من سعر كلفة الدار اعلاه الى شركة ",
    english: "of the cost price of the house above to",
  },
  {
    user_key: "ten_rule_four",
    kurdish: "کە دەکاتە",
    arabic: "وهو ما تفعله.",
    english: "which it does",
  },
  {
    user_key: "ten_rule_two",
    kurdish: " ئەوەش لە بەرامبەر نێوەندگیریی رێکخستنی ئەم گرێبەستە",
    arabic: " و ذلك مقابل التوسط في ایجار الملك",
    english: "in return for mediating in the Rent of the property",
  },

  {
    user_key: "nine_rule_two",
    kurdish:
      ".بە بریکارنامەی تایبەت بەم موڵکە لە فەرمانگەی دادنووس بە مەبەستی ڕایی کردنی مامەڵەکان و بەناوکردنی لە بەڕێوەبەرایەتی تۆماری خانووبەرە بۆ لایەنی دووەم",
    arabic:
      "وكالة خاصة عند الكاتب العدل بالعقار المذكور الاجراء المعاملات و تسجيله بدائرة التسجيل العقاري للطرف الثاني.",
    english:
      "to complete propertied process to the second party in property registration directorate.",
  },
  {
    user_key: "nine_rule_one",
    kurdish: "لەسەر لایەنی یەکەم پێویستە دەسەڵات بدات بە پارێزەر ",
    arabic: "على الطرف الاول منح صلاحية للمحامي",
    english: "The first party must grant authority to the lawyer",
  },
  {
    user_key: "lawyer",
    kurdish: "پارێزەر",
    arabic: "محامي",
    english: "lawyer",
  },
  {
    user_key: "six_rule_one",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێک بە هەر هۆیەک پاشگەزبێتەوە لەم گرێبەستە دەبێت پابەند بێت بە پێدانی ",
    arabic: "اذا تنكل احد الطرفين عن العقد المبرم، على المتنكل دفع الغرامة",
    english: "If any of them regret to commit to the contract, the amount of",
  },
  {
    user_key: "six_rule_two",
    kurdish:
      "وەک پێبژاردن (غرامة) بە لایەنەکەی تر بەبێ ئاگادارکردنەوەی لایەنی فەرمی.",
    arabic: "للطرف الاخر بدون تبليغ رسمي",
    english:
      "must be paid as a penalty by one who will withdraw from the contract to another one without notifying interested party.",
  },
  {
    user_key: "note",
    kurdish: "تێبینی",
    arabic: "ملاحظة",
    english: "Note",
  },
  {
    user_key: "Company price",
    kurdish: "نرخی کۆمپانیا $",
    arabic: "سعر الشركة $",
    english: "Company price $",
  },
  {
    user_key: "comision",
    kurdish: "عمولە",
    arabic: "عمولة",
    english: "comision",
  },
  {
    user_key: "investor",
    kurdish: "وەبەرهێنەر",
    arabic: "مستثمر",
    english: "investor",
  },
  {
    user_key: "Contract",
    kurdish: "گرێبەست",
    arabic: "العقد",
    english: "Contract",
  },
  /**
   * invoice list
   */
  {
    user_key: "Sell Contracts",
    kurdish: "لیستی گرێبەستی فرۆشتوو",
    arabic: "قائمة العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Sell_Contracts",
    kurdish: "گرێبەستی فرۆشتن",
    arabic: "العقود المباعة",
    english: "Sell Contracts",
  },
  {
    user_key: "Total_Sell_Contracts",
    kurdish: "کۆی گرێبەستی فرۆشتن",
    arabic: "إجمالي عقود البيع",
    english: "Total Sell Contracts",
  },
  {
    user_key: "Contract List",
    kurdish: "لیستی گرێبەستەکان",
    arabic: "قائمة العقود",
    english: "Contract List",
  },
  {
    user_key: "Contract_",
    kurdish: "گرێبەستەکان",
    arabic: "العقود",
    english: "Contracts",
  },
  {
    user_key: "Rent Contracts",
    kurdish: "لیستی گرێبەستە کرێیەکان",
    arabic: "قائمة عقود الإيجار",
    english: "Rent Contract",
  },

  /// Rent Contract
  {
    user_key: "this",
    kurdish: "ئەم",
    arabic: "هذا",
    english: "this",
  },
  {
    user_key: "to",
    kurdish: "تا",
    arabic: "ل",
    english: "to",
  },
  {
    user_key: "First side (property owner)",
    kurdish: "لایەنی یەکەم (خاوەن موڵك)",
    arabic: "الطرف الاول ( صاحب الملك )",
    english: "First party (property owner) :",
  },
  {
    user_key: "Vella Contracts",
    kurdish: "لیستی گرێبەستی ڤێلا",
    arabic: "قائمة عقود فیلا",
    english: "Vella Contracts",
  },
  {
    user_key: "First Side",
    kurdish: "لایەنی یەکەم",
    arabic: "الطرف الأول",
    english: "First Side",
  },
  {
    user_key: "Second Side",
    kurdish: "لایەنی دووەم",
    arabic: "الجانب الثاني",
    english: "Second Side",
  },
  {
    user_key: "Second side (tenant)",
    kurdish: "لایەنی دووەم (کرێچی)",
    arabic: "الطرف الثاني ( المستأجر )",
    english: "Second party (tenant)",
  },
  {
    user_key: "tenant",
    kurdish: "کرێچی",
    arabic: "المستأجر",
    english: "tenant",
  },
  {
    user_key: "I'm the first side to own this",
    kurdish: "من لایەنی یەکەم خاوەنی ئەم",
    arabic: " أنى الطرف الاول صاحب ھذا",
    english: "Iam the first party the owner of",
  },
  {
    user_key: "rented to the second party on the date of",
    kurdish: "م بەکرێ داوە بە لایەنی دووەم لە ڕێکەوتی",
    arabic: " أجرت ھذا الى الطرف الثاني بتأريخ",
    english: "give it to the second party for rent in this date",
  },
  {
    user_key: "monthly wages",
    kurdish: "بە کرێی مانگانەی",
    arabic: " بإجارشھري قدره",
    english: "date with monthly rent",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "دفعات شهرية",
    english: "Monthly Payments",
  },
  {
    user_key: "start date",
    kurdish: "بەرواری دەستپێکردن",
    arabic: "تاريخ البدء",
    english: "Start Date",
  },
  {
    user_key: "end date",
    kurdish: "بەرواری کۆتایی",
    arabic: "تاريخ الانتهاء",
    english: "End Date",
  },
  //
  {
    user_key: "as an introduction",
    kurdish: "وەکو پێشەکی",
    arabic: "كمقدمة",
    english: "as an introduction",
  },
  {
    user_key: "Posted",
    kurdish: "تۆمارکردن",
    arabic: "نشرت",
    english: "Posted",
  },
  {
    user_key: "I'm doing it for purposes",
    kurdish: "بەکاری دێنم بۆ مەبەستی",
    arabic: "أفعل ذلك لأغراض",
    english: "I'm doing it for purposes",
  },
  {
    user_key: "for purposes",
    kurdish: "بۆ مەبەستی",
    arabic: "أفعل ذلك لأغراض",
    english: "for purposes",
  },
  {
    user_key: "once a preludant",
    kurdish: "مانگ جارێک پێشەکی",
    arabic: "كمقدمة",
    english: "once advance guard.",
  },
  {
    user_key: "The first side is committed to handing this over",
    kurdish: "لایەنی یەکەم پابەندە بە رادەستکردنی ئەم",
    arabic: " يلتزم الطرف الاول بتسليم",
    english: "The first party binding to surrender this",
  },
  {
    user_key: "without any shortcomings in the way",
    kurdish: "ە بەبێ هیچ کەم وکوڕیەک لە ڕیکەوتی",
    arabic: " الى الطرف الثاني دون اي نواقص بتأريخ",
    english: "to the second party without any shortage in agreement",
  },
  {
    user_key: "punshed",
    kurdish:
      "وەبە پێچەوانەوە دەبێت پێبژاردن(غرامە) بدات بە لایەنی دووەم بە بڕی",
    arabic: "و بعكسه يجب عليه دفع غرامة  الى الطرف الثاني بقيمة ",
    english: "in reverse must pay fine to the second party with value of ",
  },
  {
    user_key: "For every day",
    kurdish: "بۆ هەر ڕۆژێک دواکەوتن",
    arabic: " لكل يوم",
    english: " For every day",
  },
  {
    user_key: "month",
    kurdish: "مانگ",
    arabic: " شهر",
    english: "Month",
  },
  {
    user_key: "fifth_rent",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی کرێیەکە لە ڕیکەوتی دیاریکراودا وە بە پێەچەوانەوە ئەگەر لە پێنج ڕۆژ زیاتر دواکەوت لە کاتی خۆی دەبێت پابەند بێت بە پێدانی پێبژاردنی (غرامة) بە لایەنی یەکەم بە بڕی ",
    arabic:
      " يلتزم الطرف الثاني بتسديد الايجار في موعدھا الى الطرف الاول و عند تاخرھا في التسديد بأكثر من ( خمسة ) أيام عندھا تدفع غرامة بقيمة ",
    english:
      "Second party binding to give rent in specific date in reverse if its delayed for more than five days in its date must be binding to give fine to the first party with value of",
  },
  {
    user_key: "delays for each day except monthly fees",
    kurdish:
      "بۆ هەر رۆژێک دواکەوتن جگە لە کرێی مانگانە دەبێت ڕەزامەندبێت لەسەر کردنەوەی دەرگای موڵکەکە لەلایەن لایەنی یەکەم بە مەبەستی بە کرێدانەوەی،وە لایەنی دووەم بۆی نیە داوای هەر قەرەبوویەکی دارایی یان یاسایی بکات.",
    arabic:
      "،عدا الايجارالشھري. ويتم إخلاء الملك عن طريق طرف الاول بدون مانرجع للطرف الثاني وإعادة التاجر الملك.",
    english:
      "for each day delaying, the second party must be agreed for opening the estates door by the first party for the purpose of renting again.",
  },
  {
    user_key: "After the contract expires or when this is evacuated",
    kurdish: "پاش کۆتایی هاتنی ماوەی گرێبەستەکە یان لە کاتی چۆڵکردنی ئەم",
    arabic: "بعد انتھاء مدة العقد أو عند إخلاء ",
    english:
      "After the expiration of the contract or in the case of emptying this",
  },
  {
    user_key: "On the second side, this is necessary",
    kurdish: " ە لەسەر لایەنی دووەم پێویستە ئەم",
    arabic: "يجب على الطرف الثاني تسليم",
    english: "the party must be",
  },
  {
    user_key: "The second party is committed to paying the amount",
    kurdish: " لایەنی دووەم پابەندە بە پێدانی بڕی",
    arabic: " يلتزم الطرف الثاني بدفع المبلغ",
    english: " The second party is committed to paying the amount",
  },
  {
    user_key: "such as assurances",
    kurdish: "وەکو دڵنیایی(تآمینات) تاکۆتای هاتنی ئەم گرێبەستە",
    arabic: "مثل الضمانات",
    english: "such as assurances",
  },
  {
    user_key: "such as Assurances",
    kurdish: "دڵنیایی(تآمینات)",
    arabic: "الضمانات",
    english: "such as assurances",
  },
  {
    user_key: "eight_rent",
    kurdish:
      "پێدانی پارەی مانگانە بۆ ئاو و کارەباو هەر خزمەتگووزاریەکی تر دەکەوێتە سەر ئەستۆی لایەنی دووەم لەماوەی ئەم گرێبەستە",
    arabic:
      "جميع مصاريف الخدمات، كالماء و الكھرباء و البلدية و الخدمات الاخرى تقع على الطرف الثاني اثناء مدة العقد.",
    english:
      "The second party monthly have to pay money for water and electricty and any service in the duration of the contract.",
  },
  {
    user_key: "nine_rent",
    kurdish:
      " لایەنی دووەم بۆی نیە بە هیچ شێوەیەک بۆی نیە ئەم موڵکە بە کرێ بداتە کەسێکی تر",
    arabic: " لكل يوم",
    english: " The second side can't rent this property to anyone else at all",
  },
  {
    user_key: "ten_rent",
    kurdish:
      " لایەنی دووەم بۆی نیە بەبێ رەزامەندی خاوەن موڵک هیچ گۆڕانکاریەک لە ناوەوەو دەرەوەی ئەم موڵکە بکات",
    arabic:
      "لا يمكن للجانب الثاني إجراء أي تغييرات داخل وخارج العقار دون موافقة المالك",
    english:
      "The second side cannot make any changes inside and outside the property without the consent of the owner",
  },

  /**
   * balav Rent Translation
   */

  {
    user_key: "balav_1_1",
    kurdish:
      "لایەنی یەکەم ڕەزامەندە لەسەر بەکرێدانی ئەم موڵکە کەلە سەرەوە ئاماژەی پێکراوە بەلانی دووەم.",
    arabic:
      "وافق الطرف الأول على تأجير هذا العقار المذكور أعلاه إلى الطرف الثاني. ",
    english:
      "The first party agrees to lease the property which is referred to above to the second party.",
  },
  {
    user_key: "balav_2_1",
    kurdish: "ماوەی ئەم گریبەستە",
    arabic: "مدة العقد  ",
    english: "The duration of this contract is ",
  },
  {
    user_key: "balav_2_2",
    kurdish: "مانگە دەستپێدەکات لە بەرواری",
    arabic: "شهراً تبدأ من ",
    english: "months, it starts from ",
  },
  {
    user_key: "balav_2_3",
    kurdish: "تا",
    arabic: "إلى ",
    english: "to ",
  },
  {
    user_key: "balav_2_4",
    kurdish:
      "وە لەکاتی کوتایی هاتنی ماوەی ئاماژە پێکراو لەسەر لایەنی دووەمە کە شوینی بەکرێگیراو چۆل بکات بی ئەوەی پێویستی بە ئاگادار کردنەوەی هەبیت",
    arabic: "وعند انتهاء المدة على الطرف الثاني تخلية العقار دون تبليغ مسبق. ",
    english:
      "and when the above mentioned duration ends the second party should evacuate the leased property without the need to be notified.",
  },
  {
    user_key: "balav_3_1",
    kurdish: "هەردوو لایەن رەزامەندن لەسەر کرێی مانگانەی بە بڕی",
    arabic: "وافق كلا الطرفين على أجرة شهرية قدره ",
    english: "Both parties agree on the monthly lease fee with the amount of",
  },
  {
    user_key: "balav_4_1",
    kurdish: "لایەنی دووەم بڕی",
    arabic: "يدفع الطرف الثاني مبلغ قدره ",
    english: "The second party gives the amount of ",
  },
  {
    user_key: "balav_4_2",
    kurdish: "دەدات بە لایەنی یەکەم وەک پێشەکی",
    arabic: "كمقدمة ",
    english: "to the first party as the advance payment.",
  },
  {
    user_key: "balav_5_1",
    kurdish: "دوای پێشەکی کرێیەکە بەم شێوەیە دەدرێت",
    arabic: "بعد مبلغ المقدمة يتم دفع الأجرة على النحو التالي",
    english:
      "After the advance payment the lease fee payment will be as following",
  },
  {
    user_key: "balav_6_1",
    kurdish: "لایەنی دووەم پاپەند دەبیت بە پێدانی بڕی",
    arabic: "يلتزم الطرف الثاني بدفع مبلغ قدره ",
    english: "The second party will be committed to paying the amount of",
  },
  {
    user_key: "balav_6_2",
    kurdish:
      "وەك دلنيايى(تأمینات) بە عقارات زەنگین وه پێویستە لەسەر کرێچی کە پسولەی ئەسلی پێبێت بۆ داناوەی تەئمینات به مەرجيك لايەنى دووەم مۆڵكەكه بەبى بوونى هيج كەم و كوڕيەك رادەست بكاتەوه بە پێچەوانەوە پارە کە نادرێتەوە لایەنی دووەم .",
    arabic: "كتأمينات إلى عقارات زەنگین وفق ورقة الإيصال المرقمة ",
    english: "as insurance to Zangin company as per the invoice number",
  },

  {
    user_key: "balav_7_1",
    kurdish: "لايەنى دووەم ئەم مۆلكه بەكاردێنيت بۆ مەبەستى ",
    arabic: "يستخدم الطرف الثاني هذا العقار لغرض ",
    english: "The second party will use this property for the purpose of",
  },
  {
    user_key: "balav_7_2",
    kurdish:
      "له كاتى بەكارهێنانى بۆ هەر مەبەستێكى تر پێويستە ئاگادارى عقارات زەنگین بكات و رەزامەندى لايەنى يەكەم به نوسراوو وەربگريت.به پێجەوانەوە مافى لايەنى يەكەمه ئەم گريبەستە هەڵبوشێنێتەوە بەبى ئاگادار كردنەوەى لايەنى دووەم",
    arabic:
      "وعند استخدامه لأي غرض آخر يجب تبيلغ عقارات زەنگین عن ذلك وبموافقة خطية من الطرف الأول. خلافاً لذلك يحق للطرف الأول إبطال العقد دون تبيلغ الطرف الثاني. ",
    english:
      "and when using it for any other purpose it should notify Zangin company and to get a written agreement from the first party, otherwise the first party has the right to terminate this contract without notifying the second party.",
  },
  {
    user_key: "balav_8",
    kurdish:
      "لايەنى دووەم بەلێن دەدات كه پارێزگارى له شوێنى بەكرێگیراو بكات له كاتى سوود وەرگرتن له شوێنەكە وە دوورى بگرێت له تێكجوون و داڕمان وه بەكارنەهێنانى به شێوەیەكى نەخوازراو",
    arabic:
      "يتعهد الطرف الثاني بحماية العقار المستأجَر عن الاستفادة منه والحفاظ عليه من التلف والهدم وعدم استخدامه على شكل غير مرغوب فيه. ",
    english:
      "The second party promises that it will protect the leased property when using it and it also promises that it will protect the property from getting damaged and that it will not use it unfairly.",
  },
  {
    user_key: "balav_9",
    kurdish:
      "لايەنى یەکەم بۆى نيه شوێنى بەكرێگيراو بەكار بهێنێت ياخوود داواى كليلى موڵكەکە بكات بۆ هەر مەبەستێك بێت تا رێپێدانى ئاسايش ياخوود لايەنى پەيوەندیدار وەردەگرێت.بەپیچەوانەوه بەرپرسيار دەبيت بەرامبەر به ياسا",
    arabic:
      "لا يجوز للطرف الأول استخدام العقار المستأجَر أو يطالب بمفتاحه إلى أن يتم الحصول على الرخصة الأمنية (من آسايش) أو الجهة المعنية؛ خلافاً لذلك يتحمل المسؤولية أمام القانون",
    english:
      "The first party doesn’t have the right to ask for the keys or to use the leased property for any purpose unless it gains the security clearance or the clearance from other related parties, otherwise it will be responsible in front of the law.",
  },
  {
    user_key: "balav_10",
    kurdish:
      "پێويستە لايەنى دووەم پێش بەكارهێنانى شوينى بەكرێگیراو لەسەر ئەستوى خۆى گشت قوفلى دەرگا دەركيەكان بگۆرێت.به پێچەوانە له كاتى روودانى هەر كێشەيەك تەنها خوودى خۆى بەرپرسيار دەبێت",
    arabic:
      "على الطرف الثاني تغيير كافة أقفال الأبواب الخارجية قبل استخدام العقار؛ خلافاً لذلك يتحمل المسؤولية هو بنفسه. ",
    english:
      "The second party should change all the lockers of all the main doors before using the leased property, otherwise in case of any problem the second party will solely be responsible for.",
  },
  {
    user_key: "balav_11",
    kurdish:
      "له بەروارى واژوو كردنى ئەم گرێبەستە خزمەتگوزاريەكانى پرۆژە و شارەوانى و كارەبا و ئاو وهەر خزمەت گوزاريەكى تر هەبيت له ئەستۆى لايەنى دووەم دەبيت",
    arabic:
      "	من تاريخ توقيع العقد يكون الطرف الثاني هو المسؤول عن دفع تكاليف الماء والكهرباء والبلدية وأية خدمة أخرى. ",
    english:
      "From the date of signing this contract all the expenses of the project, municipality, electricity, water and any other services will be the liability of the second party",
  },
  {
    user_key: "palace",
    kurdish: "کۆشک",
    arabic: "قصر",
    english: "palace",
  },
  {
    user_key: "First Mobile Number",
    kurdish: "ژمارەی مۆبایلی یەکەم",
    arabic: "أول رقم جوال",
    english: "First Mobile Number",
  },
  {
    user_key: "Second Mobile Number",
    kurdish: "ژمارەی مۆبایلی دووەم",
    arabic: "رقم الجوال الثاني",
    english: "Second Mobile Number",
  },
  {
    user_key: "balav_12_1",
    kurdish: "ئەگەر لایەنی دووەم تاکو بەرواری ",
    arabic: "	في حال عدم الحصول على الرخصة من الجهة الأمنية حتى تاريخ ",
    english:
      "If the second party couldn’t gain the clearance from the related parties until",
  },
  {
    user_key: "balav_12_2",
    kurdish:
      "نەیتوانی ڕێپێدان لە لایەنی پەیوەندیدار وەربگرێ راستەوخۆ گرێبەستەکە هەڵدەوەشێتەوە وە ئەو بڕە کرێیەی کەوا دراوە دەگەرێنرێتەوە بۆ لایەنی دووەم",
    arabic: "يتم فسخ العقد مباشرة ويتم إرجاع المبلغ المستلم إلى الطرف الثاني. ",
    english:
      "in this case the contract will directly be terminated and the amount of the fee which is paid will be returned to the second party.",
  },
  {
    user_key: "balav_13",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی کرێ لە کاتی دیاریکراو لەم گرێبەستە. لەکاتی دواکەوتن لە (7) رۆژ زیاتر ئەوە بە پێی برگەی (1) لە ماددەی (17) لە یاسای بەکرێدانی مۆڵک لە قانونی عێراقی ژمارە (87) ساڵی (1979) مامەڵەی لەگەل دەکرێ ئەویش بە چۆڵ کردنی موڵکەکە و تێچوی هۆشداری دادگا ئەکەوێتە ئەستۆی لایەنی دووەم لەگەل کرێی مانگانە.",
    arabic:
      "يتعهد الطرف الثاني بدفع الأجرة في الوقت المحدد في العقد. وإذا تأخر أكثر من (7) أيام فيتعامل معه حسب الفقرة (1) من المادة (17) من قانون تأجير العقار من القانون العراقي المرقم (87) لسنة (1979) وهي تخلية العقار مع تحمل تكاليف تبليغ المحكمة مع الأجرة الشهرية. ",
    english:
      "The second party will be committed to paying the lease fee at the specified time stated in this contract. And in the case of getting delayed for more than (7) days, then the second party will be dealt with according to the Clause (1) from article (17) in the law for leasing the properties of the Iraqi Law number (87) in the year (1979) which is evacuating the property and the expenses for the court notice plus the monthly lease fee will be the liability of the second party. ",
  },
  {
    user_key: "balav_14",
    kurdish:
      "ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث)لايەنى دووەم پێويستە پاريزگارى لە كەل و پەلەكان بكات و لەكاتى چۆل كردنى شوينى بەكرێگيراو وەك خۆى رادەستى لايەنى يەكەم بكاتەوە. بە پێچەوانەوە لايەنی دووەم بەرپرسە له چاككردنەوە يان گۆڕينى لەسەر ئەركى خۆى",
    arabic:
      "إذا كان العقار المؤجًّر مؤثثا على الطرف الثاني الحفاظ على الأثاث وعند التخلية يسلّمها كما كانت؛ خلافاً لذلك يكون الطرف الثاني مسؤولاً عن التصليح أو تبديله على مسؤوليته. ",
    english:
      "If the leased property was furnished, the second party should protect this stuff when evacuating the property, it should deliver to the first party as it was when being received. Otherwise, the second party will be responsible for repairing or changing the stuff on its own expense",
  },
  {
    user_key: "balav_15",
    kurdish:
      "لايەنى يەكەم پابەند دەبێت بە پێدانى پارەى حكومى و تايبەت(ئەهلى) و خزمەتگوزاريەكان و ئەستۆ پاكى بكات پيش بە كرێدان و واژوو كردنى ئەم گريبەستە",
    arabic:
      "	يتعهد الطرف الأول بدفع الرسومات الحكومية والخاصة والخدمات وبراءة الذمة قبل التأجير والتوقيع على العقد. ",
    english:
      "The first party will be committed to paying all the financial obligations whether public or private, services and clearance before leasing its property and signing this contract.",
  },
  {
    user_key: "balav_16",
    kurdish:
      "هەردوولا رێكەوتن كە باجى خانووبەرە لە لايەن لايەنى يەكەمەوە دەدرێت بە پێى ياسا باجى خانووبەرەى كارپێكراو",
    arabic:
      "اتفق الطرفان على أن الطرف الأول هو المسؤول عن دفع ضريبة العقار  وفق قانون ضريبة العقار الساري. ",
    english:
      "Both parties agreed that real estate tax will be paid by the first party according to the applicable Real Estate Law.",
  },
  {
    user_key: "balav_17",
    kurdish:
      "لايەنى دووەم پێويستە (مانگيك) پيش كوتايی هاتنى ئەم گريبەستە,ئاگادارى عقارات زەنگین بكات بەوەى ئەگەر نيازى هەبێت بە نوێكردنەوە ياخوود بە چۆول كردنى شوينى بەكرێگيراو. بە پێچەوانەوە كريى (مانگيك)دەکەويتە ئەستوى لايەنى دووەم",
    arabic:
      "يجب على الطرف الثاني إبلاغ عقارات زەنگین قبل انتهاء العقد بـ(شهرٍ) عن موقفه إما بتجديد العقد أو التخلية؛ خلافاً لذلك عليه دفع أجرة شهر.  ",
    english:
      "The second party should notify Zangin company before (1 month) to the time of ending this contract if it intends to renew or evacuate the leased property, otherwise the lease fee for one month should be paid by the second party.",
  },
  {
    user_key: "balav_18",
    kurdish:
      "لەسەر لايەنى دووەم پێويستە مولكەكە بۆ ئەو مەبەستە بەكار بهێنێت كە لەسەرى رێككەوتون,وە بۆ كارى نەشياو ناشەرعى وناقانونى بەكارنەهێنێت.بە پێچەوانەوە بەرپرسيار دەبێت بەرامبەر ياسا و گرێبەستەكە هەڵدەوەشێتەوە",
    arabic:
      "على الطرف الثاني استخدام العقار للغرض الذي اتفق عليه الطرفان وألا يستخدمه لأغراض غير شرعية وغير قانونية؛ خلافاً لذلك يتحمل المسؤولية أمام القانون ويتم فسخ العقد. ",
    english:
      "The second party should use the property for the purpose which both parties have agreed on and it should not be used for illegal actions. Otherwise the second party will be responsible in front of law.",
  },
  {
    user_key: "balav_19_1",
    kurdish:
      "دوای تەواو بونی ماوەی ئەم گرێبەستە ئەگەر لایەنی دووەم پابەند نەبێ بە چۆڵکردن یان نوێکردنەوەی ئەم گرێبەستە ئەوا کرێی موڵکەکە دەبێت بە رۆژانە بە بڕی ",
    arabic:
      "بعد انتهاء مدة العقد في حال لم يلتزم الطرف الثاني بتخلية العقار أو تجديد العقد تكون أجرة العقار ",
    english:
      "When the duration of this contract ends if the second party is not committed to evacuating the property or renewing this contract in this case the lease fee of the property will be on daily basis ",
  },
  {
    user_key: "balav_19_2",
    kurdish: "بۆ هەر رۆژێک هەژمار دەکرێت تا ئەو کاتەی کێشەکە یەکلایی دەبێتەوە",
    arabic: "إزاء كل يوم إلى أن يتم حسم القضية. ",
    english: "for each day will be counted until the problem is being solved.",
  },
  {
    user_key: "balav_20",
    kurdish:
      "ئەگەر لایەنی دووەم نیازی هەبێت هەر جۆرە گۆرانکاریەک بکا لە ناوەوە یان دەرەوەی ئەم موڵکە ئەوا پێویستە بە ئاگاداری عقارات زەنگین و بەرەزامەندی نوسراوی لایەنی یەکەم بێت وە پێویستە گۆرانکاریەکان دیاری بکرێت",
    arabic:
      "في حال أراد الطرف الثاني إحداث أي تغيير داخلي أو خارجي للعقار عليه تبليغ عقارات زەنگین وأخذ موافقة الطرف الأول مع تحديد التغييرات. ",
    english:
      "If the second party intends to make any change inside or outside the property it should notify Zangin Company and this will be based on a written agreement from the first party and all changes should be stated in this agreement.",
  },
  {
    user_key: "balav_21",
    kurdish:
      "لایەنی دووەم بۆی نیە داوای تێچووی گۆرانکاریەکان بکات لە لایەنی یەکەم",
    arabic:
      "	لا يحق للطرف الثاني المطالبة بدفع تكاليف التغييرات من الطرف الأول. ",
    english:
      "The second party doesn’t have the right to claim for the expenses of the changes which have been done. ",
  },
  {
    user_key: "balav_22",
    kurdish:
      "لایەنی دووەم بۆی نیە بە هیچ شێوەیەک ئەم مولکە ( گشتی یان بەشێکی) بەکرێ بداتەوە بەلایەنێکی تر بەبێ ئاگادارکردنەوەی عقارات زەنگین وە هەروەها بەبێ وەرگرتنی رەزامەندی نوسراوی لایەنی یەکەم",
    arabic:
      "لا يحق للطرف الثاني بأي وجه من الوجوه تأجير جزء من الملك أو كله إلى طرف آخر دون تبليغ عقارات زەنگین وكذلك أخذ الموافقة الخطية من الطرف الأول. ",
    english:
      "The second party doesn’t have the right in any way to lease (a part or as whole) of this property to the third party without notifying Zangin Company and without gaining the written agreement from the first party.",
  },
  {
    user_key: "balav_23",
    kurdish:
      "ئەگەر لەماوەی ئەم گرێبەستە خاوەنداریەتی ئەم موڵکە گواسترایەوە بۆ هەر لایەنێکی تر ئەوا ئەبێ خاوەنە نوێیەکەی پابەندی نێوەرۆکی ئەم گرێبەستە بێ",
    arabic:
      "إذا تم نقل الملكية للعقار إلى طرف آخر يجب على الصاحب الجديد  الإلتزام بمضمون هذا العقد.  ",
    english:
      "As far as this contract is active and if the property ownership transferred to another party then the new owner should commit to the content of this contract.",
  },
  {
    user_key: "balav_24",
    kurdish:
      "ئەگەر لایەنی دووەم پێش کۆتایی هاتنی ئەم گرێبەستە شوێنی بەکرێگیراوی چۆل کرد ئەوە عقارات زەنگین بە پێی توانا هاوکار دەبێ بۆ گێرانەوەی (بەشێک یان گشت) کرێی ماوەی چۆڵکردنی موڵکەکە بەمەرجێک ئەگەر موڵکەکە بەکرێدرایەوە لەلایەن عقارات زەنگین",
    arabic:
      "	إذا قام الطرف الثاني قبل انتهاء مدة العقد بتخلية العقار المؤجّر تسعى عقارات زەنگین حسب استطاعتها إلى مساعدة إرجاع (جزء أو كل) أجرة مدة تخلية العقار بشرط إعادة تأجيره من قبل عقارات زەنگین. ",
    english:
      "If the second party evacuated this property before ending the duration of this contract then Zangin Company will be helpful to return a part or all of the lease fees for the property evacuation period to the second party with the condition if the property is leased again bythe Zangin Company.",
  },
  {
    user_key: "balav_25",
    kurdish:
      "ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث) لايەنى یەکەم لەگەل لایەنی دووەم پێويستە کەل و پەلەکان ئەژمار بکەن (جرد) وە  وێنەی بگرن و هاوپێچی ئەم گرێبەستەی بکەن",
    arabic:
      "إذا كان العقار المؤجّر مؤثثاً يجب على الطرف الأول جرد الأثاث وأخذ صورة منها ويتم إرفاقها مع العقد. ",
    english:
      "If the leased property was furnished then the first party and the second party should do an inventory for all stuff and take photos of them and attach it to this contract",
  },
  {
    user_key: "balav_26",
    kurdish:
      "لایەنی یەکەم دڵنیای ئەوە دەکاتەوە کە ( ئامادەی رووبەروبونەوەی یاساییە – التعرض القانونی) لەهەر کەسێک دەربارەی شوێنی بەکرێگیراو، بەپێچەوانەوە مافی لایەنی دووەمە کە لە پێدانی کرێ بوەستێت سەرەرای بونی مافی هەڵوەشاندنەوەی گرێبەستەکە ",
    arabic:
      "يتعهد الطرف الأول بأنه يكون مستعد للتعرض للمساءلة القانونية لأي شخص بخصوص العقار المؤجّر، خلافا لذلك يحق للطرف الثاني أن يقف عن دفع الأجرة إضافة إلى حق فسخ العقد. ",
    english:
      "The first party ensures that it is ready for legal exposure against any person regarding the leased property otherwise it is the right of the second party to suspend paying the lease fees plus having the right of terminating the contract. ",
  },
  {
    user_key: "balav_27",
    kurdish:
      "لەکاتی ئامادەبونی کرێ وە ئاگادارکردنەوەی لایەنی یەکەم بۆ وەرگرتنی پێویستە لایەنی یەکەم بەزوترین کات ئامادەبێت لە عقارات زەنگین وە  کرێیەکەی وەربگرێت بە پێچەوانە پارەکە دەخرێتە سەر ئەژماری ( حساب) بانکی دیار دواتر بە چەک بۆی خەرج دەکرێت",
    arabic:
      "	عند تحضير الأجرة وتبليغ الطرف الأول لاستلامه يجب على الطرف الأول أن يحضر بأسرع وقت ممكن في عقارات زەنگین ويستلم أجرته خلافاً لذلك يتم إيداع المبلغ في حساب عقارات زەنگین ومن ثم يمكن صرفه عن طريق صك. ",
    english:
      "When the lease fees are ready and after notifying the first party to receive its lease fees then the first party should attend at Zangin Company as soon as possible to receive its lease fees otherwise this amount will be put in a bank account of Zangin Company and later on will be paid to it by check.",
  },
  {
    user_key: "balav_28",
    kurdish:
      "هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ هەر ساڵێک بدەن بە عقارات زەنگین لە بڕی رێکخستنی ئەم گرێبەستە",
    arabic:
      "على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى عقارات زەنگین بدل تظيم هذا العقد. ",
    english:
      "Each one of the first and the second party should pay half a month lease fee to Zangin  Company for arranging this contract.",
  },
  {
    user_key: "balav_29",
    kurdish:
      "لەکاتی چۆڵکردن شوێنی بەکرێ گیراو پێویستە لایەنی دووەم چۆن موڵکەکەی وەرگرتوە وەک خۆی بەبێ کەم و کورتی رادەستی لایەنی یەکەم بکاتەوە، بەپێچەوانەوە بەرپرسە لە چاککردنەوەی کەم وکوریەکان بەزوترین کات",
    arabic:
      "عند تخلية العقار يجب على الطرف الثاني تسليم العقار كما استلمه دون نقصان خلافا لذلك يتحمل المسؤولية لسد النواقص بأسرع وقت ممكن. ",
    english:
      "When evacuating the leased property the second party should deliver the property to the first party as it was when being received without any damage or shortage otherwise it will be responsible for repairing the shortages as soon as possible",
  },
  {
    user_key: "balav_30",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی پارەی ئاو و کارەبای نیشتمانی لەگەل هاتنەوەی پسولە وە پێویستە لەکاتی چؤل کردن شوێنی بەکرێگیراو سەردانی فەرمانگەکان بکات بۆ پێدانی ئەو بڕە قەرزەی کە لەئەستۆیەتی وە پابەند دەبێت بە دەرخستنی گشت پسولەکان بە پێچەوانەوە بەرپرسیار دەبێت بەرامبەر بە یاسا",
    arabic:
      "يتعهد الطرف الثاني بدفع تكاليف الماء والكهرباء الوطنية مع مجيء ورقة القبض وعند التخلية عن العقار المؤجر عليه زيارة الدوائر لدفع القرض المتبقى عليه خلافا لذلك يتحمل المسؤولية أمام القانون. ",
    english:
      "The second party is committed to paying for water, public electricity at the time of receiving the invoice and it is a must that during evacuating the least property to visit the related governmental organizations to pay off any remaining debt And will be committed for preparing all invoices otherwise will be responsible in front of law.",
  },
  {
    user_key: "balav_31",
    kurdish:
      "لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی نیو مانگ بۆ یەک ساڵ بە عقارات زەنگین",
    arabic:
      "يتعهد الطرفان عند تجديد العقد بدفع نصف مبلغ الأجرة سنوياً إلى عقارات زەنگین. ",
    english:
      "When renewing the contract each party will be committed to paying the amount of the lease fee for half a month to Zangin Company for each year. ",
  },
  {
    user_key: "balav_32",
    kurdish:
      "لایەنی دووەم بەهیچ شێوەیەک نابێت ببێتە مایەی ئەزیەت و ئازار بۆ دراوسێیەکانی و بە پێچەوانەوە بەرپرسیار دەبێت و گرێبەستەکە هەڵدەوەشێتەوە",
    arabic:
      "لا يحق للطرف الثاني بأي وجه من الوجوه أم يخلق مشاكل مع جيران خلافاً لذلك يتحمل المسؤولية ويتم فسخ العقد. ",
    english:
      "The second party should not be in any way the source of disturbance to its neighbors; otherwise it will be responsible and will cause the contract termination.",
  },
  {
    user_key: "balav_33",
    kurdish:
      "لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ و دانوستاندن ئەوا عقارات زەنگین بەرپرس نیە و نابێت بەڵکو پێویستە لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و پەنابردن بۆ دادگای تایبەت",
    arabic:
      "عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل عقارات زەنگین المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات قانونية واللجوء إلى محكمة خاصة. ",
    english:
      "In case of inability to solve the problem of the first and second parties through negotiations then Zangin Company is not responsible and will not be responsible but the parties should solve the problem through legal proceedings and to go to a specialized court.",
  },
  /**
   * Sell contract balav
   */
  {
    user_key: "S_balav_1_1",
    kurdish: "من ",
    arabic: "إني ",
    english: "My name is ",
  },
  {
    user_key: "S_balav_1_2",
    kurdish:
      "خاوەن موڵك ڕەزامەندم بە فرۆشتنی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بە بڕی ",
    arabic: "صاحب الملك وافقت على بيع العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "the property owner, I agree to sell the above mentioned property with the amount of ",
  },
  {
    user_key: "S_balav_2",
    kurdish:
      "من لایەنی دووەم ڕەزامەندم بە كڕینی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بەبڕی ",
    arabic: "إني الطرف الثاني وافقت على شراء العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "Me as the second party, I agree to buy the above mentioned property with the amount of ",
  },
  {
    user_key: "S_balav_3_1",
    kurdish: "لایەنی دووەم بڕی ",
    arabic: "يدفع الطرف الثاني مبلغاً قدره",
    english: "The second party has paid the amount of ",
  },
  {
    user_key: "S_balav_3_2",
    kurdish: "رادەستی لایەنی یەکەم کرد وەکو پێشەکی",
    arabic: "إلى الطرف الأول كمقدمة",
    english: "to the first party as advance payment",
  },
  {
    user_key: "S_balav_4",
    kurdish: " بیدات بە لایەنی یەکەم بەم شێوەی خوارەوە دەدرێت (کاش-قسط)",
    arabic: "  إلى الطرف الأول على النحو التالي: (نقداً - أقساط).   ",
    english:
      "pay to the first party, will pay as the following (Cash- Installment)",
  },
  {
    user_key: "S_balav_5",
    kurdish:
      "لەسەر لایەنی یەكەم پێویستە ئەم موڵكە ڕادەستی لایەنی دووەم بكات دوای وەرگرتنی تەواوی شایستە داراییەکانی لە رێكەوتی",
    arabic:
      "على الطرف الأول تسليم العقار إلى الطرف الثاني بعد استلام كافة مستحقاته المالية  في ",
    english:
      "The first party should deliver this property to the second party after receiving all its financial entitlements in ",
  },
  {
    user_key: "S_balav_6",
    kurdish:
      "ئەگەر هاتوو لایەنی یەكەم لە رێكەوتی دیاریكرودا ئەو موڵكەی ڕادەستی لایەنی دووەم نەكرد ئەوە دەبێت پابەندبێت بێت بە پێدانی بڕی ",
    arabic:
      "في حال تأخر الطرف الأول من تسليم العقار إلى الطرف الثاني عليه دفع مبلغ قدره ",
    english:
      "If the first party didn’t deliver this property to the second party at the specified date, then it should commit to paying the amount of ",
  },
  {
    user_key: "S_balav_6_2",
    kurdish: "وەكوو پێبژاردن (غرامة) بۆ هەر رۆژێک",
    arabic: "كغرامة لكل يوم تأخير",
    english: "as fine for each day to the second party",
  },
  {
    user_key: "S_balav_7",
    kurdish:
      "لایەنی یەکەم لەئەستۆیەتی تا بەرواری رادەست کردنی موڵکەکە بە پێدانی هەر قەرزێک ئەگەر هەبێت لە خزمەتگوزاری ئاو کارەبا سەبارەت بە موڵکی ئاماژە پێکراو",
    arabic:
      "على الطرف الأول تصفية تكاليف ورسومات الماء والكهرباء أو أي قرض آخر قبل موعد تسليم العقار المذكور. ",
    english:
      "The first party is liable to pay for any debt of the services like electricity or water of the mentioned property if there is any until the date of delivering the property to the second party.",
  },
  {
    user_key: "S_balav_8",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێك بە هەر هۆیەك پاشگەز بێتەوە لەم گرێبەستە دەبێت  لایەنەكەی تر قەرەبوو بکاتەوە بە ",
    arabic: "في حال عدول أحد الاطراف، أياَ كان السبب، يجب دفع مبلغ قدره ",
    english:
      "If any party regretted from this contract due to any reason it should commit to pay the amount of ",
  },
  {
    user_key: "S_balav_8_2",
    kurdish:
      "وەكوو پێبژاردن  بە لایەنەكەی تروەکو قەرەبوو بەبێ چوون بۆ دادگا یان ناردنی هۆشداری. ئەم برگەیەش شایانی جێبەجێ کردنە لە بەرێوبەرایەتی جێبەجێکردنی سلێمانیراستەوخۆ وە بری قەرەبوەکەش عقارات زەنگین دیاری دەکات",
    arabic:
      "كغرامة وتعويض إلى الطرف الآخر دون الرجوع إلى المحكمة أو إرسال تبليغ. تصلح هذه الفقرة للتنفيذ في مديرية تنفيذ سلیماني مباشرة ويتم تحديد مبلغ التعويض عن طريق عقارات زەنگین",
    english:
      "as penalty to the other party as compensation without going to court or giving a notice. This clause is applicable in Slemani Directorate of Implementation directly, and the amount for compensation will be put by Zangin Company.",
  },
  {
    user_key: "S_balav_9",
    kurdish:
      "لایەنی یەکەم وە لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئاماژەپێکراو لەم گرێبەستە لەبەرامبەر فرۆشتنی ئەم موڵکە ",
    arabic:
      "يلتزم الطرف المسؤول عن البند (8) من هذا العقد بدفع 1% من سعر العقار إلى عقارات زەنگین بديلاً عن الطرفين. ",
    english:
      "Any party which is responsible in the clause (8) in this contract will automatically be committed to pay the amount of (1%) of the property price to Zangin Company instead of both parties.",
  },
  {
    user_key: "S_balav_10",
    kurdish:
      "تێچوو و ڕسوماتی فرۆشتن و گواستنەوە و جیاكردنەوە و یەكخستن و ڕاستكردنەوە و باجی خانووبەرە لەسەر لایەنی یەكەمە بیدات بەپێی یاسا ئەگەر تاپۆ بوو. بەڵام ئەگەر تاپۆ نەبوو لایەنی یەكەم پابەندە بە پێدانی بڕی تێچوی گواستنەوەی خاوەنداریەتی",
    arabic:
      "تقع تكاليف ورسومات البيع والنقل والفرز والتوحيد والتعديل وضريبة العقار على الطرف الأول وفق القانون إذا كان للعقار سند طابو. وفي حال لم يكن للعقار سند طابو على الطرف الأول دفع تكاليف نقل الملكية. ",
    english:
      "The expenses and fees for selling, transferring, separation, integration, correction and real estate tax will be paid by the first party according to Law if the property is registered on his/her name. But, if the property is not registered on his/her name then the first party is committed to paying all the expenses for transferring the ownership.",
  },
  {
    user_key: "S_balav_11",
    kurdish:
      "تێچووی ڕسوماتی كەشف و تۆماری عەقاری دەكەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵكەكە تاپۆ بوو. وە ئەگەر تاپۆ نەبوو ئەوە لایەنی دووەم بە پێدانی بڕی پارەی بەناوكردن",
    arabic:
      "يكون الطرف الثاني مسؤولاً عن تسديد رسومات الكشف والتسجيل العقاري وفق القانون في حال كان للعقار سند طابو، وإذا لم يكن للعقار سند طابو على طرف الثاني دفع تكاليف التسجيل. ",
    english:
      "The expenses for inspection and real estate registration will be paid by the second party according to law if the property is registered on his/her name. But, if the property is not registered on his/her name then the second party should pay for registration expenses.",
  },
  {
    user_key: "S_balav_12_1",
    kurdish:
      "پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر هاتوو مولکی فرۆشراو تاپۆی هەبوو پێویستە لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە پارێزەر",
    arabic:
      "بعد التوقيع على هذا العقد في حال كان للعقار المباع سند طابو، يجب على الطرف الأول منح وكالة إلى المحامي",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_balav_12_2",
    kurdish:
      "بەمەبەستی گواستنەوەی خاوەنداریەتی و تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم",
    arabic: "لغرض نقل الملكية وتسجيل العقار المباع لصالح الطرف الثاني. ",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_balav_13",
    kurdish:
      "لایەنی یەکەم وە لایەنی دووەم دوای واژوو کردنی گرێبەست مافی داواکردنی کۆمشنی پێدراویان نی یە ",
    arabic:
      "يتعهد الطرف الأول بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى عقارات زەنگین إزاء بيع العقار ",
    english:
      "The first party is committed to pay (1%) of the property price put in this contract to Zangin Company for selling this property.",
  },
  {
    user_key: "S_balav_14",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئامێژەپێکراو لەم گرێبەستە بە عقارات زەنگین لەبەرامبەر کرینی ئەم موڵکە ",
    arabic:
      "يتعهد الطرف الثاني بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى عقارات زەنگین إزاء بيع العقار ",
    english:
      "The second party is committed to pay (1%) of the property price put in this contact to Zangin Company for buying this property.",
  },
  {
    user_key: "S_balav_15",
    kurdish:
      "لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە بە پێویستە لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ کێشەکە چارەسەر بکەن. بەلام ئەگەر چارەسەر نەکرا ئەوا لەرێگەی دادگاکانی سلێمانی چارەسەر دەکرێ",
    arabic:
      "في حال حدوث أي نزاع حول مضمون هذا العقد على الطرفين حله عن طريق الحوار وإلا تكون محكمة سلیماني محل بتّ القضايا",
    english:
      "In case of any problem regarding the content of this contract, both parties should solve the problem based on negotiations. But if this didn’t help then it will be solved through Slemani Courts.",
  },
  {
    user_key: "Balance",
    kurdish: "باڵانس",
    arabic: "رصيد",
    english: "Balance",
  },
  {
    user_key: "Old Balance",
    kurdish: "باڵانسی کۆن",
    arabic: "رصيد قديم",
    english: "Old Balance",
  },
  {
    user_key: "New Balance",
    kurdish: "باڵانسی نوێ",
    arabic: "رصيد جديد",
    english: "New Balance",
  },
  {
    user_key: "Tenants_",
    kurdish: "کرێچیەکان",
    arabic: "المستأجرين",
    english: "Tenants",
  },
  {
    user_key: "Action",
    kurdish: "کردارەکان",
    arabic: "افعال",
    english: "Action",
  },
  {
    user_key: "eleven_rent",
    kurdish:
      "لایەنی دووەم ناتوانێت داوای گەڕانەوەی پارەی کرێی دراو بکات لە دوای واژوو کردنی گرێبەست به هیچ شێوەیەک،تا دووبارە بەکرێ دانەوەی بە لایەنێکی تر ئەم ماوەیە کە پێویستە بۆ بە کرێدانەوەی دەکەوێتە ئەستۆی لایەنی دووەم",
    arabic:
      "لايحق للطرف الثاني بمطالبة مبلغ الايجار المدفوع بعد التوقيع على العقد بأى شكل, لحين تاجيرهالى طرف ثالث أخر و أن المدة ھذه تكون على حساب الطرف الثاني.",
    english:
      "The second party can`t order given retrieval money anyway after signing contract, till to give it rent again to another party in this period will be at the expense of the second party.",
  },
  {
    user_key: "by the company",
    kurdish: " بە کۆمپانیای",
    arabic: "من قبل الشركة",
    english: "by the company",
  },
  {
    user_key: "twelve_rent_one",
    kurdish:
      "لەسەر لایەنی دووەم پێویستە خاوەن موڵک یان عقارات زەنگین ئاگادار بکاتەوە مانگێک پێش دەرچوون یان کۆتایی هاتنی گرێبەستەکە بە پێچەوانەوە دەبێت کرێی یەک مانگ بدات بە لایەتی یەکەم.",
    arabic:
      "على الطرف الثاني تبليغ الطرف الاول او عقارات زەنگین قبل شھر من الاخلاء أو انتھاء مدةالعقد و بعكسه يجب دفع ايجار شھر الى الطرف الاول.",
    english:
      "The second party must warn the property owner or Zangin Real Estate Company a month before leaving.",
  },
  {
    user_key: "Warn him",
    kurdish:
      "ئاگادار باکاتەوە بەپێچەوانەوە دەبێت کرێی یەک مانگ بدات بە لایەنی یەکەم",
    arabic: "حذره",
    english: "Warn him",
  },
  {
    user_key: "therteen_rent",
    kurdish:
      "هەرکاتێک ئەم موڵکە کڕین و فرۆشتنی پێوەکرا نابێت کرێچی ببێتە بەربەست لەپێش مامەڵەکە،دەبێت لەماوەی مانگێک بۆ دوو مانگ موڵکەکە ڕادەستی لایەنی یەکەم بکات، بەمەرجێک فرۆشیار تێچووی گواستنەوەکە بگرێتە ئەستۆ.",
    arabic:
      "في حال بيع الشراء الملك لازم الطرف الثاني يقبل بإخلاء الملك خلال شھر أو شھرين بدون إعتراض",
    english:
      "If the estate will be selling or buying at any time for any reason the second party must be agreed to leave this property after amonth to two months, but the first party must pay the amount of transportation to the second party.",
  },
  {
    user_key: "therteen_rent_two",
    kurdish: "لەبەرامبەر ڕێکخستنی ئەم گرێبەستە",
    arabic: "مقابل ترتيب هذا العقد",
    english: "In return for arranging this contract",
  },
  {
    user_key: "17_rent_one",
    kurdish:
      "لایەنی دووەم پێش ڕادەستکردنی موڵکەکە پێویستە لەسەر ئەستۆی خۆی کلیلی دەرگا دەرەکیەکان بگۆڕێ ، بەپێچەوانەوە هەرکێشەیەک رووبدات خۆی بەرپرسیارە",
    arabic:
      "من الضروري على الجانب الثاني قبل شهر من مغادرة أو نهاية عقد المالك والشركة",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "14_rent_one",
    kurdish:
      "هەردوو لایەن پابەندن بە پێدانی کرێی نیو مانگ بۆ عقارات زەنگین لە بەرامبەر ڕێکخستنی ئەم گرێبەستە.",
    arabic:
      "الطرفان يلتزمان بدفع ايجار نصف شھر الى عقارات زەنگین مقابل تنظيمھا العقد",
    english:
      "Both parties binding to give half month rent to Zangin Real Estate Company against organizing this contract.",
  },
  {
    user_key: "table_display",
    kurdish: "هیچ تۆمارکردنێک نیە",
    arabic: "لا توجد ملفات لعرضها",
    english: "There is no record to display",
  },
  {
    user_key: "14_rent_one",
    kurdish: "ئەم گرێبەستە لە سێزدە بەند پێکهاتووە. ",
    arabic:
      "من الضروري على الجانب الثاني قبل شهر من مغادرة أو نهاية عقد المالك والشركة",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "15_rent_one",
    kurdish:
      "لەکاتی بوونی هەرکێشەیەک لەم گرێبەستەدا، دادگای سلێمانی کێشەکە یەکلایی دەکاتەوە.",
    arabic:
      "من الضروري على الجانب الثاني قبل شهر من مغادرة أو نهاية عقد المالك والشركة",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  {
    user_key: "16_rent_one",
    kurdish:
      "لەکاتی فرۆشتنی ئەم موڵکە خاوەنی نوێ دەبێ پابەند بێت بەناوەڕۆکی ئەم گرێبەستە",
    arabic:
      "من الضروري على الجانب الثاني قبل شهر من مغادرة أو نهاية عقد المالك والشركة",
    english:
      "It is necessary on the second side a month before the departure or the end of the contract of the owner and company",
  },
  /**
   * Psulay parawargrtn wasl
   */
  {
    user_key: "taking money",
    kurdish: "پارەوەرگرتن",
    arabic: "أخذ المال.",
    english: "taking money",
  },
  {
    user_key: "list taking money",
    kurdish: "لیستی پارەوەرگرتن",
    arabic: "قائمة أخذ المال",
    english: "List of taking money",
  },
  {
    user_key: "Monthly rent invoice",
    kurdish: "کرێی مانگانە",
    arabic: "فواتير الإيجار الشهري",
    english: "Monthly rent invoice",
  },
  {
    user_key: "Service Bill",
    kurdish: "خزمەتگوزاری",
    arabic: "فواتير الخدمات",
    english: "Service Bill",
  },
  {
    user_key: "Insurance Bill",
    kurdish: "دڵنیایی",
    arabic: "التأمين",
    english: "Insurance Bill",
  },
  {
    user_key: "Instead of",
    kurdish: "لە بری",
    arabic: "بدلاً من",
    english: "Instead of",
  },
  {
    user_key: "Normal_Agent",
    kurdish: "کارمەندی ئاسایی",
    arabic: "موظف عادي",
    english: "Regular Employee",
  },
  {
    user_key: "normal_agent",
    kurdish: "کارمەندی ئاسایی",
    arabic: "موظف عادي",
    english: "Regular Employee",
  },
  {
    user_key: "money",
    kurdish: "بڕی پارە",
    arabic: "مبلغ من المال",
    english: "money",
  },
  {
    user_key: "received from Mr",
    kurdish: "وەرگیرا لە بەڕێز",
    arabic: "وردت من السيد",
    english: "Received From Mr",
  },
  {
    user_key: "Company Branch",
    kurdish: "لقی کۆمپانیا",
    arabic: "فرع الشركة",
    english: "Branch",
  },
  {
    user_key: "Lease date",
    kurdish: "ڕێکەوتی بەکرێدان",
    arabic: "تاريخ التأجير",
    english: "Lease date",
  },
  {
    user_key: "end of the lease",
    kurdish: "ڕێکەوتی کۆتایی کرێ",
    arabic: "تاريخ انتهاء عقد الإيجار",
    english: "end of the lease",
  },
  {
    user_key: "Payer Signature",
    kurdish: "ئیمزای پارەدەر",
    arabic: "توقيع دافع",
    english: "Payer Signature",
  },
  {
    user_key: "Name of the recipient",
    kurdish: "ناوی پارە وەرگر",
    arabic: "اسم المستلم",
    english: "Name of the recipient",
  },
  {
    user_key: "Recipient's signature seal",
    kurdish: "مۆرو ئیمزای وەرگر",
    arabic: "ختم توقيع المستلم",
    english: "Recipient's signature",
  },
  {
    user_key: "dolar",
    kurdish: "دۆلار",
    arabic: "دولار",
    english: "dolar",
  },
  {
    user_key: "dinar",
    kurdish: "دینار",
    arabic: "دینار",
    english: "dinar",
  },
  {
    user_key: "no records",
    kurdish: "هیچ تۆمارێک نییە بۆ پیشاندانی",
    arabic: "لا توجد سجلات لعرضها",
    english: "there are no records to display",
  },
  {
    user_key: "Currency Type",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "Currency",
  },
  {
    user_key: "Commission_sold",
    kurdish: "عمولة",
    arabic: "عمولة",
    english: "Commission",
  },
  //
  {
    user_key: "one tenant's contract",
    kurdish: "گرێبەستی یەک کرێچی",
    arabic: "عقد مستأجر واحد",
    english: "One Tenant's Contract",
  },
  {
    user_key: "one tenant's bill",
    kurdish: "پسوولەی یەک کرێچی",
    arabic: "فاتورة مستأجر واحد",
    english: "One Tenant's Bill",
  },
  {
    user_key: "Currency Type",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "Currency Type",
  },
  // dashboard
  {
    user_key: "newest sell contract",
    kurdish: "نوێترین گرێبەستی فرۆشتن",
    arabic: "أحدث عقد بيع",
    english: "Newest Sell Contract",
  },
  {
    user_key: "newest rent contract",
    kurdish: "نوێترین گرێبەستی کرێ",
    arabic: "أحدث عقد إيجار",
    english: "Newest Rent Contract",
  },
  {
    user_key: "The latest bill to receive money",
    kurdish: "تازەترین پسوڵەی پارەوەرگرتن",
    arabic: "آخر فاتورة لتلقي المال",
    english: "The latest Bill to Receive Money",
  },
  {
    user_key: "Newest Sale Property",
    kurdish: "نوێترین موڵکی فرۆشتن",
    arabic: "أحدث بيع العقارات",
    english: "Newest Sale Property",
  },
  {
    user_key: "The newest rental property",
    kurdish: "نوێترین موڵکی کرێ",
    arabic: "أحدث عقار للإيجار",
    english: "The newest rental property",
  },
  {
    user_key: "Number of properties",
    kurdish: "ژمارەی موڵکەکان",
    arabic: "عدد العقارات",
    english: "Number of Properties",
  },
  {
    user_key: "Number of property",
    kurdish: "ژمارەی موڵک",
    arabic: "عدد العقار",
    english: "Number of Property",
  },
  {
    user_key: "Total Sales",
    kurdish: "کۆی فرۆشتنەکان",
    arabic: "إجمالي المبيعات",
    english: "Total Sales",
  },
  // raports
  {
    user_key: "start_d",
    kurdish: "بەرواری سەرەتا",
    arabic: "تاريخ البدء ",
    english: "Start Date",
  },
  {
    user_key: "end_d",
    kurdish: "بەرواری کۆتا",
    arabic: "تاريخ الانتهاء ",
    english: "End Date",
  },
  {
    user_key: "search_d",
    kurdish: "گەڕان بە پێی ڕۆژ",
    arabic: "البحث باليوم",
    english: "Search By Date",
  },
  {
    user_key: "weekly_report",
    kurdish: "ڕاپۆرتی هەفتانە",
    arabic: "تقرير أسبوعي",
    english: "Weekly Report",
  },
  {
    user_key: "s_reports",
    kurdish: "راپۆرتەکان",
    arabic: "التقارير",
    english: "Reports",
  },
  {
    user_key: "search_m",
    kurdish: "گەڕان بە پێی مانگ",
    arabic: "البحث بالشهر",
    english: "Search By Month",
  },
  {
    user_key: "Earth",
    kurdish: "زەوی",
    arabic: "أرض",
    english: "Earth",
  },
  {
    user_key: "search_y",
    kurdish: "گەڕان بە پێی ساڵ",
    arabic: "البحث بالسنة",
    english: "Search By Year",
  },
  {
    user_key: "Completion rental contract",
    kurdish: "تەواوبونی گرێبەستی کرێ",
    arabic: "إتمام عقد الإيجار",
    english: "Completion rental",
  },
  {
    user_key: "Rental contract report",
    kurdish: "ڕاپۆرتی گرێبەستی کرێ",
    arabic: "تقرير عقد الإيجار",
    english: "Rental contract report",
  },
  {
    user_key: "Sales Contract Report",
    kurdish: "ڕاپۆرتی گرێبەستی فرۆشتن",
    arabic: "تقرير عقد البيع",
    english: "Sales Contract Report",
  },
  {
    user_key: "MY TO DO LIST",
    kurdish: "ئەوکارانەی پێووستە ئەنجامی بدەم",
    arabic: "ما يجب أن أفعله",
    english: "MY TO DO LIST",
  },
  /// masrufat
  {
    user_key: "Expenses",
    kurdish: "خەرجیەکان",
    arabic: "مصروفات",
    english: "Expenses",
  },
  {
    user_key: "Cost type",
    kurdish: "جۆری خەرجی",
    arabic: "نوع التكلفة",
    english: "Cost type",
  },
  {
    user_key: "Total money.",
    kurdish: "کۆی پارە",
    arabic: "مجموع المال.",
    english: "Total money.",
  },
  {
    user_key: "Total money $",
    kurdish: "$ کۆی پارە بە",
    arabic: "$ مجموع المال",
    english: "Total money $",
  },
  {
    user_key: "Total money ID",
    kurdish: "ID کۆی پارە بە",
    arabic: "ID مجموع المال",
    english: "Total money ID",
  },
  {
    user_key: "Expenses List",
    kurdish: "لیستی خەرجییەکان",
    arabic: "قائمة المصروفات",
    english: "Expenses List",
  },
  {
    user_key: "Amount of money",
    kurdish: "بڕی پارە",
    arabic: "مبلغ من المال",
    english: "Amount of money",
  },
  {
    user_key: "Profit",
    kurdish: "قازانج",
    arabic: "ربح",
    english: "Profit",
  },

  {
    user_key: "Main Form",
    kurdish: "فۆڕمی سەرەکی",
    arabic: "النموذج الرئيسي",
    english: "Main Form",
  },
  {
    user_key: "Secondary Form",
    kurdish: "فۆڕمی لاوەکی",
    arabic: "النموذج الثانوي",
    english: "Secondary Form",
  },
  {
    user_key: "Choose the type of rental contract",
    kurdish: "شێوازی جۆری گرێبەستی کرێ هەڵبژێرە",
    arabic: "اختيار نوع عقد الإيجار",
    english: "Choose the type of rental contract",
  },
  {
    user_key: "On the date of",
    kurdish: "لە ڕێکەوتی",
    arabic: "في تاريخ",
    english: "On the date of",
  },
  {
    user_key: "For a date",
    kurdish: "بۆ ڕێکەوتی",
    arabic: "لموعد",
    english: "For a date",
  },
  {
    user_key: "Rental period",
    kurdish: "ماوەی بەکرێدان",
    arabic: "فترة الإيجار",
    english: "Rental period",
  },
  {
    user_key: "Date of surrender",
    kurdish: "ڕێکەوتی ڕادەستکردن",
    arabic: "تاريخ الاستسلام",
    english: "Date of surrender",
  },
  {
    user_key: "amount of money in advance",
    kurdish: "بڕی پارە پێشەکی",
    arabic: "مبلغ من المال مقدما",
    english: "Amount of Money in Advance",
  },
  {
    user_key: "Buy_Required_translation",
    kurdish: "کڕین",
    arabic: "شراء",
    english: "Buy",
  },
  {
    user_key: "Support",
    kurdish: "پشتگیری",
    arabic: "تءيد",
    english: "Support",
  },
  {
    user_key: "Arabun",
    kurdish: "عربون",
    arabic: " عربون",
    english: "Arabun",
  },
  {
    user_key: "Amount of punishment",
    kurdish: "بڕی سزا",
    arabic: "مقدار العقوبة",
    english: "Amount of punishment",
  },
  {
    user_key: "Choose the type of sales contract",
    kurdish: "شێوازی جۆری گرێبەستی فرۆشتن هەڵبژێرە",
    arabic: "اختيار نوع عقد البيع",
    english: "Choose the type of sales contract",
  },
  {
    user_key: "Payment date",
    kurdish: "ڕێکەوتی پارەدان",
    arabic: "تاريخ الدفع",
    english: "Payment date",
  },
  {
    user_key: "Bills",
    kurdish: "پسوولەکان",
    arabic: "فواتير",
    english: "Bills",
  },
  {
    user_key: "representer",
    kurdish: "ناوی نوێنەر",
    arabic: "اسم الممثل",
    english: "Representer",
  },
  {
    user_key: "Ok",
    kurdish: "باشە",
    arabic: "جید",
    english: "Ok",
  },
  {
    user_key: "success",
    kurdish: "سەرکەوتووبوو",
    arabic: "ناجحا",
    english: "success",
  },
  {
    user_key: "You successfully tainted your work",
    kurdish: "کارەکەت بە سەرکەوتوویی تاواوکرد.",
    arabic: "لقد نجحت في تلويث عملك",
    english: "You successfully tainted your work",
  },
  {
    user_key: "Are you sure",
    kurdish: "ئایا دڵنیایت؟",
    arabic: "هل أنت متأكد؟",
    english: "Are you sure?",
  },
  {
    user_key: "You won't be able to delete this!",
    kurdish: "دەتەوێ بیسڕیتەوە",
    arabic: "تريد حذفه",
    english: "You want to delete it.!",
  },
  {
    user_key: "Yes, delete it",
    kurdish: "بەڵێ، بسڕەوە.",
    arabic: "نعم، احذفه",
    english: "Yes, delete it",
  },
  {
    user_key: "You won't be able to Active this!",
    kurdish: "دەتەوێ چاڵاکی بکەیتەوە",
    arabic: "تريد تنشيطه",
    english: "You want to Active it.!",
  },
  {
    user_key: "Yes, Active it",
    kurdish: "بەڵێ، چاڵاکی بکەوە.",
    arabic: "نعم، تنشيطه",
    english: "Yes, Active it",
  },
  {
    user_key: "Yes",
    kurdish: "بەڵێ",
    arabic: "نعم.",
    english: "Yes.",
  },
  {
    user_key: "No",
    kurdish: "نەخێر",
    arabic: "لا",
    english: "No",
  },
  {
    user_key: "Add_delete",
    kurdish: "سڕینەوە",
    arabic: "مسح تعلیق",
    english: "Delete",
  },
  {
    user_key: "Delete",
    kurdish: "سڕایەوە",
    arabic: "محذوف",
    english: "Delete",
  },
  {
    user_key: "Active_",
    kurdish: "چاڵاککرایەوە",
    arabic: "نشط",
    english: "Active",
  },
  {
    user_key: "delete",
    kurdish: "سڕایەوە",
    arabic: "محذوف",
    english: "delete",
  },
  {
    user_key: "Payment bills",
    kurdish: "پسوولەی پارەدان",
    arabic: "فواتير الدفع",
    english: "Recieved",
  },
  {
    user_key: "Choose the type of payment or payment bill type",
    kurdish: "شێوازی جۆری پسوولەی پارەدان یان پارەوەرگرتن هەڵبژێرە",
    arabic: "اختيار نوع الدفع أو نوع فاتورة الدفع",
    english: "Choose the type of payment or payment bill type",
  },
  {
    user_key: "such as",
    kurdish: "وەکو",
    arabic: "مثل",
    english: "such as",
  },
  {
    user_key: "Number of bills",
    kurdish: "ژمارەی پسوولە",
    arabic: "عدد الفواتير",
    english: "Number of bills",
  },
  {
    user_key: "Security Bill",
    kurdish: "پسوولەی ئاسایش",
    arabic: "فواتير الاسايش",
    english: "Security Bill",
  },
  {
    user_key: "to the security base",
    kurdish: "بۆ بنکەی ئاسایشی",
    arabic: "إلى قاعدة الأمن.",
    english: "to the security base",
  },
  {
    user_key: "security base",
    kurdish: "بنکەی ئاسایشی",
    arabic: "قاعدة الأمن",
    english: "Security Base",
  },
  {
    user_key: "Company Name",
    kurdish: "ناوی کۆمپانیا",
    arabic: "اسم الشركة",
    english: "Company Name",
  },
  {
    user_key: "Company mobile number",
    kurdish: "ژمارەی مۆبایلی کۆمپانیا",
    arabic: "رقم الهاتف المحمول الشركة",
    english: "Company mobile number",
  },
  {
    user_key: "The name of the tenant",
    kurdish: "ناوی کرێچی",
    arabic: "اسم المستأجر",
    english: "Tenant Name",
  },
  {
    user_key: "where they came",
    kurdish: "شوێنی هاتن",
    arabic: "حيث أتوا",
    english: "where they came",
  },
  {
    user_key: "The name of the neighborhood",
    kurdish: "ناوی گەڕەک",
    arabic: "اسم الحي",
    english: "Alley Name",
  },
  {
    user_key: "Seating",
    kurdish: "شوێنی نیشتەجێبوون",
    arabic: "موقع",
    english: "Location",
  },
  {
    user_key: "We're like",
    kurdish: "ئێمە وەکــو ",
    arabic: "نحن مثل",
    english: "We're like ",
  },
  {
    user_key: `asawesh`,
    kurdish: `.پابەندیــن بە گشت یاسا و ڕینمایەکانــی لایەنیـی پەیوەنـدی دار "ئاسایش"، و دوور دەبیــن لە کاری نا یاسایی`,
    arabic: `.نحن نلتزم بجميع القوانين واللوائح المتعلقة بشجرة "الأمن"، ونتجنب الأعمال غير القانونية`,
    english: `We abide by all laws and regulations related to the "security" tree, and avoid illegal acts.`,
  },
  {
    user_key: "fee",
    kurdish: "وەکو پێبژاردن (غرامة).",
    arabic: " غرامة",
    english: "as a penalty",
  },
  {
    user_key: "paray_mawa",
    kurdish: "پێویستە بدرێت لە ڕێكەوتی ",
    arabic: "نوع العملة",
    english: "paray_mawa",
  },
  {
    user_key: "recive_money",
    kurdish: "پارەی ماوە",
    arabic: "مال متبقي",
    english: "Money left",
  },
  {
    user_key: "Amount of dissuade",
    kurdish: "بڕی پاشگەزبوونەوە",
    arabic: "مقدار الثني",
    english: "Amount of dissuade",
  },
  {
    user_key: "Lawyer's name",
    kurdish: "ناوی پارێزەر",
    arabic: "اسم المحامي",
    english: "Lawyer's name",
  },
  {
    user_key: "as introduction for month",
    kurdish: "وەردەگرم وەک پێشەکی",
    arabic: "كمقدمة ",
    english: "I take as an down payment",
  },
  {
    user_key: "new_ten_rule",
    kurdish:
      "ناکرێت واز لەم ڕێکەوتننامەیە بهێنرێت (یاخود دەستی لێهەڵبگیرێت) لە بەشێک یان هەموو بەشەکانی ئەم گرێبەستە بۆ کرێدارێکی تر یاخود هەر کەسێکی تر بەبێ ڕەزامەندی خاوەنەکەی.",
    arabic:
      "لا يمكن للجانب الآخر إجراء أي تغييرات داخل وخارج هذه الخاصية دون موافقة مالك العقار",
    english:
      "The other side cannot make any changes inside and outside this property without the consent of the owner of the property",
  },
  {
    user_key: "once a month in advance",
    kurdish: "مانگ جارێک پێشەکی",
    arabic: "مرة واحدة في الشهر مقدما",
    english: "once a month in advance",
  },
  {
    user_key: "Security Bill List",
    kurdish: "لیستی پسوولەی ئاسایش",
    arabic: "قائمة فاتورة الأمان",
    english: "Security Bill List",
  },
  {
    user_key: "List of Bills",
    kurdish: "لیستی پسوولەکان",
    arabic: "قائمة الفواتير",
    english: "List of Bills",
  },
  {
    user_key: "Payments List",
    kurdish: "لیستی پارەپێدانەکان",
    arabic: "قائمة المدفوعات",
    english: "Payments List",
  },
  {
    user_key: "Please Check Inputs",
    kurdish: "تکایە خانەکان پڕبکەوە",
    arabic: "الرجاء تعبئة الخلايا",
    english: "Please Check Inputs",
  },
  {
    user_key: "Login",
    kurdish: "چوونەژوورەوە",
    arabic: "تسجيل الدخول",
    english: "Login",
  },
  {
    user_key: "View Agent",
    kurdish: "بینینی وەکیلەکان",
    arabic: "عرض عامل",
    english: "View Agent",
  },
  {
    user_key: "TIP",
    kurdish: "تایپ",
    arabic: "تایب",
    english: "TIP",
  },
  {
    user_key: "View_Agent",
    kurdish: "بینینی وەکیل",
    arabic: "عرض عامل",
    english: "View Agent",
  },
  {
    user_key: "View Branch",
    kurdish: "بینینی لق",
    arabic: "عرض الفرع",
    english: "View Branch",
  },
  {
    user_key: "Admin",
    kurdish: "بەڕێوەبەر",
    arabic: "التحكم",
    english: "Admin",
  },
  {
    user_key: "Sceurity Anket",
    kurdish: "ئەنکێتی ئاسایش",
    arabic: "تأمينات",
    english: "Security Anket",
  },
  {
    user_key: "List of Seller Anket",
    kurdish: "لیستی ئەنکێتی کڕیار",
    arabic: "لیستی ئەنکێتی کڕیار",
    english: "List of Seller Anket",
  },
  {
    user_key: "Create Admin",
    kurdish: "دروستکردنی بەڕێوەبەر",
    arabic: " اضافة مشرف",
    english: "Create Admin",
  },
  {
    user_key: "List Admins",
    kurdish: "لیستی بەڕێوەبەرەکان",
    arabic: "قائمة المشرفين",
    english: "List Admins",
  },
  {
    user_key: "List Roles",
    kurdish: "لیستی دەسەڵاتەکان",
    arabic: "قائمة الأدوار",
    english: "List Roles",
  },
  {
    user_key: "Full Name",
    kurdish: "ناوی تەواو",
    arabic: "الاسم الكامل",
    english: "Full Name",
  },
  {
    user_key: "Create Project",
    kurdish: "دروستکردنی پرۆژە",
    arabic: "اضافة مشروع",
    english: "Create Project",
  },
  {
    user_key: "Projects",
    kurdish: "پرۆژەکان",
    arabic: "المشاريع",
    english: "Projects",
  },
  {
    user_key: "Project Name(Kurdish)",
    kurdish: "ناوی پرۆژە (کوردی)",
    arabic: "اسم المشروع (الكردية)",
    english: "Project Name (Kurdish)",
  },
  {
    user_key: "Project Name(English)",
    kurdish: "ناوی پرۆژە (ئینگلیزی)",
    arabic: "اسم المشروع (الإنجليزية)",
    english: "Project Name (English)",
  },
  {
    user_key: "Project Name(Arabic)",
    kurdish: "ناوی پرۆژە (عەرەبی)",
    arabic: "اسم المشروع (عربي)",
    english: "Project Name (Arabic)",
  },
  {
    user_key: "Project Name",
    kurdish: "ناوی پرۆژە",
    arabic: "اسم المشروع",
    english: "Project Name ",
  },
  {
    user_key: "Vellas List",
    kurdish: "لیستی ڤێلاکان",
    arabic: "قائمة فیلا",
    english: "List Vella",
  },
  {
    user_key: "Vellas_",
    kurdish: "ڤێلاکان",
    arabic: "فیلا",
    english: "Vellas",
  },
  {
    user_key: "About Project(Kurdish)",
    kurdish: "دەربارەی پڕۆژە (کوردی)",
    arabic: "عن المشروع (الكردية)",
    english: "About Project (Kurdish)",
  },
  {
    user_key: "About Project(Arabic)",
    kurdish: "دەربارەی پڕۆژە (عربي)",
    arabic: "عن المشروع (عربي)",
    english: "About Project (Arabic)",
  },
  {
    user_key: "About Project(English)",
    kurdish: "دەربارەی پڕۆژە (ئینگلیزی)",
    arabic: "عن المشروع (الإنجليزية)",
    english: "About Project (English)",
  },
  {
    user_key: "Block",
    kurdish: "بینایە",
    arabic: "عماره",
    english: "Block",
  },
  {
    user_key: "block",
    kurdish: "بینایە",
    arabic: "عماره",
    english: "Block",
  },
  {
    user_key: "floor",
    kurdish: "قاتی",
    arabic: "طابق",
    english: "Floor",
  },
  {
    user_key: "Show Password",
    kurdish: "پیشاندانی پاسۆرد",
    arabic: "إظهار كلمة المرور",
    english: "Show Password",
  },
  {
    user_key: "flour",
    kurdish: "قاتی",
    arabic: "طابق",
    english: "Floor",
  },
  {
    user_key: "‌Number_",
    kurdish: "ژمارەی شوقە",
    arabic: "رقم شوقة",
    english: "Apartment No",
  },
  {
    user_key: "imageUrl",
    kurdish: "وێنە",
    arabic: "صورة",
    english: "Image",
  },
  {
    user_key: "NumberOfShuqa",
    kurdish: "ژمارەی شوقە",
    arabic: "رقم شوقة",
    english: "Apartment No",
  },
  {
    user_key: "Area_",
    kurdish: "م²/ ڕووبەر ",
    arabic: "المساحة / م²",
    english: "Area/m²",
  },
  {
    user_key: "Meter price",
    kurdish: "نرخی مەتر $",
    arabic: "سعر المتر $",
    english: "Meter Price $",
  },
  {
    user_key: "Block Entry",
    kurdish: "داخڵکردنی شووقە",
    arabic: "إدخال شووقە",
    english: "Block Entry",
  },
  {
    user_key: "Percentage Entry",
    kurdish: "داخڵکردنی ڕێژە",
    arabic: "إدخال النسبة المئوية",
    english: "Percentage Entry",
  },
  {
    user_key: "purpose",
    kurdish: "مەبەست",
    arabic: "قصد",
    english: "Purpose",
  },
  {
    user_key: "Number of Months",
    kurdish: "ژمارەی مانگەکان",
    arabic: "عدد الشهور",
    english: "Number of Months",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "دفعات شهرية",
    english: "Monthly Payments",
  },
  {
    user_key: "Project_List",
    kurdish: "لیستی پڕۆژەکان",
    arabic: "قائمة المشاريع",
    english: "List Projects",
  },
  {
    user_key: "MetrPrice",
    kurdish: "نرخی فرۆشتن",
    arabic: "سعر المتر",
    english: "MetrPrice",
  },
  {
    user_key: "MetrPrice sell",
    kurdish: "نرخی مەتر(فرۆشتن)",
    arabic: "سعر المتر(البیع)",
    english: "MetrPrice Sell",
  },
  {
    user_key: "totalBase",
    kurdish: "کۆی گشتی",
    arabic: "المجموع الكلي",
    english: "totalBase",
  },
  {
    user_key: "diffrence",
    kurdish: "جیاوازی",
    arabic: "فوارق",
    english: "diffrence",
  },
  {
    user_key: "MonthlyShortPay",
    kurdish: "بڕی قیستی مانگانە",
    arabic: "نوع العملة",
    english: "MonthlyShortPay",
  },
  {
    user_key: "salePerMetr",
    kurdish: "نرخی بازاڕ",
    arabic: "سعر السوق",
    english: "salePerMetr",
  },
  {
    user_key: "total",
    kurdish: "کۆی گشتی دوای نرخی بازاڕ",
    arabic: "المجموع بعد أسعار السوق",
    english: "total",
  },
  {
    user_key: "NumberMonth",
    kurdish: "ژمارەی مانگەکان",
    arabic: "عدد الشهور",
    english: "NumberMonth",
  },
  {
    user_key: "language",
    kurdish: "زمان",
    arabic: "اللغة",
    english: "Language",
  },
  {
    user_key: "Side",
    kurdish: "ڕوو",
    arabic: "واجهە",
    english: "View",
  },
  {
    user_key: "such_as",
    kurdish: "وەک",
    arabic: "مثل",
    english: "such as",
  },
  {
    user_key: "It was given to sir",
    kurdish: "درا بە بەڕێز",
    arabic: "لقد أعطيت إلى سيدي",
    english: "It was given to sir",
  },
  {
    user_key: "Introduction",
    kurdish: "پێشەکی",
    arabic: "مقدمة",
    english: "Introduction",
  },
  {
    user_key: "Expenses $",
    kurdish: "خەرجی بە دۆلار",
    arabic: "النفقات $",
    english: "Expenses $",
  },
  {
    user_key: "Expenses ID",
    kurdish: "خەرجی بە دینار",
    arabic: "النفقات ID",
    english: "Expenses ID",
  },
  {
    user_key: "Down payment",
    kurdish: "پێشەکی",
    arabic: "مقدمة",
    english: "Down payment",
  },
  {
    user_key: "Structure",
    kurdish: "هەیکەل",
    arabic: "هيكل",
    english: "Structure",
  },
  {
    user_key: "Receiving the key",
    kurdish: "وەرگرتنی کلیل",
    arabic: "أستلام",
    english: "Receiving the key",
  },
  {
    user_key: "Remaining amount",
    kurdish: "بڕی ماوە",
    arabic: "المبلغ المتدبقي",
    english: "Remaining amount",
  },
  {
    user_key: "KPI Report",
    kurdish: "ڕاپۆرتی KPI",
    arabic: "تقرير KPI",
    english: "KPI Report",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "",
    kurdish: "جۆری دراو",
    arabic: "نوع العملة",
    english: "",
  },
  {
    user_key: "پازدەم",
    kurdish: "پازدەم",
    arabic: "خمسة عشر",
    english: "15",
  },
  {
    user_key: "شازدەم",
    kurdish: "شازدەم",
    arabic: "ستة عشر",
    english: "16",
  },
  {
    user_key: "حەڤدەم",
    kurdish: "حەڤدەم",
    arabic: "سابع عشر",
    english: "17",
  },
  {
    user_key: "نۆزدەم",
    kurdish: "نۆزدەم",
    arabic: "التاسع عشر",
    english: "19",
  },
  {
    user_key: "هەژدەم",
    kurdish: "هەژدەم",
    arabic: "ثامن عشر",
    english: "18",
  },
  {
    user_key: "چواردەم",
    kurdish: "چواردەم",
    arabic: "الرابع عشر",
    english: "14",
  },
  {
    user_key: "سیانزەم",
    kurdish: "سیانزەم",
    arabic: "الثالث عشر",
    english: "13",
  },
  {
    user_key: "دوانزەم",
    kurdish: "دوانزەم",
    arabic: "الثاني عشر",
    english: "12",
  },
  {
    user_key: "یانزەم",
    kurdish: "یانزەم",
    arabic: "الحادي عشر",
    english: "11",
  },
  {
    user_key: "دەیەم",
    kurdish: "دەیەم",
    arabic: "العاشر",
    english: "10",
  },
  {
    user_key: "نۆیەم",
    kurdish: "نۆیەم",
    arabic: "التاسع",
    english: "9",
  },
  {
    user_key: "هەشتەم",
    kurdish: "هەشتەم",
    arabic: "الثامن",
    english: "8",
  },
  {
    user_key: "حەوتەم",
    kurdish: "حەوتەم",
    arabic: "السابع",
    english: "7",
  },
  {
    user_key: "شەشەم",
    kurdish: "شەشەم",
    arabic: "السادس",
    english: "6",
  },
  {
    user_key: "پێنجەم",
    kurdish: "پێنجەم",
    arabic: "الخامس",
    english: "5",
  },
  {
    user_key: "چوارەم",
    kurdish: "چوارەم",
    arabic: "الرابع",
    english: "4",
  },
  {
    user_key: "سێیەم",
    kurdish: "سێیەم",
    arabic: "الثالث",
    english: "3",
  },
  {
    user_key: "دووەم",
    kurdish: "دووەم",
    arabic: "الثاني",
    english: "2",
  },
  {
    user_key: "یەکەم",
    kurdish: "یەکەم",
    arabic: "الأول",
    english: "1",
  },
  // new
  {
    user_key: "Company",
    kurdish: "پێشانگا",
    arabic: "معرض",
    english: "Company",
  },
  {
    user_key: "Hotel",
    kurdish: "هۆتێل",
    arabic: "فندق",
    english: "Hotel",
  },
  {
    user_key: "Commercial Land",
    kurdish: "زەوی بازرگانی",
    arabic: "أرض تجارية",
    english: "Commercial Land",
  },
  {
    user_key: "Car Garage",
    kurdish: "گەراجی ئۆتۆمبێل",
    arabic: "كراج سيارات",
    english: "Car Garage",
  },
  {
    user_key: "Stadium",
    kurdish: "یاریگا",
    arabic: "ملعب",
    english: "Stadium",
  },
  {
    user_key:
      "Please make sure you fill out the branch name and all required information",
    kurdish:
      "تکایە دڵنیابە لە پڕکردنەوەی ناوی لقەکەو هەموو زانیارییە پێویستەکان.",
    arabic: "يرجى التأكد من ملء اسم الفرع وجميع المعلومات المطلوبة",
    english:
      "Please make sure you fill out the branch name and all required information",
  },
  /**
   * Rent Contract zhiarkoy
   */
  {
    user_key: "zhiarkoy_1_1",
    kurdish:
      "لایەنی یەکەم ڕەزامەندە لەسەر بەکرێدانی ئەم موڵکە کەلە سەرەوە ئاماژەی پێکراوە بەلانی دووەم.",
    arabic:
      "وافق الطرف الأول على تأجير هذا العقار المذكور أعلاه إلى الطرف الثاني. ",
    english:
      "The first party agrees to lease the property which is referred to above to the second party.",
  },
  {
    user_key: "zhiarkoy_2_1",
    kurdish: "ماوەی ئەم گریبەستە",
    arabic: "مدة العقد  ",
    english: "The duration of this contract is ",
  },
  {
    user_key: "zhiarkoy_2_2",
    kurdish: "مانگە دەستپێدەکات لە بەرواری",
    arabic: "شهراً تبدأ من ",
    english: "months, it starts from ",
  },
  {
    user_key: "zhiarkoy_2_3",
    kurdish: "تا",
    arabic: "إلى ",
    english: "to ",
  },
  {
    user_key: "zhiarkoy_2_4",
    kurdish:
      "وە لەکاتی کوتایی هاتنی ماوەی ئاماژە پێکراو لەسەر لایەنی دووەمە کە شوینی بەکرێگیراو چۆل بکات بی ئەوەی پێویستی بە ئاگادار کردنەوەی هەبیت",
    arabic: "وعند انتهاء المدة على الطرف الثاني تخلية العقار دون تبليغ مسبق. ",
    english:
      "and when the above mentioned duration ends the second party should evacuate the leased property without the need to be notified.",
  },
  {
    user_key: "zhiarkoy_3_1",
    kurdish: "هەردوو لایەن رەزامەندن لەسەر کرێی مانگانەی بە بڕی",
    arabic: "وافق كلا الطرفين على أجرة شهرية قدره ",
    english: "Both parties agree on the monthly lease fee with the amount of",
  },
  {
    user_key: "zhiarkoy_4_1",
    kurdish: "لایەنی دووەم بڕی",
    arabic: "يدفع الطرف الثاني مبلغ قدره ",
    english: "The second party gives the amount of ",
  },
  {
    user_key: "zhiarkoy_4_2",
    kurdish: "دەدات بە لایەنی یەکەم وەک پێشەکی",
    arabic: "كمقدمة ",
    english: "to the first party as the advance payment.",
  },
  {
    user_key: "zhiarkoy_5_1",
    kurdish: "دوای پێشەکی کرێیەکە بەم شێوەیە دەدرێت",
    arabic: "بعد مبلغ المقدمة يتم دفع الأجرة على النحو التالي",
    english:
      "After the advance payment the lease fee payment will be as following",
  },
  {
    user_key: "zhiarkoy_6_1",
    kurdish: "لایەنی دووەم پاپەند دەبیت بە پێدانی بڕی",
    arabic: "يلتزم الطرف الثاني بدفع مبلغ قدره ",
    english: "The second party will be committed to paying the amount of",
  },
  {
    user_key: "zhiarkoy_6_2",
    kurdish: "وەك دلنيايى(تأمینات)به عقارات زەنگین بە پێى پسولەى ژمارە ",
    arabic: "كتأمينات إلى عقارات زەنگین وفق ورقة الإيصال المرقمة ",
    english: "as insurance to Zangin company as per the invoice number",
  },
  {
    user_key: "zhiarkoy_6_3",
    kurdish:
      "وه ئەم بڕه پارەيە دەگەريندريتەوه بو لايەمى دووەم به هەمان پسوله دواى كوتای هاتنى ماوەى گرێبەست به مەرجيك لايەنى دووەم مۆڵكەكه بەبى بوونى هيج كەم و كوڕيەك رادەست بكاتەوه.",
    arabic:
      "ويتم تسليم المبلغ بورقة الإيصال نفسها إلى الطرف الثاني بعد انتهاء مدة العقد بشرط تسليم العقار دون أي نقص من قبل الطرف الثاني إلى الطرف الأول. ",
    english:
      "and this amount of money will be returned to the second party with the same invoice after the contract duration ends with the condition that the second party returns the property without any damage or shortage. ",
  },
  {
    user_key: "zhiarkoy_7_1",
    kurdish: "لايەنى دووەم ئەم مۆلكه بەكاردێنيت بۆ مەبەستى ",
    arabic: "يستخدم الطرف الثاني هذا العقار لغرض ",
    english: "The second party will use this property for the purpose of",
  },
  {
    user_key: "zhiarkoy_7_2",
    kurdish:
      "له كاتى بەكارهێنانى بۆ هەر مەبەستێكى تر پێويستە ئاگادارى عقارات زەنگین بكات و رەزامەندى لايەنى يەكەم به نوسراوو وەربگريت.به پێجەوانەوە مافى لايەنى يەكەمه ئەم گريبەستە هەڵبوشێنێتەوە بەبى ئاگادار كردنەوەى لايەنى دووەم",
    arabic:
      "وعند استخدامه لأي غرض آخر يجب تبيلغ عقارات زەنگین عن ذلك وبموافقة خطية من الطرف الأول. خلافاً لذلك يحق للطرف الأول إبطال العقد دون تبيلغ الطرف الثاني. ",
    english:
      "and when using it for any other purpose it should notify Zangin company and to get a written agreement from the first party, otherwise the first party has the right to terminate this contract without notifying the second party.",
  },
  {
    user_key: "zhiarkoy_8",
    kurdish:
      "لايەنى دووەم بەلێن دەدات كه پارێزگارى له شوێنى بەكرێگیراو بكات له كاتى سوود وەرگرتن له شوێنەكە وە دوورى بگرێت له تێكجوون و داڕمان وه بەكارنەهێنانى به شێوەیەكى نەخوازراو",
    arabic:
      "يتعهد الطرف الثاني بحماية العقار المستأجَر عن الاستفادة منه والحفاظ عليه من التلف والهدم وعدم استخدامه على شكل غير مرغوب فيه. ",
    english:
      "The second party promises that it will protect the leased property when using it and it also promises that it will protect the property from getting damaged and that it will not use it unfairly.",
  },
  {
    user_key: "zhiarkoy_9",
    kurdish:
      "لايەنى یەکەم بۆى نيه شوێنى بەكرێگيراو بەكار بهێنێت ياخوود داواى كليلى موڵكەکە بكات بۆ هەر مەبەستێك بێت تا رێپێدانى ئاسايش ياخوود لايەنى پەيوەندیدار وەردەگرێت.بەپیچەوانەوه بەرپرسيار دەبيت بەرامبەر به ياسا",
    arabic:
      "لا يجوز للطرف الأول استخدام العقار المستأجَر أو يطالب بمفتاحه إلى أن يتم الحصول على الرخصة الأمنية (من آسايش) أو الجهة المعنية؛ خلافاً لذلك يتحمل المسؤولية أمام القانون",
    english:
      "The first party doesn’t have the right to ask for the keys or to use the leased property for any purpose unless it gains the security clearance or the clearance from other related parties, otherwise it will be responsible in front of the law.",
  },
  {
    user_key: "zhiarkoy_10",
    kurdish:
      "پێويستە لايەنى دووەم پێش بەكارهێنانى شوينى بەكرێگیراو لەسەر ئەستوى خۆى گشت قوفلى دەرگا دەركيەكان بگۆرێت.به پێچەوانە له كاتى روودانى هەر كێشەيەك تەنها خوودى خۆى بەرپرسيار دەبێت",
    arabic:
      "على الطرف الثاني تغيير كافة أقفال الأبواب الخارجية قبل استخدام العقار؛ خلافاً لذلك يتحمل المسؤولية هو بنفسه. ",
    english:
      "The second party should change all the lockers of all the main doors before using the leased property, otherwise in case of any problem the second party will solely be responsible for.",
  },
  {
    user_key: "zhiarkoy_11",
    kurdish:
      "له بەروارى واژوو كردنى ئەم گرێبەستە خزمەتگوزاريەكانى پرۆژە و شارەوانى و كارەبا و ئاو وهەر خزمەت گوزاريەكى تر هەبيت له ئەستۆى لايەنى دووەم دەبيت",
    arabic:
      "	من تاريخ توقيع العقد يكون الطرف الثاني هو المسؤول عن دفع تكاليف الماء والكهرباء والبلدية وأية خدمة أخرى. ",
    english:
      "From the date of signing this contract all the expenses of the project, municipality, electricity, water and any other services will be the liability of the second party",
  },
  {
    user_key: "zhiarkoy_12_1",
    kurdish: "ئەگەر لایەنی دووەم تاکو بەرواری ",
    arabic: "	في حال عدم الحصول على الرخصة من الجهة الأمنية حتى تاريخ ",
    english:
      "If the second party couldn’t gain the clearance from the related parties until",
  },
  {
    user_key: "zhiarkoy_12_2",
    kurdish:
      "نەیتوانی ڕێپێدان لە لایەنی پەیوەندیدار وەربگرێ راستەوخۆ گرێبەستەکە هەڵدەوەشێتەوە وە ئەو بڕە کرێیەی کەوا دراوە دەگەرێنرێتەوە بۆ لایەنی دووەم",
    arabic: "يتم فسخ العقد مباشرة ويتم إرجاع المبلغ المستلم إلى الطرف الثاني. ",
    english:
      "in this case the contract will directly be terminated and the amount of the fee which is paid will be returned to the second party.",
  },
  {
    user_key: "zhiarkoy_13",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی کرێ لە کاتی دیاریکراو لەم گرێبەستە. لەکاتی دواکەوتن لە (7) رۆژ زیاتر ئەوە بە پێی برگەی (1) لە ماددەی (17) لە یاسای بەکرێدانی مۆڵک لە قانونی عێراقی ژمارە (87) ساڵی (1979) مامەڵەی لەگەل دەکرێ ئەویش بە چۆڵ کردنی موڵکەکە و تێچوی هۆشداری دادگا ئەکەوێتە ئەستۆی لایەنی دووەم لەگەل کرێی مانگانە.",
    arabic:
      "يتعهد الطرف الثاني بدفع الأجرة في الوقت المحدد في العقد. وإذا تأخر أكثر من (7) أيام فيتعامل معه حسب الفقرة (1) من المادة (17) من قانون تأجير العقار من القانون العراقي المرقم (87) لسنة (1979) وهي تخلية العقار مع تحمل تكاليف تبليغ المحكمة مع الأجرة الشهرية. ",
    english:
      "The second party will be committed to paying the lease fee at the specified time stated in this contract. And in the case of getting delayed for more than (7) days, then the second party will be dealt with according to the Clause (1) from article (17) in the law for leasing the properties of the Iraqi Law number (87) in the year (1979) which is evacuating the property and the expenses for the court notice plus the monthly lease fee will be the liability of the second party. ",
  },
  {
    user_key: "zhiarkoy_14",
    kurdish:
      "ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث)لايەنى دووەم پێويستە پاريزگارى لە كەل و پەلەكان بكات و لەكاتى چۆل كردنى شوينى بەكرێگيراو وەك خۆى رادەستى لايەنى يەكەم بكاتەوە. بە پێچەوانەوە لايەنی دووەم بەرپرسە له چاككردنەوە يان گۆڕينى لەسەر ئەركى خۆى",
    arabic:
      "إذا كان العقار المؤجًّر مؤثثا على الطرف الثاني الحفاظ على الأثاث وعند التخلية يسلّمها كما كانت؛ خلافاً لذلك يكون الطرف الثاني مسؤولاً عن التصليح أو تبديله على مسؤوليته. ",
    english:
      "If the leased property was furnished, the second party should protect this stuff when evacuating the property, it should deliver to the first party as it was when being received. Otherwise, the second party will be responsible for repairing or changing the stuff on its own expense",
  },
  {
    user_key: "zhiarkoy_15",
    kurdish:
      "لايەنى يەكەم پابەند دەبێت بە پێدانى پارەى حكومى و تايبەت(ئەهلى) و خزمەتگوزاريەكان و ئەستۆ پاكى بكات پيش بە كرێدان و واژوو كردنى ئەم گريبەستە",
    arabic:
      "	يتعهد الطرف الأول بدفع الرسومات الحكومية والخاصة والخدمات وبراءة الذمة قبل التأجير والتوقيع على العقد. ",
    english:
      "The first party will be committed to paying all the financial obligations whether public or private, services and clearance before leasing its property and signing this contract.",
  },
  {
    user_key: "zhiarkoy_16",
    kurdish:
      "هەردوولا رێكەوتن كە باجى خانووبەرە لە لايەن لايەنى يەكەمەوە دەدرێت بە پێى ياسا باجى خانووبەرەى كارپێكراو",
    arabic:
      "اتفق الطرفان على أن الطرف الأول هو المسؤول عن دفع ضريبة العقار  وفق قانون ضريبة العقار الساري. ",
    english:
      "Both parties agreed that real estate tax will be paid by the first party according to the applicable Real Estate Law.",
  },
  {
    user_key: "zhiarkoy_17",
    kurdish:
      "لايەنى دووەم پێويستە (مانگيك) پيش كوتايی هاتنى ئەم گريبەستە,ئاگادارى عقارات زەنگین بكات بەوەى ئەگەر نيازى هەبێت بە نوێكردنەوە ياخوود بە چۆول كردنى شوينى بەكرێگيراو. بە پێچەوانەوە كريى (مانگيك)دەکەويتە ئەستوى لايەنى دووەم",
    arabic:
      "يجب على الطرف الثاني إبلاغ عقارات زەنگین قبل انتهاء العقد بـ(شهرٍ) عن موقفه إما بتجديد العقد أو التخلية؛ خلافاً لذلك عليه دفع أجرة شهر.  ",
    english:
      "The second party should notify Zangin company before (1 month) to the time of ending this contract if it intends to renew or evacuate the leased property, otherwise the lease fee for one month should be paid by the second party.",
  },
  {
    user_key: "zhiarkoy_18",
    kurdish:
      "لەسەر لايەنى دووەم پێويستە مولكەكە بۆ ئەو مەبەستە بەكار بهێنێت كە لەسەرى رێككەوتون,وە بۆ كارى نەشياو ناشەرعى وناقانونى بەكارنەهێنێت.بە پێچەوانەوە بەرپرسيار دەبێت بەرامبەر ياسا و گرێبەستەكە هەڵدەوەشێتەوە",
    arabic:
      "على الطرف الثاني استخدام العقار للغرض الذي اتفق عليه الطرفان وألا يستخدمه لأغراض غير شرعية وغير قانونية؛ خلافاً لذلك يتحمل المسؤولية أمام القانون ويتم فسخ العقد. ",
    english:
      "The second party should use the property for the purpose which both parties have agreed on and it should not be used for illegal actions. Otherwise the second party will be responsible in front of law.",
  },
  {
    user_key: "zhiarkoy_19_1",
    kurdish:
      "دوای تەواو بونی ماوەی ئەم گرێبەستە ئەگەر لایەنی دووەم پابەند نەبێ بە چۆڵکردن یان نوێکردنەوەی ئەم گرێبەستە ئەوا کرێی موڵکەکە دەبێت بە رۆژانە بە بڕی ",
    arabic:
      "بعد انتهاء مدة العقد في حال لم يلتزم الطرف الثاني بتخلية العقار أو تجديد العقد تكون أجرة العقار ",
    english:
      "When the duration of this contract ends if the second party is not committed to evacuating the property or renewing this contract in this case the lease fee of the property will be on daily basis ",
  },
  {
    user_key: "zhiarkoy_19_2",
    kurdish: "بۆ هەر رۆژێک هەژمار دەکرێت تا ئەو کاتەی کێشەکە یەکلایی دەبێتەوە",
    arabic: "إزاء كل يوم إلى أن يتم حسم القضية. ",
    english: "for each day will be counted until the problem is being solved.",
  },
  {
    user_key: "zhiarkoy_20",
    kurdish:
      "ئەگەر لایەنی دووەم نیازی هەبێت هەر جۆرە گۆرانکاریەک بکا لە ناوەوە یان دەرەوەی ئەم موڵکە ئەوا پێویستە بە ئاگاداری عقارات زەنگین و بەرەزامەندی نوسراوی لایەنی یەکەم بێت وە پێویستە گۆرانکاریەکان دیاری بکرێت",
    arabic:
      "في حال أراد الطرف الثاني إحداث أي تغيير داخلي أو خارجي للعقار عليه تبليغ عقارات زەنگین وأخذ موافقة الطرف الأول مع تحديد التغييرات. ",
    english:
      "If the second party intends to make any change inside or outside the property it should notify Zangin Company and this will be based on a written agreement from the first party and all changes should be stated in this agreement.",
  },
  {
    user_key: "zhiarkoy_21",
    kurdish:
      "لایەنی دووەم بۆی نیە داوای تێچووی گۆرانکاریەکان بکات لە لایەنی یەکەم",
    arabic:
      "	لا يحق للطرف الثاني المطالبة بدفع تكاليف التغييرات من الطرف الأول. ",
    english:
      "The second party doesn’t have the right to claim for the expenses of the changes which have been done. ",
  },
  {
    user_key: "zhiarkoy_22",
    kurdish:
      "لایەنی دووەم بۆی نیە بە هیچ شێوەیەک ئەم مولکە ( گشتی یان بەشێکی) بەکرێ بداتەوە بەلایەنێکی تر بەبێ ئاگادارکردنەوەی عقارات زەنگین وە هەروەها بەبێ وەرگرتنی رەزامەندی نوسراوی لایەنی یەکەم",
    arabic:
      "لا يحق للطرف الثاني بأي وجه من الوجوه تأجير جزء من الملك أو كله إلى طرف آخر دون تبليغ عقارات زەنگین وكذلك أخذ الموافقة الخطية من الطرف الأول. ",
    english:
      "The second party doesn’t have the right in any way to lease (a part or as whole) of this property to the third party without notifying Zangin Company and without gaining the written agreement from the first party.",
  },
  {
    user_key: "zhiarkoy_23",
    kurdish:
      "ئەگەر لەماوەی ئەم گرێبەستە خاوەنداریەتی ئەم موڵکە گواسترایەوە بۆ هەر لایەنێکی تر ئەوا ئەبێ خاوەنە نوێیەکەی پابەندی نێوەرۆکی ئەم گرێبەستە بێ",
    arabic:
      "إذا تم نقل الملكية للعقار إلى طرف آخر يجب على الصاحب الجديد  الإلتزام بمضمون هذا العقد.  ",
    english:
      "As far as this contract is active and if the property ownership transferred to another party then the new owner should commit to the content of this contract.",
  },
  {
    user_key: "zhiarkoy_24",
    kurdish:
      "ئەگەر لایەنی دووەم پێش کۆتایی هاتنی ئەم گرێبەستە شوێنی بەکرێگیراوی چۆل کرد ئەوە عقارات زەنگین بە پێی توانا هاوکار دەبێ بۆ گێرانەوەی (بەشێک یان گشت) کرێی ماوەی چۆڵکردنی موڵکەکە بەمەرجێک ئەگەر موڵکەکە بەکرێدرایەوە لەلایەن عقارات زەنگین",
    arabic:
      "	إذا قام الطرف الثاني قبل انتهاء مدة العقد بتخلية العقار المؤجّر تسعى عقارات زەنگین حسب استطاعتها إلى مساعدة إرجاع (جزء أو كل) أجرة مدة تخلية العقار بشرط إعادة تأجيره من قبل عقارات زەنگین. ",
    english:
      "If the second party evacuated this property before ending the duration of this contract then Zangin Company will be helpful to return a part or all of the lease fees for the property evacuation period to the second party with the condition if the property is leased again by the Zangin Company.",
  },
  {
    user_key: "zhiarkoy_25",
    kurdish:
      "ئەگەر شوێنى بەكرێگيراو راخراو بوو (مؤثث) لايەنى یەکەم لەگەل لایەنی دووەم پێويستە کەل و پەلەکان ئەژمار بکەن (جرد) وە  وێنەی بگرن و هاوپێچی ئەم گرێبەستەی بکەن",
    arabic:
      "إذا كان العقار المؤجّر مؤثثاً يجب على الطرف الأول جرد الأثاث وأخذ صورة منها ويتم إرفاقها مع العقد. ",
    english:
      "If the leased property was furnished then the first party and the second party should do an inventory for all stuff and take photos of them and attach it to this contract",
  },
  {
    user_key: "zhiarkoy_26",
    kurdish:
      "لایەنی یەکەم دڵنیای ئەوە دەکاتەوە کە ( ئامادەی رووبەروبونەوەی یاساییە – التعرض القانونی) لەهەر کەسێک دەربارەی شوێنی بەکرێگیراو، بەپێچەوانەوە مافی لایەنی دووەمە کە لە پێدانی کرێ بوەستێت سەرەرای بونی مافی هەڵوەشاندنەوەی گرێبەستەکە ",
    arabic:
      "يتعهد الطرف الأول بأنه يكون مستعد للتعرض للمساءلة القانونية لأي شخص بخصوص العقار المؤجّر، خلافا لذلك يحق للطرف الثاني أن يقف عن دفع الأجرة إضافة إلى حق فسخ العقد. ",
    english:
      "The first party ensures that it is ready for legal exposure against any person regarding the leased property otherwise it is the right of the second party to suspend paying the lease fees plus having the right of terminating the contract. ",
  },
  {
    user_key: "zhiarkoy_27",
    kurdish:
      "لەکاتی ئامادەبونی کرێ وە ئاگادارکردنەوەی لایەنی یەکەم بۆ وەرگرتنی پێویستە لایەنی یەکەم بەزوترین کات ئامادەبێت لە عقارات زەنگین وە  کرێیەکەی وەربگرێت بە پێچەوانە پارەکە دەخرێتە سەر ئەژماری ( حساب) بانکی دیار دواتر بە چەک بۆی خەرج دەکرێت",
    arabic:
      "	عند تحضير الأجرة وتبليغ الطرف الأول لاستلامه يجب على الطرف الأول أن يحضر بأسرع وقت ممكن في عقارات زەنگین ويستلم أجرته خلافاً لذلك يتم إيداع المبلغ في حساب عقارات زەنگین ومن ثم يمكن صرفه عن طريق صك. ",
    english:
      "When the lease fees are ready and after notifying the first party to receive its lease fees then the first party should attend at Zangin Company as soon as possible to receive its lease fees otherwise this amount will be put in a bank account of Zangin Company and later on will be paid to it by check.",
  },
  {
    user_key: "zhiarkoy_28",
    kurdish:
      "هەر یەک لە لایەنی یەکەم و لایەنی دووەم پێوستە بڕی کرێی نیو مانگ بۆ هەر ساڵێک بدەن بە عقارات زەنگین لە بڕی رێکخستنی ئەم گرێبەستە",
    arabic:
      "على الطرفين دفع نصف مبلغ الأجرة سنوياً إلى عقارات زەنگین بدل تظيم هذا العقد. ",
    english:
      "Each one of the first and the second party should pay half a month lease fee to Zangin  Company for arranging this contract.",
  },
  {
    user_key: "zhiarkoy_29",
    kurdish:
      "لەکاتی چۆڵکردن شوێنی بەکرێ گیراو پێویستە لایەنی دووەم چۆن موڵکەکەی وەرگرتوە وەک خۆی بەبێ کەم و کورتی رادەستی لایەنی یەکەم بکاتەوە، بەپێچەوانەوە بەرپرسە لە چاککردنەوەی کەم وکوریەکان بەزوترین کات",
    arabic:
      "عند تخلية العقار يجب على الطرف الثاني تسليم العقار كما استلمه دون نقصان خلافا لذلك يتحمل المسؤولية لسد النواقص بأسرع وقت ممكن. ",
    english:
      "When evacuating the leased property the second party should deliver the property to the first party as it was when being received without any damage or shortage otherwise it will be responsible for repairing the shortages as soon as possible",
  },
  {
    user_key: "zhiarkoy_30",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی پارەی ئاو و کارەبای نیشتمانی لەگەل هاتنەوەی پسولە وە پێویستە لەکاتی چؤل کردن شوێنی بەکرێگیراو سەردانی فەرمانگەکان بکات بۆ پێدانی ئەو بڕە قەرزەی کە لەئەستۆیەتی وە پابەند دەبێت بە دەرخستنی گشت پسولەکان بە پێچەوانەوە بەرپرسیار دەبێت بەرامبەر بە یاسا",
    arabic:
      "يتعهد الطرف الثاني بدفع تكاليف الماء والكهرباء الوطنية مع مجيء ورقة القبض وعند التخلية عن العقار المؤجر عليه زيارة الدوائر لدفع القرض المتبقى عليه خلافا لذلك يتحمل المسؤولية أمام القانون. ",
    english:
      "The second party is committed to paying for water, public electricity at the time of receiving the invoice and it is a must that during evacuating the least property to visit the related governmental organizations to pay off any remaining debt And will be committed for preparing all invoices otherwise will be responsible in front of law.",
  },
  {
    user_key: "zhiarkoy_31",
    kurdish:
      "لەکاتی نوێ کردنەوەی گرێبەست هەر لایەنێک پابەند دەبێت بە پێدانی کرێی نیو مانگ بۆ یەک ساڵ بە عقارات زەنگین",
    arabic:
      "يتعهد الطرفان عند تجديد العقد بدفع نصف مبلغ الأجرة سنوياً إلى عقارات زەنگین. ",
    english:
      "When renewing the contract each party will be committed to paying the amount of the lease fee for half a month to Zangin Company for each year. ",
  },
  {
    user_key: "zhiarkoy_32",
    kurdish:
      "لایەنی دووەم بەهیچ شێوەیەک نابێت ببێتە مایەی ئەزیەت و ئازار بۆ دراوسێیەکانی و بە پێچەوانەوە بەرپرسیار دەبێت و گرێبەستەکە هەڵدەوەشێتەوە",
    arabic:
      "لا يحق للطرف الثاني بأي وجه من الوجوه أم يخلق مشاكل مع جيران خلافاً لذلك يتحمل المسؤولية ويتم فسخ العقد. ",
    english:
      "The second party should not be in any way the source of disturbance to its neighbors; otherwise it will be responsible and will cause the contract termination.",
  },
  {
    user_key: "zhiarkoy_33",
    kurdish:
      "لەکاتی چارەسەر نەبوونی کێشەی لایەنی یەکەم و دووەم بە شێوازی گفتوگۆ و دانوستاندن ئەوا عقارات زەنگین بەرپرس نیە و نابێت بەڵکو پێویستە لەسەر لایەنەکان کێشەکە چارەسەر بکەن بەگرتنەبەری رێکاری یاسایی و پەنابردن بۆ دادگای تایبەت",
    arabic:
      "عند عدم حسم المشاكل بالحوار فيما بين الطرفين لا تتحمل عقارات زەنگین المسؤولية بل على الطرفين أن يحسم القضايا من خلال إجراءات قانونية واللجوء إلى محكمة خاصة. ",
    english:
      "In case of inability to solve the problem of the first and second parties through negotiations then Zangin Company is not responsible and will not be responsible but the parties should solve the problem through legal proceedings and to go to a specialized court.",
  },
  /**
   * Sell contract zhiarkoy
   */
  {
    user_key: "S_zhiarkoy_1_1",
    kurdish: "من ",
    arabic: "إني ",
    english: "My name is ",
  },
  {
    user_key: "S_zhiarkoy_1_2",
    kurdish:
      "خاوەن موڵك ڕەزامەندم بە فرۆشتنی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بە بڕی ",
    arabic: "صاحب الملك وافقت على بيع العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "the property owner, I agree to sell the above mentioned property with the amount of ",
  },
  {
    user_key: "S_zhiarkoy_2",
    kurdish:
      "من لایەنی دووەم ڕەزامەندم بە كڕینی ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بەبڕی ",
    arabic: "إني الطرف الثاني وافقت على شراء العقار المذكور أعلاه بمبلغ قدره ",
    english:
      "Me as the second party, I agree to buy the above mentioned property with the amount of ",
  },
  {
    user_key: "S_zhiarkoy_3_1",
    kurdish: "لایەنی دووەم بڕی ",
    arabic: "يدفع الطرف الثاني مبلغاً قدره",
    english: "The second party has paid the amount of ",
  },
  {
    user_key: "S_zhiarkoy_3_2",
    kurdish: "رادەستی لایەنی یەکەم کرد وەکو پێشەکی",
    arabic: "إلى الطرف الثاني كمقدمة",
    english: "to the first party as advance payment",
  },
  {
    user_key: "S_zhiarkoy_4",
    kurdish:
      "ئەو برە پارەیەی کە لەئەستۆی لایەنی دووەم ماوە بیدات بە لایەنی یەکەم بەم شێوەی خوارەوە دەدرێت (کاش-قسط)",
    arabic:
      "يتم دفع المبلغ المتبقي على الطرف الثاني إلى الطرف الأول على النحو التالي: (نقداً - أقساط).   ",
    english:
      "The amount of money which the second party is due to pay to the first party, will pay as the following (Cash- Installment)",
  },
  {
    user_key: "S_zhiarkoy_5",
    kurdish:
      "لەسەر لایەنی یەكەم پێویستە ئەم موڵكە ڕادەستی لایەنی دووەم بكات دوای وەرگرتنی تەواوی شایستە داراییەکانی لە رێكەوتی",
    arabic:
      "على الطرف الأول تسليم العقار إلى الطرف الثاني بعد استلام كافة مستحقاته المالية  في ",
    english:
      "The first party should deliver this property to the second party after receiving all its financial entitlements in ",
  },
  {
    user_key: "S_zhiarkoy_6",
    kurdish:
      "ئەگەر هاتوو لایەنی یەكەم لە رێكەوتی دیاریكرودا ئەو موڵكەی ڕادەستی لایەنی دووەم نەكرد ئەوە دەبێت پابەندبێت بێت بە پێدانی بڕی ",
    arabic:
      "في حال تأخر الطرف الأول من تسليم العقار إلى الطرف الثاني عليه دفع مبلغ قدره ",
    english:
      "If the first party didn’t deliver this property to the second party at the specified date, then it should commit to paying the amount of ",
  },
  {
    user_key: "S_zhiarkoy_6_2",
    kurdish: "وەكوو پێبژاردن (غرامة) بۆ هەر رۆژێک",
    arabic: "كغرامة لكل يوم تأخير",
    english: "as fine for each day to the second party",
  },
  {
    user_key: "S_zhiarkoy_7",
    kurdish:
      "لایەنی یەکەم لەئەستۆیەتی تا بەرواری رادەست کردنی موڵکەکە بە پێدانی هەر قەرزێک ئەگەر هەبێت لە خزمەتگوزاری ئاو کارەبا سەبارەت بە موڵکی ئاماژە پێکراو",
    arabic:
      "على الطرف الأول تصفية تكاليف ورسومات الماء والكهرباء أو أي قرض آخر قبل موعد تسليم العقار المذكور. ",
    english:
      "The first party is liable to pay for any debt of the services like electricity or water of the mentioned property if there is any until the date of delivering the property to the second party.",
  },
  {
    user_key: "S_zhiarkoy_8",
    kurdish:
      "ئەگەر هاتوو هەر لایەنێك بە هەر هۆیەك پاشگەز بێتەوە لەم گرێبەستە دەبێت پابەند بێت بە پێدانی ",
    arabic: "في حال انسحاب أحد الطرفين، أياَ كان السبب، يجب دفع مبلغ قدره ",
    english:
      "If any party regretted from this contract due to any reason it should commit to pay the amount of ",
  },
  {
    user_key: "S_zhiarkoy_8_2",
    kurdish:
      "وەكوو پێبژاردن  بە لایەنەكەی تروەکو قەرەبوو بەبێ چوون بۆ دادگا یان ناردنی هۆشداری. ئەم برگەیەش شایانی جێبەجێ کردنە لە بەرێوبەرایەتی جێبەجێکردنی سلێمانیراستەوخۆ وە بری قەرەبوەکەش عقارات زەنگین دیاری دەکات",
    arabic:
      "كغرامة وتعويض إلى الطرف الآخر دون الرجوع إلى المحكمة أو إرسال تبليغ. تصلح هذه الفقرة للتنفيذ في مديرية تنفيذ سلیماني مباشرة ويتم تحديد مبلغ التعويض عن طريق عقارات زەنگین",
    english:
      "as penalty to the other party as compensation without going to court or giving a notice. This clause is applicable in Slemani Directorate of Implementation directly, and the amount for compensation will be put by Zangin Company.",
  },
  {
    user_key: "S_zhiarkoy_9",
    kurdish:
      "هەر لایەک بەرپرس بێ لە بەندی (8)ی ئەم گرێبەستە ئەوا پابەندە بە پێدانی بڕی 2%ی نرخی موڵکەکە بەعقارات زەنگین لەبری هەردوولایەن",
    arabic:
      "يلتزم الطرف المسؤول عن البند (8) من هذا العقد بدفع 2% من سعر العقار إلى عقارات زەنگین بديلاً عن الطرفين. ",
    english:
      "Any party which is responsible in the clause (8) in this contract will automatically be committed to pay the amount of (2%) of the property price to Zangin Company instead of both parties.",
  },
  {
    user_key: "S_zhiarkoy_10",
    kurdish:
      "تێچوو و ڕسوماتی فرۆشتن و گواستنەوە و جیاكردنەوە و یەكخستن و ڕاستكردنەوە و باجی خانووبەرە لەسەر لایەنی یەكەمە بیدات بەپێی یاسا ئەگەر تاپۆ بوو. بەڵام ئەگەر تاپۆ نەبوو لایەنی یەكەم پابەندە بە پێدانی بڕی تێچوی گواستنەوەی خاوەنداریەتی",
    arabic:
      "تقع تكاليف ورسومات البيع والنقل والفرز والتوحيد والتعديل وضريبة العقار على الطرف الأول وفق القانون إذا كان للعقار سند طابو. وفي حال لم يكن للعقار سند طابو على الطرف الأول دفع تكاليف نقل الملكية. ",
    english:
      "The expenses and fees for selling, transferring, separation, integration, correction and real estate tax will be paid by the first party according to Law if the property is registered on his/her name. But, if the property is not registered on his/her name then the first party is committed to paying all the expenses for transferring the ownership.",
  },
  {
    user_key: "S_zhiarkoy_11",
    kurdish:
      "تێچووی ڕسوماتی كەشف و تۆماری عەقاری دەكەوێتە سەر لایەنی دووەم بە گوێرەی یاسا ئەگەر موڵكەكە تاپۆ بوو. وە ئەگەر تاپۆ نەبوو ئەوە لایەنی دووەم بە پێدانی بڕی پارەی بەناوكردن",
    arabic:
      "يكون الطرف الثاني مسؤولاً عن تسديد رسومات الكشف والتسجيل العقاري وفق القانون في حال كان للعقار سند طابو، وإذا لم يكن للعقار سند طابو على طرف الثاني دفع تكاليف التسجيل. ",
    english:
      "The expenses for inspection and real estate registration will be paid by the second party according to law if the property is registered on his/her name. But, if the property is not registered on his/her name then the second party should pay for registration expenses.",
  },
  {
    user_key: "S_zhiarkoy_12_1",
    kurdish:
      "پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر هاتوو مولکی فرۆشراو تاپۆی هەبوو پێویستە لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە پارێزەر",
    arabic:
      "بعد التوقيع على هذا العقد في حال كان للعقار المباع سند طابو، يجب على الطرف الأول منح وكالة إلى المحامي",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_zhiarkoy_12_2",
    kurdish:
      "بەمەبەستی گواستنەوەی خاوەنداریەتی و تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم",
    arabic: "لغرض نقل الملكية وتسجيل العقار المباع لصالح الطرف الثاني. ",
    english:
      "After signing this contract if the sold property was registered on the first party’s name then the first party should give the agency to a lawyer: for the purpose of transferring the ownership and registering the sold property for the second party.",
  },
  {
    user_key: "S_zhiarkoy_13",
    kurdish:
      "لایەنی یەکەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئامێژەپێکراو لەم گرێبەستە بە عقارات زەنگین لەبەرامبەر فرۆشتنی ئەم موڵکە ",
    arabic:
      "يتعهد الطرف الأول بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى عقارات زەنگین إزاء بيع العقار ",
    english:
      "The first party is committed to pay (1%) of the property price put in this contract to Zangin Company for selling this property.",
  },
  {
    user_key: "S_zhiarkoy_14",
    kurdish:
      "لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی موڵکی ئامێژەپێکراو لەم گرێبەستە بە عقارات زەنگین لەبەرامبەر کرینی ئەم موڵکە ",
    arabic:
      "يتعهد الطرف الثاني بدفع نسبة 1% من سعر العقار المذكور في هذا العقد إلى عقارات زەنگین إزاء بيع العقار ",
    english:
      "The second party is committed to pay (1%) of the property price put in this contact to Zangin Company for buying this property.",
  },
  {
    user_key: "S_zhiarkoy_15",
    kurdish:
      "لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە بە پێویستە لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ کێشەکە چارەسەر بکەن. بەلام ئەگەر چارەسەر نەکرا ئەوا لەرێگەی دادگاکانی سلێمانی چارەسەر دەکرێ",
    arabic:
      "في حال حدوث أي نزاع حول مضمون هذا العقد على الطرفين حله عن طريق الحوار وإلا تكون محكمة سلیماني محل بتّ القضايا",
    english:
      "In case of any problem regarding the content of this contract, both parties should solve the problem based on negotiations. But if this didn’t help then it will be solved through Slemani Courts.",
  },
  // zhyar koye sell
  {
    user_key: "zhyar_3_1",
    kurdish: "لایەنی یەکەم (فرۆشیار) دانی بەوە دانا کە بڕی",
    arabic: "الطرف الاول(البائع) استلمت من الطرف الثاني مبلغ قدره",
    english: "First party complies that he received",
  },
  {
    user_key: "zhyar_3_2",
    kurdish: "وەرگرتووە لە لایەنی دووەم(کڕیار)",
    arabic: "عن قيمة الملك كاملة. ",
    english: "from second party",
  },
  {
    user_key: "zhyar_4_1",
    kurdish: "لایەنی دووەم (کڕیار) دانی بەوە دانا کە دەستبەجێ بڕی پارەی",
    arabic: "الطرف الثاني (المشتري) يدفع مبلغ وقدره",
    english: "Second party complies to pay",
  },
  {
    user_key: "zhyar_4_2",
    kurdish: "بدات. لەگەڵ وەرگرتنی بریکار نامە لەلایەنی یەکەم(فرۆشیار)",
    arabic: "للطرف الاول(البائع) .بعد عمل وكالة للمحامي",
    english: "to first party and also take agency from first party.",
  },
  {
    user_key: "zhyar_5_1",
    kurdish: "بەڕەزامە ندی هەردوولا بڕی پارەی",
    arabic: "بموافقة الطرفين ابقاء مبلغ قدره",
    english: "After the settlement by both parties",
  },
  {
    user_key: "zhyar_5_2",
    kurdish:
      "خەویندرا لە کۆمپانیا، تا بەناو کردنی موڵکەکە بۆخەرجیەکانی ئاو وکارەباو باجی مولک و کرێی پاریزەرو هەرشتیکی تر، کەلە ئەستۆیی لایەنی یەکەم (فروشیار)ە.",
    arabic:
      " الشركة لمصاريف الضريبة والكهرباء والماء والبلدية الى حين تحويل البيت.",
    english:
      "the money is kept in company untill all the realestate procedures is completed.",
  },
  {
    user_key: "zhyar_6_1",
    kurdish: "هەر لایەک پەشیمان ببێتەوە ئەوا دەبێت بڕی پارەی",
    arabic: "في حال تراجع اي طرف من الاطراف عليه شرط جزائي قدره",
    english: "If any of the parties has drawn",
  },
  {
    user_key: "zhyar_6_2",
    kurdish: "بدات بە لایەنەکەی تر.",
    arabic: "الى الطرف الثاني ",
    english: "he must pay the penalty clause ",
  },
  {
    user_key: "zhyar_7",
    kurdish:
      "رسوماتی موڵک /گواستنەوە / جیاکردنەوە/ یەک خستنەوە / راست کردنەوە/باجی موڵک/ کریی کارەباو و ئاو شارەوانی (قیرتاو ) لەئەستۆی لایەنی یەکەمە (فروشیار)، و پارەی ڕەسمی تاپۆ لەئەستۆی لایەنی دووەمە (کریار).",
    arabic:
      "يكون اجور الرسومات على الطرف الثاني (المشتري) واجور الضريبه والكهرباء والماء على الطرف الاول (البائع)",
    english:
      "The registration procedures are on second party, amd the priority procedures are on first party.",
  },
  {
    user_key: "zhyar_8",
    kurdish:
      "پاش واژووکردنی ئەم گرێ بەستە لەلایەنی کۆمپانیا و لایەنەکان مافی کۆمپانیا (زەنگین)ە کە بری (1%) (یەک لەسەد) وەربگرێت، وە ئەم پارەیە ناگەڕێتەوە.",
    arabic:
      "بعد توقيع العقد من الطرفين و من الشركة, يدفع حق الشركة وهي العمولة بنسبة (1%) ",
    english:
      "After signing this agreement from both parties, the company will take (%1) of the amount as the companies privilage, with no refund.",
  },
  {
    user_key: "zhyar_9",
    kurdish:
      "هەر تیبینیەک یان شتیک هەبێت لەپشت ئەم گرێ بەستە بەرەزامەندی هەردوولا (کریار و فروشیار) بەواژووکردن لەپشت گرێبەستەکە بەدەست دەنوسرێت، وە دەبێت هەردوولایەن پابەند بن.",
    arabic:
      "في حالة وجود اي ملاحظة اخرى تكتب في ظهر العقد بموافقة الطرفين و يلتزم الطرفين بها و بتوقيع من الطرفين",
    english:
      "If there are any other additions on this contract, with the settlement and signiture of both parties, it will be written on the rare of this contract, and both parties must comply on it.",
  },
  {
    user_key: "zhyar_Company",
    kurdish: "عقارات ( زەنگین)",
    arabic: "عقارات ( زەنگین)",
    english: "Zangin RealEstate",
  },
  {
    user_key: "zhyar_Company_header_bill",
    kurdish: "عقارات زەنگین بۆ عەقارات",
    arabic: "العقارات زەنگین العقاریە",
    english: "Zangin Real Estate Co.",
  },
  {
    user_key: "zhyar_rent_7",
    kurdish:
      "لەپاش ئەو گرێبەستە، هەر گرێبەستێکیتر لە نێوان (خاوەن موڵک) و (کرێچی) بکرێت، عقارات زەنگین لێی بەرپرس نیە.",
    arabic:
      "اي خلاف بين الطرفين بعد كتابه العقد اعلاه الشركة(زيار كويى) لا تتحمل المسؤولية. و عقد اي اتفاق اخر بين الطرفين بدون علمنا الشركة غير مسؤولة عنها",
    english:
      "After this agreement,Zangin Real Company takes no responsibilities for any other contracts between the both parties (The owner and The renter).",
  },
  {
    user_key: "zhyar_rent_6",
    kurdish:
      "پاش واژووکردنی ئەم گرێ بەستە لەلایەن کۆمپانیا و لایەنەکانیتر، مافی عقارات  (زەنگین)ە بە وەرگرتنی بڕی نیو کرێی یەک مانگ، وە ئەم پارەیە ناگەڕێتەوە",
    arabic:
      "بعد الاتفاق على هذا العقد عند عقارات  ( زەنگین) يدفع مبلغ للشركة نصف آجار شهر واحد كعمولة ولا يرجع هذا المبلغ لاي سبب كان.",
    english:
      "After signing this agreement from both parties ( The owener and The renter) in Zangin Real Company, half amount of the first month has to be payed with no refund.",
  },
  {
    user_key: "zhyar_rent_5_1",
    kurdish: "من لایەنی دووەم ئەم",
    arabic: "انا الطرف الثاني اتفقت على اجار هذا",
    english: "as the second party (The renter) have rented this ",
  },
  {
    user_key: "zhyar_rent_5_2",
    kurdish: "ەم لەلایەنی یەکەم بەکرێ گرتووە بۆماوەی",
    arabic: "من الطرف الاول لمدة",
    english: "for",
  },
  {
    user_key: "zhyar_rent_4_1",
    kurdish: "لایەنی یەکەم خاوەن مولک دانی بەوە دانا کە بری",
    arabic: "استلم الطرف الاول مبلغ الاجار وقدره",
    english: "The first party (The owner) admitted that he received",
  },
  {
    user_key: "zhyar_rent_4_2",
    kurdish: "وەرگرتوە لەلایەنی دووەم (کرێچی).",
    arabic: "من الطرف الثاني",
    english: "completely from the second party (The renter).",
  },
  {
    user_key: "zhyar_rent_3",
    kurdish: "مانگانە بڕی پارەی دیاریکراو دەدرێت لەلایەن لایەنی دووەم(کرێچی).",
    arabic: "يدفع مبلغ الآجار شهريا من قبل الطرف الثاني",
    english:
      "3. The specified amount of money will be payed monthly from the second party (The renter)",
  },
  {
    user_key: "zhyar_rent_2",
    kurdish: "بری ئەوپارەی کەلەسەری ریک کەوتون بریتیە",
    arabic: "مبلغ الآجار المتفق عليه",
    english:
      "The amount of money that both parties (The owner and The renter) have agreed on is ",
  },
  {
    user_key: "zhyar_rent_article",
    kurdish:
      "لایەنی یەکەم (خاوەن موللک) دانی بەوە دانا بە کریدانی ئەم مۆلکەی خوارەوە بە لایەنی دووەم (کرێچی) بە پێی ئەم خالانەی کەلەم ڕێک کەوتن نامەیەدا هاتووە.",
    arabic:
      "الطرف الاول : (صاحب الملك ) وافق على آجار العقار الى الطرف الثاني (المستأجر) وحسب الشروط المشار اليه أدناه:-",
    english:
      "The first party (The owner) admitted to rent this realestate to the second party (The renter) according to these terms:",
  },

  {
    user_key: "pezan_sell_11",
    kurdish:
      "لە کاتی فرۆشتنی موڵکەکە (گرێبەستی کرێ) هەڵناوەشێتەوە بەڵکو پابەند بوونی خاوەن موڵک دەگوازرێتەوە بۆم کڕیار، بەپێی بەکرێدانی خانوبەرە ژمارە (٨٧) لە ساڵی (١٩٧٩) بڕگەی یەکەم لە ماددەی (١٥)",

    arabic:
      "عند بيع الملك لا يصار الى فسخ (عقد الايجار). بل تنتقل التزامات صاحب الملك الى المشتري و  ذلك قانون ايجار العقارات المرقم (٨٧) لسنة (١٩٧٩) الفقرة اولا من المادة (١٥).",
    english: "",
  },
  {
    user_key: "pezan_sell_12",
    kurdish:
      "لایەنی یەکەم بەرپرسیارە لە بەناوکردن و گواستنەوەی موڵکەکە بۆ لایەنی دووەم و هیچ  بەرپرسیاریەکی یاسایی و مەدەنی لە ئەستۆی عقارات زەنگین دا نیە، بەڵکو ئەرکی کۆمپانیا تەنها گەیاندنی لایەنی یەکەم بە لایەنی دوومە،",

    arabic:
      "الطرف الاول ؤول عن تسجيل ونقل الملك الى الطرف الثاني ولن تتحمل شركة يزان أية مسؤولية مدنية و قانونية. العقارات عملها فقط التوسط بين الطرف الاول و الطرف الثاني.",
    english: "",
  },
  {
    user_key: "14_pezan",
    kurdish:
      "هەر لایەنێک پابەندە بە پێدانی کرێی نیو مانگ بۆ هەر سالیک بە عقارات زەنگین لە بەرامبەر نوێکردنەوەی گرێبەست",
    arabic:
      "يلتزم كلا طرفين باعطاء بدل ايجار نصف شهر لكل سنة لشركة سرراست لقاء تجديد و تنظيم العقد",
    english:
      "Both parties shall concede to pay half the rent of a month per year to Shkoy Zawy Realestate in compensation of organizing and renewing the contract",
  },
  {
    user_key: "15_pezan",
    kurdish:
      "لایەنی دووەم بۆی نیە داوا لە لایەنی یەکەم بکات بە گەڕاندنەوەی تێچووی ئەو گۆڕانکاریانەی لە موڵکەکەی کردووە بەبێ ڕەزامەندی خاوەن موڵک .",
    arabic:
      "لايحق للطرف الثاني المطالبة باسترجاع كلفة التغيرات الحاصلة على الملك من دون موافقة صاحب الملك.",
    english:
      "The second party is not allowed to ask for cost of the changes he made to the property, unless the first party accepts it",
  },
  {
    user_key: "16_pezan",
    kurdish:
      "ئەگەر هاتوو موڵکەکە ڕاخراو (مۆئث) بوو پێویستە لەسەر هەردوو لایەن هەڵسن بە سەرژمێری کەل و دیاریکردنی پەلەکان و کەم وکوڕیەکان و وێنەگرتنیان وە بەستنەوەی بە گرێبەست وەک پاشکۆ بۆ بەرچاو ڕوونی هەردوو لایەن",
    arabic:
      "اذاكان الملك مؤثثا يتعين على الطرفين القيام بجرد جميع الموجودات و تحديد النقص و تصويرها و الحاقها بالعقد كملحق للاستيضاع للطرفين",
    english:
      "If the property was equipped, both parties have to take census of all the merchandise, take its defects into account, take pictures of them and link these factors to the contract as a post script for statement of facts to both parties",
  },
  {
    user_key: "17_pezan",
    kurdish:
      "لەسەر لایەنی دووەم پێویستە هەڵسێ بە گۆڕینی (قفل) ی دەرگاکانی دەرەکی لەسەر تێچوی خۆی، بە پێچەوانەوە خۆی بەرپرسیارە لە ڕوودانی هەر کێشەیەک .",
    arabic:
      "يتعين على الطرف الثاني تغير اقفال الابواب الرئيسية على نفقته الخاصة, بخلافه سيتحمل مسؤولية حدوث اي مشكلة تترتب عليها",
    english:
      "The second party is responsible to pay changing the locks of the entrance doors, on the  contrary, he is responsible for any issue    ",
  },
  {
    user_key: "18_pezan",
    kurdish:
      "لە کاتی فرۆشتنی موڵ (گرێبەستی کرێ) هەڵناوەشێتەوە بەڵکو پابەند بوونی خاوەن موڵک دەگوازرێتەوە بۆم کڕیار، بەپێی بەکرێدانی خانوبەرە ژمارە (٨٧) لە ساڵی (١٩٧٩) بڕگەی ییەکەم لە مادە(٥ا) .",
    arabic:
      "عند بيع الملك لا يفسخ (عقد الايجار) بل تنتقل التزامات صاحب الملك الى المشتري, بموجب قانون ايجار العقار المرقم (87) لسنة (1979) الفقرة اولى من المادة (15)",
    english:
      "In the case of selling the property, the contract of lease shall not be cancelled, instead the abidance of the owner will be carried to the buyer, according to Law number (87) of Leasing Estates, in the year of (1979), First Term, Fifteenth Article",
  },
  {
    user_key: "19_pezan",
    kurdish:
      "عقارات زەنگین بەرپرس نیە لە کاتی هەبوونی کێشەی نێوان هەردوو لایەن یان نەدانی پارەی کرێ لەلایەن کرێچی",
    arabic:
      "لا تتحمل عقارات زەنگین اية مسؤولية عند نشوب اى نزاع بين الطرفين او عدم دفع المستاجر لبدلات الايجار لصاحب الملك",
    english:
      "Zangin Realestate is not responsible for any disputes between the leaseholder and the owner or leaseholders delay in paying rents",
  },
  {
    user_key: "5_pezan",
    kurdish:
      "لایەنی دووەم پابەندە بە پێدانی کرێیەکە لە ڕێکەوتی دیاریکراودا وە ئەگەر لە ماوەی (٧) رۆژ پێدانی کرێێ دیار، دواکەوت لایەنی دووەم بەرپرسیار دەبێ بەرامبەر یاسا بەپێی ماددە (٧) بڕگە(١) لە یاسای بر کرێدانی عێراقی.",
    arabic:
      "يلتزم الطرف الثاني بدفع بدل الايجار في تاريخ محدد, اما اذا تاخر في دفع بدل الايجار المحدد خلال (7) ايام, فلطرف الثاني سيكون مسؤولا امام القانون بموجب المادة (7) فقرة (1) من قانون الايجار العراقي",
    english:
      "The Second party shall pay the rent on the due day. If paying the rent is delayed for (7) seven days, then the second party shall be responsible and has to face the law according to Article (7) - Term (1) from the Iraqi Law of lease",
  },
  {
    user_key: "6_pezan",
    kurdish:
      "عقارات زەنگین هاوکاری هەردوو لایەن دەبێ تا کۆتایی هاتنی بەرواری گرێبەستەکە بۆ مانەوە و بەردەوامی گرێبەستەکە وە چارەسەرکردنی هەر کێشەیەک ئەگەر هەبوو، عەقارات دیار بەرپرس نیە تەنها نێوەندگیرە.",
    arabic:
      "تتعتون شركة بيزان مع الطرفين لحين نهاية تاريخ العقد لغرض البقاء و استمرارية العقد و معالجة اى مشكلة ان وجدت, و العقارات ليست مسؤولة تنجم بعد ذلك ... وهي تعمل مجرد كوسيط",
    english:
      "Zangin Realestate shall assist both parties until the end of the contract for subsistence and continuance of the contract and solving their problems if there is any, but the company is not responsible for any disputes arise between them. It is only an intermediary",
  },
  {
    user_key: "S_baghe32_10",
    kurdish:
      "کاری نوسینگەی زەنگین گەیاندنی لایەنی یەکەم بە لایەنی دووەم و ڕێکخستنی گرێبەستە لە نێوانیاندا",
    arabic: ".عمل عقارات زەنگین التوسط بين الطرفين و تنظيم العقد بينهما",
    english: "",
  },
  {
    user_key: "R_baghe32_14",
    kurdish:
      "هەر کاتێك ئەم موڵکە کڕین و فرۆشتنی پێوەکرا نابێت کرێچی ببێتە بەربەست لەپێش مامەڵەکە، دەبێت ماوەی چۆڵکردنەکە بە ڕەزامەندی هەردوو لا دیاری بکرێت موڵکەکە ڕادەستی لایەنی یەکەم بکات، بەمەرجێک فرۆشیار تێچووی گواستنەوەکە بگرێتە ئەستۆ.",
    arabic: "",
    english: "",
  },
  {
    user_key: "11_pezan",
    kurdish:
      "لایەنی دووەم بۆی نیە بەبێ ڕەزامەندی خاوەن موڵک هەر جۆرە گۆڕانکاریەک لە ناوەوە و دەرەوەی ئەم موڵکە بکات.",
    arabic:
      "لايحق للطرف الثاني القيام باجراء اي تغيرات في الملك سواء كان من الداخل ام من الخارج بدون الحصول على موافقة صاحب الملك",
    english:
      "The second party is not allowed to make any changes to the property (inner or outer) without acquiesces of the first party.",
  },
  {
    user_key: "S_baghe32_10",
    kurdish:
      "کاری نوسینگەی زەنگین گەیاندنی لایەنی یەکەم بە لایەنی دووەم و ڕێکخستنی گرێبەستە لە نێوانیاندا",
    arabic: ".عمل عقارات زەنگین التوسط بين الطرفين و تنظيم العقد بينهما",
    english: "Brikar",
  },
  {
    user_key: "R_baghe32_14",
    kurdish:
      "هەر کاتێك ئەم موڵکە کڕین و فرۆشتنی پێوەکرا نابێت کرێچی ببێتە بەربەست لەپێش مامەڵەکە، دەبێت ماوەی چۆڵکردنەکە بە ڕەزامەندی هەردوو لا دیاری بکرێت موڵکەکە ڕادەستی لایەنی یەکەم بکات، بەمەرجێک فرۆشیار تێچووی گواستنەوەکە بگرێتە ئەستۆ.",
    arabic: "",
    english: "",
  },
  // validastion
  {
    user_key: "Please fill out your card number.",
    kurdish: "تکایە ژمارەی کارت پڕبکەوە",
    arabic: "يرجى ملء رقم بطاقتك.",
    english: "Please fill out your card number.",
  },
  {
    user_key: "Please fill out the branch name",
    kurdish: "تکایە ناوی لق پڕبکەوە",
    arabic: "يرجى ملء اسم الفرع",
    english: "Please fill out the branch name",
  },
  {
    user_key: "Please fill the percentage.",
    kurdish: "تکایە ڕێژەی سەدی پڕبکەوە",
    arabic: "يرجى ملء النسبة المئوية.",
    english: "Please fill the percentage.",
  },
  {
    user_key: "Please fill out the mobile phone.",
    kurdish: "تکایە مۆبایل پڕبکەوە",
    arabic: "يرجى ملء الهاتف المحمول.",
    english: "Please fill out the mobile phone.",
  },
  {
    user_key: "Please fill the location",
    kurdish: "تکایە شوێن پڕبکەوە",
    arabic: "يرجى ملء الموقع",
    english: "Please fill the location",
  },
  {
    user_key: "Please fill out the salary",
    kurdish: "تکایە مووچە پڕبکەوە",
    arabic: "يرجى تعبئة الراتب",
    english: "Please fill out the salary",
  },
  {
    user_key: "Please fill out the password",
    kurdish: "تکایە وشەی نهێنی پڕبکەوە",
    arabic: "يرجى ملء كلمة المرور",
    english: "Please fill out the password",
  },
  {
    user_key: "Please fill out the password and Mobile Phone",
    kurdish: "تکایە وشەی نهێنی و ژمارەی مۆبایل پڕبکەوە",
    arabic: "يرجى ملء كلمة  المرور و الهاتف المحمول",
    english: "Please fill out the password Mobile Phone",
  },
  {
    user_key: "Please fill out the first name.",
    kurdish: "تکایە ناوی یەکەم پڕبکەوە",
    arabic: "يرجى ملء الاسم الأول.",
    english: "Please fill out the first name.",
  },
  {
    user_key: "Please fill out the second name.",
    kurdish: "تکایە ناوی دووەم پڕبکەوە",
    arabic: "يرجى ملء الاسم الثاني.",
    english: "Please fill out the second name.",
  },
  {
    user_key: "Reward and Punishment Form",
    kurdish: "فۆڕمی پاداشت و سزا",
    arabic: "نموذج الثواب والعقاب",
    english: "Reward and Punishment Form",
  },
  {
    user_key: "Add Form",
    kurdish: "زیادکردنی فۆڕم",
    arabic: "اضافە نموذج",
    english: "Add Form",
  },
  {
    user_key: "bonus",
    kurdish: "پاداشت",
    arabic: "الثواب",
    english: "bonus",
  },
  {
    user_key: "punish",
    kurdish: "سزا(غرامە)",
    arabic: "غرامە",
    english: "punish",
  },
  {
    user_key: "punish/bounes",
    kurdish: "پاداشت/سزا",
    arabic: "غرامە/الثواب",
    english: "punish/bounes",
  },
  {
    user_key: "Customer Detail",
    kurdish: "زانیاری کڕیار",
    arabic: "تفاصيل العميل",
    english: "Customer Detail",
  },
  {
    user_key: "Customer Detail List",
    kurdish: "لیستی زانیاری کڕیار",
    arabic: "قائمة تفاصيل العملاء",
    english: "Customer Detail List",
  },
  {
    user_key: "Min Price",
    kurdish: "کەمترین نرخ",
    arabic: "الحد الأدنى للسعر",
    english: "Min Price",
  },
  {
    user_key: "MAx Price",
    kurdish: "زۆرترین نرخ",
    arabic: "الحد الأقصى للسعر",
    english: "MAx Price",
  },
  {
    user_key: "Add Customer",
    kurdish: "زیادکردنی کڕیار",
    arabic: "إضافة عميل",
    english: "Add Customer",
  },
  {
    user_key: "Salary Payment Form",
    kurdish: "فۆڕمی پێدانی مووچە",
    arabic: "نموذج دفع الراتب",
    english: "Salary Payment Form",
  },
  {
    user_key: "Box Report",
    kurdish: "ڕاپۆرتی سندوق",
    arabic: " تقرير الصندوق",
    english: "Box Report",
  },
  {
    user_key: "Total Repayments in dollars and dinars",
    kurdish: "کۆی گشتی پارەوەرگرتنەکان بە دۆلار و دینار",
    arabic: " إجمالي التسديدات بالدولار والدينار",
    english: "Total Repayments in dollars and dinars",
  },
  {
    user_key: "Total payments in dollars and dinars",
    kurdish: "کۆی گشتی پارەپێدانەکان بە دۆلار و دینار",
    arabic: " إجمالي المدفوعات بالدولار والدينار",
    english: "Total payments in dollars and dinars",
  },
  {
    user_key: "Total expenses and monthly money",
    kurdish: "کۆی گشتی خەرجییەکان و پارەی مانگانە",
    arabic: " إجمالي المصروفات والنقود الشهرية",
    english: "Total expenses and monthly money",
  },
  {
    user_key: "The total amount of money that came out of the money",
    kurdish: "کۆی گشتی پارەی هاتوو پارەی دەرچوو",
    arabic: " المبلغ الإجمالي للمال الذي خرج من المال",
    english: "The total amount of money that came out of the money",
  },
  {
    user_key: "Total rewards and penalties",
    kurdish: "کۆی گشتی نسبەکان و پاداشت و سزاکان",
    arabic: " إجمالي المكافآت والعقوبات",
    english: "Total rewards and penalties",
  },
  {
    user_key: "Property Detail",
    kurdish: "زانیاری  موڵك",
    arabic: "معلومات عقار",
    english: "Property Information",
  },
  {
    user_key: "monthly payments",
    kurdish: "پارەی مانگانە",
    arabic: "مدفوعات شهرية",
    english: "Monthly Payments",
  },
  {
    user_key: "Recurrence",
    kurdish: "دووبارەبوونەوە",
    arabic: "تكرار",
    english: "Recurrence",
  },
  {
    user_key: "next Repayment",
    kurdish: "پارەوەرگرتنی داهاتوو",
    arabic: "التالي السداد",
    english: "next Repayment",
  },
  {
    user_key: "Contract Date",
    kurdish: "بەرواری گرێبەست",
    arabic: "تاريخ العقد",
    english: "Contract Date",
  },
  {
    user_key: "Day",
    kurdish: "ڕۆژ",
    arabic: "يوم",
    english: "Day",
  },
  {
    user_key: "Only",
    kurdish: " ، تەنها ",
    arabic: " فقط لا غير ,",
    english: ",Only",
  },
  {
    user_key: "Sale price",
    kurdish: "نرخی فرۆشتن",
    arabic: "سعر البيع",
    english: "Sale price",
  },
  {
    user_key: "Purchase Price",
    kurdish: "نرخی کڕین",
    arabic: "سعر الشراء",
    english: "Purchase Price",
  },
  {
    user_key: "buy_price",
    kurdish: "نرخی کڕین",
    arabic: "سعر الشراء",
    english: "Purchase Price",
  },
  {
    user_key: "Persentage Payment Form",
    kurdish: "فۆڕمی پێدانی نسبە",
    arabic: "نموذج دفع النصبة",
    english: "Persentage Payment Form",
  },
  {
    user_key: "Persentage Payment Form Agents",
    kurdish: "فۆڕمی پێدانی نسبە بە کارمەندەکان",
    arabic: "نموذج دفع النصبة",
    english: "Persentage Payment Form Agents",
  },
  {
    user_key: "Monthly Percentage",
    kurdish: "نسبەی مانگی",
    arabic: "النسبة الشهرية",
    english: "Monthly Percentage",
  },
  {
    user_key: "List of Cost Types",
    kurdish: "لیستی جۆرەکانی خەرجی",
    arabic: "قائمة أنواع التكاليف",
    english: "List of Cost Types",
  },
  {
    user_key: "Increase spending",
    kurdish: "زیادکردنی خەرجی",
    arabic: "زيادة الإنفاق",
    english: "Increase spending",
  },
  {
    user_key: "Specify your expenses.",
    kurdish: "خەرجیەکەت دیاریبکە",
    arabic: "حدد نفقاتك.",
    english: "Specify your expenses.",
  },
  {
    user_key: "expenses (Kurdish)",
    kurdish: "خەرجی (کوردی)",
    arabic: "النفقات (كردي)",
    english: "expenses (Kurdish)",
  },
  {
    user_key: "expenses (Arabic)",
    kurdish: "خەرجی (عربي)",
    arabic: "النفقات (عربي)",
    english: "expenses (Arabic)",
  },
  {
    user_key: "expenses (English)",
    kurdish: "خەرجی (ئینگلیزی)",
    arabic: "النفقات (إنجليزي)",
    english: "expenses (English)",
  },
  {
    user_key: "Update Cost",
    kurdish: "نویکردنەوەی خەرجی",
    arabic: "تحديث النفقات",
    english: "Update Cost",
  },
  {
    user_key: "User",
    kurdish: "بەکارهێنەر",
    arabic: "مستخدم",
    english: "User",
  },
  {
    user_key: "Does the money go into the box?",
    kurdish: "ئایا پارەکە بچێتە ناو سندوق",
    arabic: "هل يذهب المال إلى الصندوق؟",
    english: "Does the money go into the box?",
  },
  {
    user_key: "Is the money going to go out of the box؟",
    kurdish: "ئایا پارە بچێتە دەر لە سندوق",
    arabic: "هل سيخرج المال من الصندوق؟",
    english: "Is the money going to go out of the box؟",
  },
  {
    user_key: "Fast-selling contracts",
    kurdish: "گرێبەستی فرۆشتن خێرا",
    arabic: "عقود البيع السريع",
    english: "Fast-selling contracts",
  },
  {
    user_key: "Fast rental contracts",
    kurdish: "گرێبەستی کرێ خێرا",
    arabic: "عقود الإيجار السريعة",
    english: "Fast rental contracts",
  },
  {
    user_key: "Fast contracts",
    kurdish: "گرێبەستە خێراکان",
    arabic: "عقود سريعة",
    english: "Fast contracts",
  },
  {
    user_key: "Rejected",
    kurdish: "خێرا",
    arabic: "سريع",
    english: "fast",
  },
  {
    user_key: "type of contract",
    kurdish: "جۆری گرێبەست",
    arabic: "اختر نوع عقد",
    english: "type of contract",
  },
  {
    user_key: "Rejected",
    kurdish: "خێرا",
    arabic: "سريع",
    english: "fast",
  },
  {
    user_key: "off",
    kurdish: "نەخێر",
    arabic: "لا",
    english: "No",
  },
  {
    user_key: "on",
    kurdish: "بەڵێ",
    arabic: "نعم",
    english: "Yes",
  },
  {
    user_key: "Go to the box.",
    kurdish: "بچێتە سندوق",
    arabic: "اذهب إلى المربع",
    english: "Go to the box",
  },
  {
    user_key: "Get out of the box",
    kurdish: "بچێتە دەر لە سندوق",
    arabic: "اخرج من الصندوق",
    english: "Get out of the box",
  },
  {
    user_key: "Registration Property",
    kurdish: "داخیلکردنی موڵک",
    arabic: "تسجيل العقار",
    english: "Registration Property",
  },
  {
    user_key: "Applicant's name",
    kurdish: "ناوی داواکار",
    arabic: "اسم مقدم الطلب",
    english: "Applicant's name",
  },
  {
    user_key: "Employee General Report",
    kurdish: "ڕاپۆرتی گشتی کارمەند",
    arabic: "التقرير العام للموظف",
    english: "Employee General Report",
  },
  {
    user_key: "accountant",
    kurdish: "ژمێریار",
    arabic: "محاسب",
    english: "accountant",
  },
  {
    user_key: "archive",
    kurdish: "ئەرشیفەکان",
    arabic: "أرشيف",
    english: "archive",
  },
];
export default lang;
